import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}
/* eslint sonarjs/no-duplicate-string: 0 */


import { extendTheme } from "native-base";
import Platform from "react-native-web/dist/cjs/exports/Platform";
import baseTheme from "./base.theme"; // Define the config

var config = {
  colors: {
    primary: {
      100: "#86714D",
      200: Platform.OS === "web" ? "#B4292D" : "#A96F3E",
      300: "#DF4505",
      // TODO: replace this placeholder with appropriate color (this is for the focusring and hover to work)
      400: "#A96F3E",
      500: "#A96F3E",
      600: "#A96F3E"
    },
    secondary: {
      100: "#D7BA8A",
      200: "#A96F3E",
      300: "#86714D"
    },
    background: {
      100: "#F6F4E0",
      200: "#F6F3EF",
      300: "#DAD4D5",
      400: "#86714D"
    },
    indicatorBannerColors: {
      indicatorBannerColor_NI: "#C6653B",
      indicatorBannerColor_LT: "#a8b341",
      indicatorBannerColor_CSK_B: "#b3292d",
      indicatorBannerColor_Default: "#C6653B"
    },
    calendarCtaBorderRadius: 0,
    outletLocationRestText: "#86714D",
    viewMenuHover: "#86714D",
    orderOnlineHomeButton: "#A96F3E",
    startBgColor: "#86714d",
    circularAddBtn: "#B09C79",
    locationListBtn: "#86714d",
    bannerDropShadow: "#5F2C2D",
    confirmationModalOptionBg: "#867148",
    secondary200Mobile: Platform.OS === "web" ? "#A96F3E" : "#FFFFFF",
    asapOptionBg: "#F6F4E0",
    asapTextColor: "#404040",
    cartNumberText: "#ffff",
    themeErrorColor: "#F3D8DA",
    themeErrorTextColor: "#AF272F",
    themeTextFieldBoundary: "#DEDEDE",
    themeSectionSeparator: Platform.OS === "web" ? "#D6D6D6" : "#C7C0AA",
    themeSectionSeparatorDark: "#979797",
    listItemDivider: "transparent",
    locationCardBg: "#f6f3ef",
    themeSectionTextDark: Platform.OS === "web" ? "#000000" : "#3B3734",
    grey300: "#303030",
    selectedListItem: Platform.OS === "web" ? "#ded4c6" : "#F6F3EF",
    infoLinkColor: "#A96F3E",
    refreshIconColor: "#86714D",
    backLinkColor: "#D38232",
    tempSilderText: "#BA685C",
    selectTemperatureAccordian: "#F6F4E0",
    themeTextColor: "#020001",
    legalDesclaimerText: "#000000",
    categoryBoxTop: "#CFB59D",
    categoryBoxBottom: "#86714D",
    categoryBoxDivider: "#FFFFFF",
    firstCategoryBoxDivider: "transparent",
    themeGrey: "#606060",
    jwcLeaveTheLineModalHeadBg: "#D7D2CB",
    headerBackground: "#FFFFFF",
    hamburgerMenuBgColor: "#f0ece6",
    quantityArrowColor: "#86714d",
    backToMenu: "#3B3734",
    hStackArrowsBg: "#b09c79",
    textCTAColor: "#700000",
    selectedCarouselItemWithoutImage: Platform.OS === "web" ? "#ded4c6" : "#f6f3ef",
    unselectedCarouselItemWithoutImage: Platform.OS === "web" ? "#ded4c6" : "#f6f3ef",
    orderSettingsDivider: "#CFB59D",
    orderSettingsDividerMobile: "#CFB59D",
    timeDropDownBg: "#FFFFFF",
    modalLightBg: "#FFFFFF",
    modalDarkBg: "#f0ece6",
    orderSettingsBorder: "#CFB59D",
    modalTextColor: "#020001",
    checkoutButtonBackgroundColor: "#867148",
    themeDarkGrey: "#2E2A26",
    orderSettingsDateTimeChoiceColor: "#A96F3E",
    selectedOptionBorderColor: "#86714d",
    notSelectedOptionBorderColor: "#D6D6D6",
    menuDetailsMobileHeaderText: "#A96F3E",
    configOptionsAccordionBackground: "#867148",
    hStackArrowsColor: "#ffff",
    themeDisableButton: "#E5E5E5",
    orderConfirmationDivider: "#E5E5E5",
    popoverBg: "#F2EFEA",
    separatorLineColor: "#2A2C25",
    categoryHeaderSeparator: "#EAEAEA",
    btnHoverColor: "#7A502D",
    cartNoOfItemsText: "#867148",
    menuListTooltipBg: "#812F36",
    selectedMenuCategoryBorder: "#FFFFFF",
    menuListTooltipColor: "#FFFFFF",
    menuDetailTooltipBg: "#A96F3E",
    menuDetailTooltipColor: "#FFFFFF",
    cartItemPrice: "#867148",
    cartItemActionBtn: "#867148",
    cartPhoneNumber: "#867148",
    menuItemNameColor: "#2A2C25",
    legalTextContainerBg: "#EFEFEF",
    menuLinksColor: "#FFFFFF",
    deliveryModalHeadingColor: "#2A2C25",
    waitlistRestaurantInfoBoxText: "#54301A",
    deliveryModalBrandColor: "#A96F3E",
    deliveryModalNameColor: "#A96F3E",
    sliderItemColor: "#A96F3E",
    headerBackgroundTop: "#FFFFFF",
    menuButtonBackgroundColor: "#A96F3E",
    orderSettingsTextColor: "#86714D",
    categoriesText: "#FFFFFF",
    modalCategoriesText: Platform.OS === "web" ? "#86714d" : "#86714d",
    inActiveCategoriesText: "#FFFFFF",
    inActiveModalCategoriesText: "#000000",
    menuItemPriceColor: "#020001",
    menuItemCalorieColor: "#020001",
    scrollToTopColor: "#86714d",
    menuItemAddButtonColor: "#86714d ",
    menuItemCardBg: "#f6f3ef",
    cartHeaderOrderType: "#3B3734",
    cartHeaderLocationName: "#867148",
    itemAddToCartPopupBackground: "#867148",
    sliderWithButtonsBackground: "#FFFFFFE5",
    recommendationHeadingColor: "#606060",
    menuDetailAccordionDownArrowColor: Platform.OS === "web" ? "#ffffff" : "#fff",
    menuDetailAccordionTextColor: Platform.OS === "web" ? "#ffffff" : "#fff",
    menuDetailsAccordionDetailsBackground: "#F6F4E0",
    // transparent
    menuDetailsAccordionDetailsBackgroundNotDefaultExpanded: "#FFFFFF",
    menuDetailModifyOrRemoveColor: "#000",
    menuDetailTemparatureSliderLabelColor: "#404040",
    menuDetailItemNameColor: "#000000",
    legalDisclaimerText: "#3B3734",
    menuDetailsItemPriceColor: "#000000",
    menuDetailsItemDescriptionColor: "#2A2C25",
    menuDetailsItemCaloriesCaolor: "#2A2C25",
    menuDetailsModifiersBorderColor: Platform.OS === "web" ? "#86714d" : "#86714d",
    menuDetailsSliderItemBackground: "#EBE9E9",
    menuDetailsSliderHoverColor: "#A96F3E",
    menuDetailsBackToMenu: "#86714D",
    loginModalTextColor: "#A96F3E",
    requiredTextColor: "#A96F3E",
    recommendationaInfoTextColor: "#404040",
    reoderInfoTextColor: "#404040",
    reorderHeadingsText: "#404040",
    nutritionalHTMLColor: "#020001",
    orderConfirmationTextColor: "#FFFFFF",
    locationListingItemHeading: "#303030",
    mobilePayNotYourCheckTextColor: "#606060",
    mobilePayReachOutSubTextColor: "#782434",
    locationListingItemHeadingMobile: "#86714D",
    locationListingItemText: "#020001",
    confirmPickupDetailsText: "#2D2926",
    addressTextColor: "#000000",
    itemIsFor: "#606060",
    itemIsForName: "#2A2C25",
    cartItemTitle: "#3B3734",
    specialInstructions: "#2A2C25",
    plusIconColor: "#A96F3E",
    cartItemOption: "#3B3734",
    ninjaIconColor: "#A96F3E",
    locationsNear: "black",
    searchResultsName: "#303030",
    locationConfirmationHeadings: "#A96F3E",
    emptyCartHeaderBgColor: "#ded4c6",
    orderSettingsDesktop: "#86714D",
    orderSettingsMobile: "#86714D",
    previousOrderItemStatus: "#A96F3E",
    mobileGetStartedButtonColor: "#FFFFFF",
    mobileAppAuthBg: Platform.OS === "web" ? "white" : "#DED4C6",
    myReservationsBoxBg: "#f6f3ef",
    smartRecommendationCardbg: "#f6f3ef",
    mobileAuthOrDividerBorderColor: Platform.OS === "web" ? "#CDCFD5" : "#C7C0AA",
    mobileAuthOrTextColor: "#737373",
    mobileAuthFooterPassiveText: "#808080",
    reOrderAddBtnBorder: "#A96F3E",
    mobileAuthFooterActiveText: "#cb7034",
    mobileAuthTransparentBg: "rgba(0, 0, 0, 0.7)",
    accordionDescription: "#FFFFFF",
    mobileCriticalModeHeding: "#606060",
    mobileCriticalModeText: "#959595",
    mobileCreateAccountDetailsSectionBackgroundColor: Platform.OS === "web" ? "#FFFFFF" : "#F1ECE6",
    mobileCreateAccountButtonTextColor: "#FFFFFF",
    mobileCreateAccountLegalNoticesColor: "#cb7034",
    skuUnavaliableTextColor: "#A2402B",
    mobileCriticalModeBg: "#E5E5E5",
    mobileForgotPasswordHeding: "#606060",
    linearGradientTransparent: "rgba(255,255,255,0)",
    linearGradientWhite: " rgba(255,255,255,1)",
    linearGradientCardDarkShade: "rgba(54, 26, 5, 0.84)",
    linearGradientCardLightShade: "rgba(54, 26, 5, 0.44)",
    linearGradientCardTransparent: "rgba(35,34,30,0)",
    linearGradientHeaderDark: Platform.OS === "web" ? "#6F3D31" : "#000",
    linearGradientHeaderLight: "rgba(104, 61, 51, 0.05)",
    ratingCardTitle: "#2A2C25",
    ratingCardSubheaderText: "#606060",
    ratingCardBodyHeader: "#606060",
    ratingCardTextAreaBorderColor: "F3F4EA",
    ratingCardTextAreaWordCount: "rgba(0, 0, 0, 0.4)",
    ratingCardSubmitButton: "#A96F3E",
    ratingCardSubmitButtonText: "#FFFFFF",
    ratingCardDismissButtonText: "#808080",
    mobileForgotPasswordHeading: "#606060",
    mobileResetPasswordText: "#606060",
    mobileCustomBrandModalBg: "#F8F7F6",
    lunchIssueModalBody: "#ECE4CA",
    lunchIssueModalSeparator: "#D2C7A3",
    unavailablePriceTextColor: "#7E7C77",
    restaurantDetailsDataText: "#303030",
    mobileHeaderBg: "rgba(255, 255, 255, 0.9)",
    routerNavigationHeaderColor: "rgba(0, 0, 0, 0.7)",
    displayImageFallbackBackground: Platform.OS === "web" ? "#C6C6C6" : "#DED4C6",
    mobileOrderDetailsBanner: Platform.OS === "web" ? "#F5F7E8" : "#F6F4E0",
    mobileOrderDetailsDisabledButton: "#C6C6C6",
    mobileOrderDetailsBg: Platform.OS === "web" ? "white" : "#ECE4CA",
    locationModalHeadingColor: "#2A2C25",
    locationModalBodyDataColor: "#808080",
    locationModalDividerColor: "#C6C6C6",
    restaurantsTimingDetails: "#606060",
    restaurantLabelColor: "#606060",
    joinWaitlistColor: "#CA7C30",
    disableJoinWaitlistColor: "#C6C6C6",
    waitlistHeaderAddressHeaderBorder: "#D6D6D6",
    globalBannerBg: "#131313",
    mobileSelectedVehicleTypeBg: "#F4F4F4",
    mobileSliderSeparator: "#BEBEBE",
    locationInfographicModalTextColor: "#606060",
    locationInfographicModalActionButtonTextColor: "#FFFFFF",
    inputPlaceholderTextColor: "#303030",
    restaurantInfoNumberAndDistanceTextColor: "#86714D",
    restaurantDetailsHeaderBackground: "#FFFFFF",
    amenitiesHeadingColor: "#2A2C25",
    amenitiesDividerColor: "rgba(0,0,0,0.2)",
    amenitiesActionButtonsColor: "#86714D",
    currentStatusAndWaitlistDividerColor: "rgba(0,0,0,0.1)",
    restaurantWaitlistTextColor: "#606060",
    joinWaitlistButtonColor: "#CA7C30",
    orderFromHereButtonTextColor: Platform.OS === "web" ? "#86714D" : "#FFFFFF",
    restaurantAboutSectionHeadingTextColor: "#2A2C25",
    restaurantAboutSectionBodyTextColor: "#303030",
    restaurantImageBorderColor: "#FFFFFF",
    restaurantNumberAndDistanceDividerColor: "rgba(0,0,0,0.20)",
    restaurantHoursTextColor: "#2A2C25",
    restaurantSpecialDayHeadingTextColor: "#404040",
    restaurantSpecialDayBodyTextColor: "#606060",
    restaurantTimingsHeadingTextColor: "#86714D",
    restaurantTimingsDividerColor: "rgba(0,0,0,0.1)",
    restaurantDetailsSeparatorDividerColor: "rgba(0,0,0,0.1)",
    restaurantTimingsTextColor: "#303030",
    locationTabNavigationNotFocusedTabText: "#282728",
    locationInfographicLoginBackgroundColor: "#ffffff",
    locationOverlayMyLocationsTitles: "#303030",
    locationOverlayMyLocationsScrollView: "#FFFFFF",
    locationOverlaySelectLocationColor: "#2A2C25",
    noRecentLocationsTextColor: "#606060",
    searchThisAreaText: "#FFFFFF",
    selectedWeekDayColor: "#223E6A",
    notSelectedWeekDayColor: "#FFFFFF",
    weekDayBorderColor: "#86714D",
    currentWeekDayIndicator: "#49909B",
    mobileScrollableMenuTab: "#F8F8F8",
    orderConfirmationBackground: "#ffffff",
    podBackground: "#f6f3ef",
    orderConfirmationThanksSubHeaderColor: "#505050",
    orderConfirmationCustomerEmail: "#303030",
    pickupRestaurantTitle: "#737373",
    pickupRestaurantName: "#303030",
    pickupRestaurantAddress: "#606060",
    errorModalHeaderBg: Platform.OS === "web" ? "#eee4c7" : "#faf3de",
    pickMyOrderCardTitle: "#303030",
    specialInstArrowColor: "black",
    pickUpMyOrderHStackText: "#303030",
    bottomSheetTitleColor: "#303030",
    errorModalBackgroundColor: "rgba(29, 26, 26, 0.88)",
    errorModalTitleColor: "#2A2C25",
    errorModalSubTitleTextColor: "#606060",
    errorModalOKButtonTextColor: "#FFFFFF",
    addCardModalValidWarningTextColor: "#D30000",
    cardExpiredColor: "#D51010",
    saveCardCheckbox: "#737373",
    saveCardAddButtonTextColor: "#FFFFFF",
    enterCVVSubTitle: "#606060",
    enterCVVPlaceholderText: "#606060",
    enterCVVTooltipBgColor: "#e3e3e3",
    enterCVVValidWarningTextColor: "#D30000",
    enterCVVConfirmButtonDisabledColor: "#C6C6C6",
    enterCVVConfirmButtonTextColor: "#FFFFFF",
    mobilePaymentMethodIconBg: Platform.OS === "web" ? "#F6F6F6" : "#ECE3CA",
    mobilePaymentsCardTextColor: "white",
    mobileGiftCardGradientFirst: "rgba(166,148,116,1)",
    mobileGiftCardGradientSecond: "rgba(134,113,77,1)",
    myAccountGiftCardLargeBorderRadius: 0,
    mobileMasterCardGradientFirst: "#1C338F",
    mobileMasterCardGradientSecond: "#214792",
    mobileVisaGradientFirst: "#0B765C",
    mobileVisaGradientSecond: "#0B765C",
    mobileVisaGradientThird: "#13770B",
    mobilePaymentMethodAssistTextColor: "#808080",
    mobileCouponInputPlaceholderColor: "#C7C0C0",
    mobilePaymentsScreenBg: "#FFFFFF",
    addGiftCardBottomSheetBackdropColor: "rgba(29, 26, 26, 0.88)",
    enterCVVBottomSheetBackdropColor: "rgba(29, 26, 26, 0.88)",
    addCreditDebitCardTooltipBgColor: "#e3e3e3",
    yourOrderTitle: "#303030",
    orderDescriptionItem: "#2A2C25",
    orderTotalTitle: "#A96F3E",
    pickupDetailsTitle: "#303030",
    carSideStackTitle: "#606060",
    cardCreateAnAccountHeading: "#303030",
    downArrowColor: Platform.OS === "web" ? "#EDE3C7" : "#3B3734",
    categoryNavBgColor: "#86714D",
    takeSurveyText: "#606060",
    joinEClubTitle: "#303030",
    joinEClubTickScheme: "#A8AD00",
    mobileGiftVoucherGiftText: "#E7A227",
    mobileGiftVoucherVoucherIDText: "#C6C6C6",
    mobileGiftVoucherValueFirstGrad: "#F6C551",
    mobileGiftVoucherValueSecondGrad: "#B15801",
    mobileGiftVoucherBoxFirstGrad: "#423F3F",
    mobileGiftVoucherBoxSecondGrad: "#5F5852",
    mobileGiftCardNormalText: "white",
    wailistHomeScreenBannerGradientOne: "#BF7D3F",
    waitlistHomeScreenBannerGradientTwo: "#964631",
    waitlistHomeScreenBannerText: "#FFFFFF",
    waitlistBannerCircleOuterBorder: "rgba(255,255,255,0.2)",
    waitlistBannerFooterText: "#303030",
    waitlistPositionBackground: "#F3F4E7",
    waitlistPositionBorderTwo: "rgba(159, 167, 58, 0.1)",
    waitlistPositionBorderOne: "rgba(159, 167, 58, 0.2)",
    waitlistPositionInnerBorder: "#9FA73A",
    waitlistPositionCircleBackgroundColor: "#FFFFFF",
    howMobilePayWorksModalBg: "rgba(0,0,0,0.6)",
    waitlistPositionSubTitle: "#606060",
    waitlistPositionButtonBackground: "#FFFFFF",
    waitlistPositionSubTextColor: "#303030",
    waitlistSubCardsVerticalDivider: "#F6F6F6",
    waitlistDetailsSwiperText: "#FFFFFF",
    waitlistSwiperNavigationButtonBorderColor: "#FFFFFF",
    waitlistSwiperNavigationButtonBackgroundColor: "#FFFFFF",
    seasonFavouriteTitleText: "#FFFFFF",
    seasonFavouritesHeadingDivider: "#4D4D4D",
    waitlistMapSectionBorder: "#DCDCDC",
    waitlistMapSectionButtonBackground: "#FFFFFF",
    orderInfoBg: "#f6f3ef",
    specialInstInputBg: "#f6f3ef",
    waitlistDetailsOrderbuttonText: "#FFFFFF",
    waitlistPositionHeadingText: "#2A2C25",
    waitlistDetailsScreenBackground: "#FFFFFF",
    waitlistBannerCircleBackgroundColor: "#FFFFFF",
    mobileCategoryNavigationBg: "#F8F8F8",
    mobileOrderSummaryBackground: "#F6F6F6",
    mobileOrderSummaryHeaderText: "#303030",
    mobileOrderSummaryDishQuantity: "#2A2C25",
    mobileOrderSummaryOtherInstructions: "#606060",
    mobileOrderSummaryOrderTotalDetailsItem: "#000000",
    mobileOrderSummaryOrderTotalDetailsItemCoupon: "#CA7C30",
    mobileOrderSummaryPaidByColor: "#303030",
    youMightLikeBannerColor: "#A96F3E",
    defaultMenuBannerBg: Platform.OS === "web" ? "#2f2f2f" : "#1F1F1F",
    newIndicatorBannerColor: "#C6653B",
    myAccountSubTextColor: "#606060",
    myAccountScreenBackroundColor: Platform.OS === "web" ? "#FFFFFF" : "#F0ECE6",
    myAccountScreenMobileBackgroundColor: "#F0ECE6",
    myAccountScreenWebBackgroundColor: "#fff",
    menuItemCardBorder: "transparent",
    myAccountScreenUserInfoTextColor: "#606060",
    myAccountCardShadow: "rgba(0, 0, 0, 0.2)",
    myAccountCardBackground: Platform.OS === "web" ? "#FFFFFF" : "#FFFFFF",
    ProfilePictureCircleBorderColor: "#fff",
    mobileOrderSettingsOptionStackBorderColor: "#DEDEDE",
    orderSettingsPickupDetails: "#2A2C25",
    orderSettingsBackdrop: "rgba(0, 0, 0, 0.7)",
    curbsideHomeScreenBannerGradientOne: Platform.OS === "web" ? "#BF7D3F" : "#A96F3E",
    curbsideHomeScreenBannerGradientTwo: Platform.OS === "web" ? "#964631" : "#A96F3E",
    curbsideHomeScreenBannerText: "#523020",
    curbsideDetailsBackground: "#F3F4E7",
    curbsidePickupScreenBackground: "#FFFFFF",
    curbsidePickupScreenDetailsBackground: "#F2F4E6",
    curbsidePickupScreenDetailsDivider: "#DCDCDC",
    curbsidePickupScreenBannerText: "#523020",
    curbsidePickupScreenDetailsSubText: "#303030",
    curbsidePickupScreenDetailsIconsBackground: "#F6F6F6",
    curbsidePickupScreenDetailsEditButtonText: "#993324",
    viewDirectionButtonTextColor: "#FFFFFF",
    restaurantLocationBottomSheetBackdropColor: "rgba(0,0,0,0.6)",
    modalHeaderBackgroundColor: "rgba(0, 0, 0, 0.7)",
    restuarantLocationBottomSheetLocationText: "#606060",
    addGiftCardHeaderTextColor: "#2A2C25",
    mobileOrderHistoryBackgroundColor: Platform.OS === "web" ? "#F6F6F6" : "#ECE4CA",
    mobileOrderHistoryItemCardHeaderBackgroundColor: Platform.OS === "web" ? "#F1ECE6" : "#F6F4E0",
    orderHistoryItemDividerColor: "#C6C6C6",
    orderHistoryReorder: Platform.OS === "web" ? "#993324" : "#FFF",
    orderHistoryDetailsText: "#303030",
    orderHistoryOrderFrom: "#808080",
    orderHistoryDetailsAddress: "#606060",
    orderHistoryDetailsBGColor: Platform.OS === "web" ? "#F1ECE6" : "#ECE3CA",
    searchBarBackground: "#FFFFFF",
    addCardFooterButtonText: "#FFFFFF",
    homeScreenBackgroundColor: Platform.OS === "web" ? "#F6F6F6" : "#FFFFFF",
    homeScreenOrderNowButtonTextColor: "#FFFFFF",
    restCallNowCTATextColor: "#FFFFFF",
    homeScreenHeaderIconColors: "#FFFFFF",
    homeScreenLoginBorderColor: "#FFFFFF",
    homeScreenCardButtonTextColor: "#FFFFFF",
    homeScreenCardButtonBorderColor: Platform.OS === "web" ? "#FFFFFF" : "#FBFBFB",
    homeScreenCardTextColor: "#FFFFFF",
    myAccountCartAmountTextBorderColor: "#FFFFFF",
    myAccountCartAmountTextColor: "#FFFFFF",
    selectPreferredLocationBackgroundColor: "#FFFFFF",
    outletLocationItemIconText: "#FFFFFF",
    outletLocationItemButtonText: "#FFFFFF",
    mobileBg: "#FFFFFF",
    profileScreenMainModalBackgroundColor: "#F6F3EF",
    showCreditCard_bottomSheet_BackgroundColor: "#FFFFFF",
    addEditCreditCard_scrollView_backgroundColor: "#FFFFFF",
    HomeScreenlinearGradientBackgroundColor: Platform.OS === "web" ? "#F6F6F6" : "#FFFFFF",
    homeScreenRecentOrdersListItemSubTextColor: "#606060",
    homeScreenRecentOrdersListItemDividerColor: "#C6C6C6",
    homeScreenRecentOrdersListItembackgroundColor: Platform.OS === "web" ? "#FFFFFF" : "#F6F4E0",
    homeScreenRecentOrdersListItemButtonTextColor: "#FFFFFF",
    addCardPlaceholderTextColor: "#606060",
    addCardCheckboxTextColor: "#606060",
    mobileReorderBg: Platform.OS === "web" ? "#F8F8F8" : "#ECE4CA",
    changePasswordBackgroundColor: "#FFFFFF",
    googleSocialSignInBGColor: "#FFFFFF",
    facebookSocialSignInBGColor: "#1877F2",
    appleSocialSignInBGColor: "#000000",
    socialAuthBorderColor: "#DEDEDE",
    createAccountPreferredLocationBGColor: Platform.OS === "web" ? "#F8F7F6" : "#F6F4E0",
    cartScreenBackgroundColor: Platform.OS === "web" ? "#FFFFFF" : "#FFFFFF",
    orderLimitReacherModalBackdrop: "rgba(0,0,0,0.7)",
    cartHeaderPressableColor: "#F6F6F6",
    securityQuestionContainer: Platform.OS === "web" ? "#ffffff" : "#ECE3CA",
    securityQuestionMenuColor: "#C6c6c6",
    securityQuestionTextColor: "#606060",
    createAccountBackgroundColor: Platform.OS === "web" ? "#FFFFFF" : "#ECE3CA",
    createAccountScreenTextColor: "#303030",
    createAccountZipCodeBorderColor: "#DCDCDC",
    createAccountZipCodeLabelColor: "#808080",
    settingScreenBg: Platform.OS === "web" ? "#F8F8F8" : "#ECE3CA",
    settingListItemShadow: "rgba(0,0,0,0.5)",
    frequentlyOrderedItemBackground: Platform.OS === "web" ? "#FFFFFF" : "#F6F4E0",
    frequentlyOrderedItemSubText: "#505050",
    giftCardBalanceColor: "#606060",
    homescreenPromoBackdrop: "rgba(0, 0, 0, 0.6)",
    fullHomescreenPromoBg: "#F8F7F6",
    paymentScreenImportantTextDescription: "#808080",
    curbsideBannerTagColor: "#FFFFFF",
    guestFavoritesBackgroundColor: "#F6F6F6",
    guestFavouritePopOverBGColor: "#F3F4E7",
    guestPopoverBackdropColor: "rgba(0,0,0,0.7)",
    locationListItemBorder: "transparent",
    allLocationsSelectBgMobile: "#f6f3ef",
    allLocationsSelectBgDesktop: "#f6f3ef",
    locationDropdownBg: "#DED4C6",
    allLocationsSelectBorderColorMobile: "#DED4C6",
    allLocationsSelectBorderColorDesktop: "#DED4C6",
    allLocationsItemBoxBorderColor: "#DEDEDE",
    allLocationsBodyBgMobile: "#ffffff",
    allLocationsBodyBgDesktop: "#ffffff",
    allLocationsSelectBorderColor: "#DED4C6",
    confirmPickupDetailsChangeBtnBorder: "#86714d",
    checkoutBorderColor: "transparent",
    categoriesHeadingColor: "#020001",
    categoriesDescriptionColor: "#020001",
    itemUnavailableCardBg: "#DED4C6",
    configOptionBg: "white",
    itemCardBg: "#F6F3EF",
    itemCardBgLight: "#F6F3EF",
    // ORDER CONFIRMATION START
    confirmationPrimary: "#86714d",
    confirmationSecondary: "#303030",
    confirmationAccent: "#2A2C25",
    confirmationAccentLight: "#666666",
    confirmationAccentDark: "#303030",
    confirmationCheckbox: "#A96F3E",
    confirmationThemeDark: "#000000",
    confirmationThemeLight: "#EEEEEE",
    confirmationThemeGrey: "#B0B0B0",
    confirmationSpecialInstructionsBg: "#faf3de",
    // ORDER CONFIRMATION END
    bodyBg: Platform.OS === "web" ? "#FFFFFF" : "#FFFFFF",
    quickAddModalBg: "#eee4c7",
    categoriesPopupInactive: "#DFD3B1",
    categoriesPopupBg: "white",
    cardColor: "#F6F4E0",
    menuInfoBackgroundMobile: "#F6F3EF",
    menuInfoBackgroundDesktop: "#F6F3EF",
    selectedSKUItem: Platform.OS === "web" ? "#ded4c6" : "#F6F3EF",
    nonSelectedSkuItem: Platform.OS === "web" ? "#ded4c6" : "#F6F3EF",
    nonSelectedListItem: Platform.OS === "web" ? "#ded4c6" : "#F6F3EF",
    selectedListItemWithImage: Platform.OS === "web" ? "#ded4c6" : "#F6F3EF",
    nonExpandedAccordionBackground: Platform.OS === "web" ? "#86714d" : "#86714d",
    selectedDescriptionText: "#020001",
    carouselBorderColor: "#D6D6D6",
    signInTextColor: "#020001",
    registerTextColor: "#020001",
    recommendationsHeadingColor: "#020001",
    capacityInfoText: "#000000",
    selectedStateColor: "#000000",
    quantityColor: "#020001",
    timeDropdownColor: "#000000",
    searchKeywordHighlightColor: "#A2402A",
    restaurantInfoAddressTextColor: "#86714D",

    /* Restaurant Details */
    restaurantDetailsBGColor: Platform.OS === "web" ? "white" : "#ECE3CA",
    restaurantDetailsDividerColor: "rgba(0,0,0,0.2)",
    restaurantDetailsAboutSectionDividerColor: "rgba(0,0,0,0)",
    restaurantDetailsMobilePoliteNoticeDividerBg: "rgba(0,0,0,0.2)",
    restDetailsAmenitiesDividerMobileColor: "rgba(0,0,0,0.2)",
    restDetailsAmenitiesDividerColor: "transparent",
    restaurantDetailsJoinWaitlistButtonTextColor: "#A96F3E",
    restaurantDetailsJoinWaitlistButtonBorderColor: "#A96F3E",
    restaurantDetailsJoinWaitlistButtonLargeTextColor: "white",
    restaurantDetailsDisableJoinWaitlistTextColor: "#C6C6C6",
    restaurantDetailsDisableJoinWaitlistButtonBorderColor: "#C6C6C6",
    restaurantDetailsCurrentStatusAndWaitlistDividerColor: "rgba(0,0,0,0.1)",
    restaurantDetailsRestInfoBoxBackgroundColor: "#FFFFFF",
    restaurantDetailsRestInfoLgDividerBackgroundColor: "#0000004D",
    restaurantDetailsSelectedWeekDayColor: "#86714D",
    restaurantDetailsNotSelectedWeekDayTextColor: "#000000",
    restaurantDetailsNotSelectedWeekDayColor: "#FFFFFF",
    restaurantDetailsCurrentWeekDayIndicator: "#49909B",
    restaurantTimingWeekDayTextColor: "#86714D",
    restaurantDetailsAmenetiesbgColor: "#FFFFFF",
    waitlistBannerBg: "#A8AD00",
    waitlistTableHeaderBg: "#F8F8F8",
    waitlistBottomBackground: "#F3F4EA",
    selectedWaitlistRow: "#F3F4EA",
    waitlistFooterBorderTop: "#393939",
    howItWorksBannerBg: "#9FA73A",
    howItWorksHeaderBg: "#F3EFEB",
    waitlistDisclaimer: "#231815",
    restDetailsRestInfoTitleColor: "#4E311D",
    politeNoticeBoxBg: "#F6F3EF",
    politeNoticeBoxBgMobile: "#F6F3EF",
    scrollToTopBgColor: "#FFFFFF",
    scrollToTopBgColorMobile: "#FFFFFF",

    /* Restaurant Details end*/
    //Menu search
    suggestedSearchTextColor: Platform.OS === "web" ? "#FFFFFF" : "#ffffff",
    noResultFoundMenuSearchBg: "#f6f3ef",
    searchModalBackgroundColor: "#ffffff",
    menuSearchModalDivider: "#ABABAB",
    inputFieldBackgroundColor: Platform.OS === "web" ? "#f6f3ef" : "#f6f3ef",
    searchCardCategorySlugColor: "grey",
    searchModalCategoryListBg: "#f6f3ef",
    searchIconContainerBgColor: "#DFD3B1",
    mobilePayUserLoginBackground: "#FFFFFF",
    mobilePayUserLoginButtonTextColor: "#FFFFFF",
    mobilePayBodyTextColor: "#606060",
    searchBarBorderColor: "#86714d",
    menuLinearGradientStartColor: Platform.OS === "web" ? "#F8F8F8" : "#86714D",
    menuLinearGradientEndColor: Platform.OS === "web" ? "#F8F8F8" : "#86714D",
    paymentOrderTotalTextColor: "#000000",
    mobilePayHeaderBtnBorder: "#A96F3E",
    keyboardDoneButtonBgColor: "#FBFBFB",
    keyboardDoneButtonColor: "#2c7aff",
    profileHeaderLinearGradientStartColor: Platform.OS === "web" ? "#A1784D" : "#86714d",
    profileHeaderLinearGradientEndColor: Platform.OS === "web" ? "#6A4A27" : "#86714d",
    profileAddCardButtonText: "#FFFFFF",
    weekDayStartColor: "#223E6A",
    weekDayEndColor: "#223E6A",
    mobilePayConfirmationScreenBlockBG: "#FAF3DF",
    reservationCarouselActiveDotColor: "#DDC274",
    reservationCarouselInactiveDotColor: "#D5D8DA",
    reservationBorderColor: "#86714D",
    reservationButtonBGDisabled: "#CBD1D6",
    reservationSelectedCTABorderColor: "#86714D",
    reservationUnSelectedCTABorderColor: "transparent",
    reservationSelectedCTABGColor: "#F6F3EF",
    reservationUnSelectedCTABGColor: "#F6F3EF",
    reservationPopupBgColor: "#F6F3EF",
    locationsTopTabsContainerColor: "#F0ECE6",
    searchItemCardTextColor: "#000000",
    noResultTextColor: Platform.OS === "web" ? "#86714d" : "#86714d",
    menuSearchBarContainerBg: "#ded4c6",
    searchItemBreadCrumbSlugcolor: "#000000",
    preferredLocationHeaderBg: Platform.OS === "web" ? "#FFFFFF" : "#020001",
    preferredLocationHeaderTextColor: "#000000",
    scrollingNavigationFlatlistStartingGradientStartColor: Platform.OS === "web" ? "#f8f8f8" : "transparent",
    scrollingNavigationFlatlistStartingGradientEndColor: Platform.OS === "web" ? "rgba(248, 248, 248, 0)" : "transparent",
    menuSearchModalCloseIconBg: "#FFFFFF",

    /* Order Tracking start*/
    orderStatusText: "#3B3734",
    orderStatusCircleBg: "#A96F3E",
    locaionAndTimeHeaderBg: "#FAF3DF",
    locaionAndTimeHeaderBorder: "#A96F3E",
    borderColorCallSection: "#DCDCDC",
    payNowButtonBg: "#A96F3E",
    curbsideCheckInPrimary: "#FFFFFF",
    curbsideCheckInSecondary: "#A96F3E",
    orderStatusSectionBg: "#FAF3DF",
    refreshButtonColor: "#9F4E43",
    checkText: "#3B3734",
    curbsideCheckInAvailable: "#7C7C7C",
    orderStatusSectionBorderColor: "#A96F3E",
    refreshButtonBg: "#FFFFFF",

    /* Order Tracking end*/
    waitlistVisibilityAddressBoxArrow: "#54301A",
    howItWorksText: "#C16436",
    imageStackBorderColor: "#FFFFFF",
    defaultCardColor: "#rgba(255, 255, 255, 0.3)",
    defaultCardTextColor: "#FFFFFF",
    mobilePayBringYourCardArea: "#D6DCD2",
    mobilePayCheckArea: "#F2F2F2",
    mobilePayCallInCheckDivider: "rgba(0, 0, 0, 0.1)",
    mobilePaySkeletonColor: "#DCDCDC",
    noOfGuestsLabelColor: "#808080",
    mobilePayCheckCloseBackgroundColor: "#F4F4F4",
    mobilePayCheckDividerColor: "rgba(0, 0, 0, 0.4)",
    mobilePayCheckBackground: "#FFFFFF",
    homescreenLocationTagBGColor: Platform.OS === "web" ? "rgba(255, 255, 255, 0.68)" : "rgba(18, 7, 8, 0.68)",
    homescreenLocationTagBorderColor: Platform.OS === "web" ? "#C16436" : "#827070",
    homescreenLocationTextColor: Platform.OS === "web" ? "#303030" : "#FFFFFF",
    homeScreenAlertBackgroundGradientOne: "#BE6336",
    homeScreenAlertBackgroundGradientTwo: "#4E332B",
    // location Search Token
    locationSearchTitle: "#303030",
    locationSearchSubTitle: "#020001",
    locationSearchActiveTab: "#86714D",
    searchThisAreaBg: "#A96F3E",
    locationSearchInActiveTab: "#282728",
    searchCurrentLocation: "#A2402A",
    registerLsBtn: "#86714d",
    allLocationsLsBg: "#F6F3EF",
    callRestLsText: "#A96F3E",
    mobilePayICheckError: "#3F3C3C",
    locationSearchTabDivider: "#DED4C6",
    lsAllLocationsSelectBorder: "#DED4C6",
    allLocationsLSPageBg: "#FFFFFF",
    locationSearchAddressColor: "#000000",
    locationSearchTabBgColor: "#F0ECE6",
    allLocationsPageItemBoxBorderColor: "#DEDEDE",
    locationsSearchPageLocationListItemBgColor: "#F6F3EF",
    locationListingItemHeadingInPage: "#86714D",
    lsMyLocationsTabContentDivider: "#0000001a",
    hoursInfoAccordionIcon: "#A96F3E",
    hoursInfoAccordionTitle: "#A96F3E",
    joinWaitlistBtnHover: "white",
    joinWaitlistBtnTextHover: "#CA7C30",
    newLoctionsLinkText: "white",
    profileHeaderBackground: "#A8AD00",
    locationTopTabColor: "#86714D",
    remoteCheckinWaitTimeBg: "#F3F4EA",
    remoteCheckinWaitTimeBorderTwo: "rgba(159, 167, 58, 0.1)",
    remoteCheckinWaitTimeBorderOne: "rgba(159, 167, 58, 0.2)",
    remoteCheckinWaitTimeInnerBorder: "rgba(159, 167, 58, 1)",
    remoteCheckinWaitTimeCircleBg: "#FFFFFF",
    remoteCheckinWaitTimeHeaderText: "#452D20",
    remoteCheckinWaitTimeText: "rgba(159, 167, 58, 1)",
    remoteCheckinWaitTime: "rgba(96, 96, 96, 1)",
    remoteCheckinRefreshBtnColor: "#A2402A",
    remoteCheckinRefreshBtnBg: "#FFFFFF",
    remoteCheckinPartySizeText: "#54301A",
    wcacSecondaryBtnBorder: "#A2402A",
    checkbackSoonBgImgOverlayColor: "#F3F4EA",
    onboardingButtonTextColor: "#FFFFFF",
    restDetailsName: "#54301A",
    mobileMasterCardGradientThird: Platform.OS ? "#255F95" : "#5A1F21",
    mobileDiscoverGradientFirst: "#95989F",
    mobileDiscoverGradientSecond: "#D1D5D8",
    mobileDiscoverGradientThird: "#93969B",
    mobileAmericanExpressGradientFirst: "#1B1B1D",
    mobileAmericanExpressGradientSecond: "#5E5E62",
    mobileAmericanExpressGradientThird: "#1E1E20",
    mobileJcbCardGradientFirst: "#001741",
    mobileJcbCardGradientSecond: "#195182",
    mobileJcbCardGradientThird: "#2B3E7F",
    defaultMenuTextColor: "#F6F4E0",
    editProfileScreensBackgroundColor: "#F1ECE6",
    jwcBgColor: "#F2F4EA",
    jwcOrderAheadImgOverlayShade: "rgba(0, 0, 0, 0)",
    jwxLeaveTheLineCancelBtnBorder: "#A2402A",
    mobileDividerColor: "rgba(0,0,0,0.5)",
    mobilePayBgColor: "#FFFFFF",
    mobilePayDividerColor: "#C6C6C6",
    mobilePayDividerTextColor: "#808080",
    mobilePayWorksHeaderTextColor: "#404040",
    mobilePayWorksListItemBgColor: "#F6F6F6",
    mobilePayWorksTitleColor: "#303030",
    mobilePayWorksItemTitleColor: "#2A2C25",
    mobilePayGuidlineBgColor: "#F6F6F6",
    mobilePayWhiteTextColor: "#FFFFFF",
    reorderTopTabScreenBackgroundColor: "#F6F6F6",
    errorPopUpContentDividerBackgroundColor: "#F6F6F6",
    menuSliderSelectedCountTextColor: "#808080",
    menuCustomisationButtonColor: "#A2402A",
    menuCustomisationIsSelectedMobileColor: "#F3F4EA",
    menuCustomisationIsSelectedBorderMobileColor: "#A8AD00",
    menuCustomisationNotSelectedBorderMobileColor: "#C6C6C6",
    joinWaitListMapTextColor: "#464838",
    joinWaitlistBackgroundColor: "#F6F6F6",
    selectedNumberOfGuestBorderColor: "#F0ECE6",
    selectedNumberOfGuestBackgroundColor: "#F3F4EA",
    backgroundWhite: Platform.OS === "web" ? null : "#FFFFFF",
    menuCustomisationListIItemActiveColour: "#DFD3B1",
    collapsableDropdownItemBgColor: "#F6F6F6",
    smartRecommendationBackgroundColor: "#E5E5E5",
    smartRecommendationActiveDotColor: "#54301A",
    smartRecommendationInActiveDotColor: "#C6C6C6",
    unavailableWaitlistColor: "#BDBDBD",
    mobileReorderScreenTitleColor: "#2A2C25",
    // ORDER CONFIRMATION END
    pickupMethodBackgroundColor: "#F6F4E0",
    pickupMethodSectionDivider: "#DCDCDC",
    // Menu Search Start
    suggestionsBorderColor: "#C6C6C6",
    clearTextColor: "#993324",
    backgroundE5E5: "#E5E5E5",
    // Menu Search End
    ///Order Ahead Flow Tokens
    serveAsEntreeSwitch: "#97BC67",
    //mobile Payment Options tokens
    paymentOptionsHeaderColor: "#A96F3E",
    paymentOptionsBorderColor: "#86714D",
    //mobile app profile
    editProfileInfoLabelColor: "#808080",
    editProfileInfoAsteriskColor: "#D30000",
    profilePictureShadowColor: "#000000",
    mobileOrderInfoBannerBorderColor: "#D6D6D6",
    // order tracking page end
    //mobile restaurant details skeleton
    skeletonColorGrey: "#DCDCDC",
    onboardingScreenBGColor: "#FFFFFF",
    onboardingActiveDotColor: "#A96F3E",
    onboardingInactiveDotColor: "rgba(17, 0, 0,0.2)",
    onboardingButtonBackgroundColor: "#A96F3E",
    orderDetailsSkeletonBgColor: "#C4C4C4",
    //tab bar
    backgroundTabBarColor: "white",
    shadowColor: "#2c2c2c",
    //home-screen header avatar
    homeScreenHeaderAvatarBg: "#86714d",
    //menu-collapsable bg
    menuCollapsableButton: "#ECE3CA",
    //number of guests bg
    numberOfGuestsActiveColor: "#303030",
    // estimated waitTime bg
    estimatedWaitTimeBg: "#54301A",
    // cart item qty color
    cartItemQuantityColor: "#54301A",
    mobileBottomTabBackgroundColor: "#86714d",
    bottomTabTextColor: "#FFFFFF",
    checkoutGratuitySliderMinTrackColor: "#A96F3E",
    checkoutGratuitySliderMaxTrackColor: "#BFBFBF",
    cartQuantityTextColor: "#54301A",
    checkoutRadioBtnColor: "#A8AD00",
    // waitlistWineWhileYouWait Background color:
    waitlistWineWhileYouWaitBg: "#FFEFC2",
    homescreenWaitlistButtonBorderColor: "#A2402A",
    homescreenWaitlistButtonTextColor: "#A2402A",
    recentOrderTextColor: "#303030",
    orderConfirmationSeeDetailsShadowStart: "rgba(0, 0, 0, 0.02)",
    orderConfirmationSeeDetailsShadowEnd: "rgba(0, 0, 0, 0.05)",
    // statuses colours:
    highWait: "#CA7C30",
    lowWait: "#A8AD00",
    waitNotAvailable: "#BDBDBD",
    partySizeBgColor: "#A8AD00",
    partySizeBorderColor: "white",
    recentOrdersListItemPrice: "#3B3734",
    // keyboard done button:
    joinWaitlistBackgrouondColor: "#F6F6F6",
    joinWaitlistFormBgColor: "#FFFFFF",
    joinWaitlistFormBorder: "#DEDEDE",
    orderTotalTextColor: "#54301A",
    orderTotalPriceColor: "#54301A",
    jwcArrowColor: "#4E311D",
    waitlistStatusScreenBg: "#F3F4EA",
    waitlistVisibilityModalBg: "#000000B2",
    waitlistTableRowSeperator: "#F6F6F6",
    waitlistTableInfoBg: "#452D20",
    waitlistTableInfoText: "#FFFFFF",
    loginScreenHeaderBackground: "#ECE3CA",
    loginScreenScrollBg: "#ECE3CA",
    createAccountZipCodeBg: "#FFFFFF",
    createAccountLocationCardBackgroundColor: "#ECE3CA",
    loginErrorMessageBg: "#F6F4E0",
    loginErrorMessageBorder: "#F6F4E0",
    preferredLocationScrollBg: "#ECE3CA",
    menuListingScrollBackground: "#f6f3ef",
    menuListingTopTabActiveBorderColor: "#ffffff",
    cartCheckoutButtonLinearGradientStart: "transparent",
    cartCheckoutButtonLinearGradientEnd: "transparent",
    menuListingTopTabsColor: "#86714d",
    cartHeaderTextColor: "#FFF",
    dividerBackgroundColor: "#b09c79",
    moreHeaderTitleTextColor: "#FFFFFF",
    customMobileHeaderBG: "#86714d",
    addCreditCard_headerBackgroundColor: "#FFFFFF",
    editProfileInfoCardBg: "#ECE3CA",
    addCardSecurityBannerBg: "#F6F4E0",
    mobileCreateAccountScrollBackgroundColor: "#ECE3CA",
    menuTopTabNotActiveTextColor: "#ffffff",
    menuTopTabActiveTextColor: "#ffffff",
    checkoutTopTabTextColor: "#FFFFFF",
    checkoutTopTabActiveTextColor: "#171717",
    checkoutCardsBg: "#F6F4E0",
    orderInfoBannerCartSubTotalColor: "#A96F3E",
    wineOnboardingScreenBGColor: "#000",
    wineOnboardingActiveDotColor: "#fff",
    wineOnboardingInactiveDotColor: "rgba(255,255,255, 0.5)",
    wineOnboardingButtonBackgroundColor: "#A96F3E",
    wineOnboardingButtonTextColor: "#FFFFFF",
    orderSettingsCardsBackgroundColor: "#f6f3ef",
    orderSettingsActionSheetBackgroundColor: "#ded4c6",
    orderSettingsActionSheetAsapScheduledColor: "#A96F3E",
    menuItemDetailMenuSummaryBackgroundColor: "#ded4c6",
    menuitemDetailScreenBackgroundColor: "#ded4c6",
    cartHeaderBGColor: "#998668",
    homescreenCarouselInactiveDotColor: "#CCAC87",
    homescreenCarouselActiveDotColor: "#A96F3E",
    wineListingHeadingColor: "#3B3734",
    wineFilterCategoriesBg: "#998668",
    wineListLocationSearchBarBackgroundColor: "#998668",
    wineListLocationSearchBarLocationColor: "#FFF",
    wineListLocationSearchBarChangeTextColor: "#FFFFFF",
    wineListSearchBarBackgroundColor: "#F6F4E0",
    wineListSearchBarDividerColor: "#A58E61",
    wineListSearchBarInputFieldPlaceholderTextColor: "#7E7C77",
    wineListHeaderTextColor: "#FFF",
    wineListResultsContainerBackgroundColor: "#ECE4CA",
    wineListResultsIndexLetterTextColor: "#4E311D",
    wineListResultsListItemDividerColor: "#D2C7A3",
    locationsTopTabScreenHeaderHeadingTextColor: "#FFFFFF",
    locationsTopTabScreenHeaderSubHeadingTextColor: "#ECE4CA",
    nearbyLocationsListViewScrollViewBgColor: "#FFFFFF",
    alphabetsListItemTextColor: "#3B3734",
    wineListItemDividerColor: "#D2C7A3",
    filterControlItemBorderColor: "#A96F3E",
    filterControlItemBackgroundColor: "#F6F4E0",
    filterControlItemTextColor: "#3B3734",
    wineListLocationScrollViewBgColor: "#ECE4CA",
    wineLockerLandingBg: "#000",
    landingLoginButtonBg: "#A96F3E",
    landingLoginButtonText: "#fff",
    landingLoginButtonBorder: "#fff",
    landingSignupButtonBgText: "#000",
    landingHeading: "#fff",
    wineLockerTabActiveBorderColor: "#F3ECD7",
    wineLockerTopTabBg: "#000",
    wineLockerTopTabFocused: "#F9F4E4",
    wineLockerTopTabBlur: "#AFAFAF",
    lockersBg: "#eee4c7",
    lockerDivider: "#D2C7A3",
    myWineLockerThingsToTryNumberBg: "#3B3734",
    lockerDetailsHeading: "#3B3734",
    lockerDetailsSubHeading: "#606060",
    menuSearchResultsBg: "#ded4c6",
    searchHeaderColor: "#020001",
    menuSearchPlaceHolder: "#3B3734",
    recentOrderDividerBg: "#D2C7A3",
    restDetailsTitleColor: "#fff",
    restDetailsBg: "#FFFFFF",
    restDetailButtonBg: "#F6F4E0",
    newLocationsBannerBg: "#86714D",
    recentOrderBorder: "#D2C7A3",
    topTabCountInactiveBg: "#606060",
    tooltipTextColor: "#3B3734",
    pickupDetailsBorder: "#F6F4E0",
    checkoutVehicleBg: "#F6F4E0",
    sliderFilterTrackBackgroundColor: "#CCC0A7",
    sliderFilterThumbComponentOuterColor: "#FFF",
    seeDetailsText: "#fff",
    orderSettingsQuantityBg: "#ECE3CA",
    criticalModeBg: "#ECE4CA",
    wineSkeletonItemBgColor: "#C4C4C4",
    wineSkeletonFooterBgColor: "#F8F8F8",
    wineSkeletonFooterItemBgColor: "#DCDCDC",
    wineSkeletonDividerBgColor: "#CDCDCD",
    reservationSectionBg: "#A96F3E",
    reservationSectionText: "#fff",
    todayText: "#3B3734",
    timeText: "#A96F3E",
    lookForwardText: "#3B3734",
    reservationSectionCircleBg: "#fff",
    reservationSectionCircleBorder: "rgba(255, 255, 255, 0.2)",
    reorderAddItemBg: "#F6F4E0",
    reorderAddItem: "#86714d",
    orderHistoryItemCardBackgroundColor: "#F6F4E0",
    orderHistoryItemCardPriceColor: "#000",
    orderHistoryItemCardDividerColor: "#DED3B5",
    orderHistoryHeaderBgColor: "#000",
    orderHistoryHeaderTitleColor: "#FFF",
    orderHistoryDetailsOrderNumberTextColor: "#000",
    orderHistoryCardLayoutBackgroundColor: "#FFFFFF",
    orderHistoryFooterBackgroundColor: "#ECE3CA",
    menuItemDetailListCardBorderColor: "#DCDCDC",
    menuItemDetailListCardBackgroundColor: "#F8F8F8",
    menuItemDetailListScrollViewColor: "#E5E5E5",
    menuItemDetailListCardBackground: "#FFF",
    addKeyHolderSkeletonScrollViewBgColor: "#FFF",
    menuListSkeletonHeaderContainerBackground: "#020001",
    menuListSkeletonHeaderBackground: "#020001",
    menuListSkeletonCategoryNavigationBgColor: "#DCDCDC",
    menuListSkeletonTopTabActiveBottomBorderColor: "#F9F4E4",
    menuDetailsHeaderTitleColor: "#FFFFFF",
    selectedOrderTypeBorderColor: "#A96F3E",
    selectedOrderTypeTextColor: "#A96F3E",
    reservationsLocationCardBg: "#F6F4E0",
    reservationDetailsCTABg: "#F6F4E0",
    reservationAvailableTimeSlotBg: "#F6F4E0",
    reservationTimeSlotsItemInactiveBg: "#ECE4CA",
    reservationsSpecialRequestBg: "#F6F4E0",
    reservationsConfirmationDetailsBg: "#F6F4E0",
    reservationHeaderTitleColor: "#FFFFFF",
    reservationDOBBgColor: "#F6F4E0",
    modalHeaderColor: "#020001",
    modalHeaderTextColor: "#fff",
    mobileCalendarTextColor: "#86714d",
    itemAddToCartPopupBackgroundMobile: "#f6f3ef",
    recommendedWineColor: "#A96F3E",
    gcBalanceRefreshBorderTextColor: "#86714D",
    gcBalanceRefreshBackdropColor: "rgba(0, 0, 0, 0.6)",
    calenderTodayBackgroundColor: Platform.OS === "web" ? "#73994A" : "#fff",
    calenderSelectedDayColor: Platform.OS === "web" ? "#73994A" : "#A96F3E",
    calenderSelectedDayTextColor: Platform.OS === "web" ? "#000" : "#fff",
    calenderSelectedDayStyleBGColor: Platform.OS === "web" ? "#73994A" : "#86714d",
    reserveTableHeaderRightButtonText: "#73994A",
    reserveConfirmationDescriptionHeaderBg: Platform.OS === "web" ? "#000" : "#A96F3E",
    suggestedWineOpenTextColor: "#3B3734",
    reservationSelectedSeatingOption: "#ded4c6",
    reservationCalendarCtaBorderRadius: 0,
    reservationDOBMonthBgColor: "transparent",
    reservationDOBYearBgColor: "transparent",
    reservationDOBNavColor: "#000",
    reservationInputErrorColor: "#ff0000",
    giftAWineAddRecipientToolTipTextColor: "#FFF",
    reservationLocationModalDeskHeaderBg: "#f6f3ef",
    smartRecommendationModalCloseIconColor: "#FFF",
    wineListSkeletonBgColor: "#AFAFAF",
    wineListSkeletonContainerBgColor: "#DCDCDC",
    wineListSkeletonDividerColor: "#CDCDCD",
    wineListSkeletonSearchBarBgColor: "#F8F8F8",
    wineListSkeletonLocationContainerBgColor: "#C4C4C4",
    wineListSortControlsLabelTextColor: "#A96F3E",
    wineListSortControlSortValueTextColor: "#3B3734",
    noReservationBorder: "#86714d",
    wineGiftThankYouStatusTextColor: "#3B3734",
    wineGiftThankYouGiftDividerColor: "#D2C7A3",
    giftSummaryScreenPrimaryTextColor: "#4E311D",
    giftSummaryScreenSecondaryTextColor: "#DFD5B6",
    callScreenBg: "#131313",
    callScreenHeading: "#fff",
    callScreenSubHeading: "#fff",
    buttonsBg: "rgba(255, 255, 255, 0.16)",
    endCallBg: "#FF0000",
    networkIndicatorColor: "#A96F3E",
    reservationLocationModalMobHeaderBg: Platform.OS === "web" ? "#f6f3ef" : "#000",
    reservationLocationListBg: "#fff",
    reservationLocationListBgMobile: "#F0ECE6",
    pdLocationListBg: "#FFF",
    pdLocationListBgMobile: "#F0ECE6",
    reservationDropDownIconColor: "#86714D",
    reservationsSpecialRequestSwitch: "#86714D",
    reservationBg: "#FFFFFF",
    reservationStaticTextBg: "#F6F3EF",
    reservationTabsBg: "#DED4C6",
    reservationPickerHoverColor: "#86714D",
    reservationNoOfGuestsSelectedBg: "#86714d",
    reservationNoOfGuestsNotSelectedBg: "#f6f3ef",
    reservationsTimePickerBg: "#FFFFFF",
    reservationActionButtonsBg: "#F6F3EF",
    reservationInactiveSelectTime: "#DED4C6",
    confirmationModalBorderRadius: 0,
    cancelConfirmationModalBorderRadius: 0,
    reservationUserInitials: "#ffffff",
    preferredLocationCloseButtonBg: "transparent",
    preferredLocationCloseButtonHover: "transparent",
    preferredLocationCloseButtonIconColor: Platform.OS === "web" ? "#86714D" : "#FFFFFF",
    preferredLocationModalContentColor: "#FFFFFF",
    reservationHoveredText: "#FFF",
    reservationNotHoveredText: "#3B3734",
    reservationsCardBg: Platform.OS === "web" ? "#f6f3ef" : "#f6f3ef",
    reservationsCardsBodyBg: "transparent",
    checkoutRadioButtonBorderColor: Platform.OS === "web" ? "#86714D" : "#D6D6D6",
    reservationSpecialRequests: "#f6f3ef",
    reservationsTopTabsBg: Platform.OS === "web" ? "#DED4C6" : "#86714d",
    reservationsTopTabsLabel: "#000000",
    reservationsTopTabsLabelFocused: "#000000",

    /** Colors: Private Dining Start */
    minimalHeaderSignInBtn: "#ECE3CA",
    makeRequestPageBg: "#fff",
    requestFormTabActiveItem: "#EFEDE9",
    requestFormTabDisableItem: "#B09C79",
    splRequestToggleTrackColor: "#86714D",
    pdPurposeDropDownOptionHover: "#86714D",
    pdTimeDropDownOptionHover: "#86714D",
    pdPartySizeRangeOptionHover: "#86714D",
    pdmenuPrefOptionHover: "#86714D",
    pdFooterPrivacyNotice: "#86714D",
    pdContactDetailsEdit: "#86714D",
    pdReviewDetailsEventInfoDivider: "#86714D",
    pdConfirmationMobileBg: "#F0ECE6",
    pdRequestFormInputBg: "#FFFFFF",
    pdRequestFormInputBorder: "transparent",
    pdFooterBg: "#FFFFFF",
    pdActionSheetBody: "#FFF",
    pdMobilePageBg: "#F0ECE6",
    eventPurposeSelectorColor: "#606060",
    eventPurposeSelectorHoverColor: "#FFFFFF",
    pdContactsPhoneTypeDivider: "#D5CEB6",
    pdFormAsteriskColor: "#808080",
    pdLandingMenuTabBg: "#F0ECE6",
    pdLandingLocationInfoMobileBg: "#F0ECE6",
    pdLandingDropdownActive: "#86714D",
    pdLandingDropdownInActive: "#FFFFFF",
    pdLandingNoLocationContainer: "#FFFFFF",

    /** Colors: Private Dining End */
    reservationDOBTooltipBgColor: "#e3e3e3",
    reservationDOBTooltipTextColor: "#000",
    desktopTopTabsBG: "#ffffff",
    menuSearchModalCloseIconColor: "#000000",
    menuSearchInputBorder: "#86714d",
    menuSearchResultContainerBG: "#ded4c6",
    pdRequestFormBG: "#F0ECE6",
    myAccountBgImageOverlay: "#F1ECE6",
    myAccountBgColor: "#F1ECE6",
    myAccountCardBackgroundActive: "#F1ECE6",
    myAccountChangeFieldModalBg: "white",
    myAccountEditProfileScrollViewBg: "white",
    myAccountAddGiftCardsPopover: "#A96F3E",
    myAccountDOBYearBgColor: "transparent",
    myAccountDOBMonthBgColor: "transparent",
    myAccountDOBTextColor: "#86714D",
    myAccountMenuItemActiveTextColor: "#86714D",
    myAccountMenuItemInActiveTextColor: "#303030",
    myAccountCalendarCtaBorderRadius: 0,
    eClubHoverActiveColor: "#F0ECE6",
    eClubHoverActiveTextColor: "#303030",
    eClubHoverInactiveTextColor: "#303030",
    eClub_background_color: "#F0ECE6",
    eClub_confirmation_background_color: "#F0ECE6",
    eClubPopOverBackgroundColor: "#FFFFFF",
    EclubUnsubscribeBackgroundColor: "#F0ECE6",
    EClubUnsubscribeEmailValidationTextColor: "#f00",
    joinEclubPreferredLocationButtonBorderColor: "#D6D6D6",
    joinEclubPreferredLocationLocationHeadingTextColor: "#808080",
    joinEclubPreferredLocationLocationNameTextColor: "#303030",
    joinEclubPreferredLocationLocationAddressTextColor: "#606060",
    editProfileFullBottomButtonBackgroundColor: "white",
    orderHistoryFullBottomButtonBackgroundColor: "white",
    orderHistoryDetailsHeaderModalBackgroundColor: "#F1ECE6",
    pdInputDataTextColor: "#000",
    EClubInputErrorColor: "#ff0000",
    menuListingContainerBG: "#fff",
    locationListBgColor: "#fff",
    locationsSearchPageLocationListItemBgColorMobile: "#f6f3ef",
    joinEclubContainerBgColor: "#f1ece6",
    editProfile_modalHeaderBackgroundColor: "#FFFFFF",
    editProfile_modalBodyBackgroundColor: "#F6F6F6",
    confirmationModalCTABackgroundColor: "#86714D",
    giftCardLargeBody_BackgroundColor: "#FAFAFA",
    giftCardLargeBody_webModalBackgroundColor: "#FAFAFA",
    giftCardLargeHeader_BackgroundColor: "#FAFAFA",
    webOrderHistoryBackgroundColor: "#FFFFFF",
    orderHistoryDetailsBottomButton_BackgroundColor: "#FFFFFF",
    paymentOptionsAddEditGCModalHeaderBackgroundColor: "#FFFFFF",
    paymentOptionsAddEditCCModalHeaderBackgroundColor: "#FFFFFF",
    securityBannerTextColor: "#606060",
    addCreditDebitCardTooltipTextColor: "#606060",
    orderHistoryModalHeaderTextColor: "#404040",
    orderHistoryDetailsModalBackgroundColor: "#FFFFFF",
    EclubFormInputPlaceholderTextColor: "#808080",
    myAccountSkipConfirmationCTA: "#86714D",
    paymentOptions_giftCard_balanceAmountColor: "#303030",
    joinEclubDOBTextColor: "#A96F3E",
    menuItemcardVerticalImageBorderRadius: "xl",
    EclubDOBBottomBorderColor: "#606060",
    reservationShareIconText: "#86714D",
    globalMessageBannerPadding: 1,
    errorDialogModalBorderRadius: 8,
    itemIsForBgColor: "#F6F4E0",
    locationListItemOrderText: "white",
    locationListItemOrderBg: "secondary.300",
    locationListItemOrderHoverBg: "secondary.300",
    locationListItemOrderPadding: 3,
    orderDetailsCartItemPrice: "#000000"
  },
  components: {
    Pressable: {
      variants: {
        /* RESERVATION */
        reservationLocationSelectionBtn: {
          borderRadius: 0,
          px: 10,
          backgroundColor: "secondary.300",
          alignItems: "center",
          justifyContent: "center"
        },
        reservationConfBackHomeBtn: {
          borderRadius: 0,
          alignItems: "center",
          justifyContent: "center",
          mb: 30,
          mx: 5,
          px: 5,
          mt: 5,
          borderWidth: 1,
          height: 12,
          borderColor: "secondary.300"
        },
        reservationSelectGuestBtn: {
          borderColor: "reservationBorderColor",
          borderWidth: 1,
          py: 3,
          px: 5,
          mx: 1.5,
          borderRadius: 0,
          _ios: {
            radiusValue: 0
          },
          _android: {
            radiusValue: 0
          }
        },
        reservationPickerBtn: {
          flex: 1,
          py: 2,
          _web: {
            py: 4,
            px: 4
          },
          _ios: {
            alignItems: "center"
          },
          _android: {
            alignItems: "center"
          },
          mx: 1.5,
          borderRadius: 0,
          justifyContent: "center"
        },
        reservationAvailableTimeSlotBtn: {
          borderColor: "reservationBorderColor",
          borderRadius: 0,
          mx: 2
        },

        /* RESERVATION */
        jwcPreOrderBtn: {
          px: 5,
          py: 4,
          bg: {
            base: "#A2402A",
            lg: "white"
          },
          borderRadius: {
            base: 8,
            lg: 12
          },
          _web: {
            my: 2
          },
          mx: 2
        },
        qualityStoryBtnCta: {
          px: 5,
          py: 4,
          bg: {
            base: "#ffffff",
            lg: "#ffffff"
          },
          borderRadius: {
            base: 8,
            lg: 12
          },
          _web: {
            my: 2
          },
          mx: 2
        },
        categoryActiveBorder: {
          borderBottomWidth: 3
        },
        suggestedSearchPill: {
          mb: 2,
          mr: 3,
          py: 1,
          px: 4,
          alignItems: "center",
          justifyContent: "center",
          bg: Platform.OS === "web" ? "#86714d" : "#86714d",
          borderRadius: 0,
          _ios: {
            borderWidth: 1,
            borderColor: "#86714d"
          },
          _android: {
            borderWidth: 1,
            borderColor: "#86714d"
          }
        },
        //Order Tracking
        orderTrackingCurbsideCheckPrimary: {
          bg: "payNowButtonBg",
          borderColor: "curbsideCheckInSecondary",
          borderWidth: 1,
          px: 5,
          py: 3,
          alignItems: "center",
          justifyContent: "center"
        },
        orderTrackingCurbsideCheckSecondary: {
          bg: "#FFFFFF",
          borderColor: "curbsideCheckInSecondary",
          px: 5,
          py: 3,
          borderWidth: 1,
          alignItems: "center",
          justifyContent: "center"
        },
        criticalModeOrderCTA: {
          backgroundColor: "#A96F3E"
        },
        //Restaurant Details Start
        restaurantDetails_RestWaitlist_JoinWaitlistButton: function restaurantDetails_RestWaitlist_JoinWaitlistButton(_ref) {
          var disabled = _ref.disabled;
          return {
            borderColor: disabled ? "#BCBCBC" : "transparent",
            alignItems: "center",
            justifyContent: "center",
            borderWidth: disabled ? 1 : 0,
            _ios: {
              py: 2
            },
            _android: {
              py: 2
            },
            minWidth: {
              base: "70%",
              lg: "261px"
            },
            _web: {
              minH: "44px",
              style: {
                background: disabled ? "#BCBCBC" : "linear-gradient(125deg, rgba(176,156,121,1) 0%, rgba(134,113,77,1) 100%)"
              }
            },
            bg: disabled ? "#BCBCBC" : "rgba(134,113,77,1)"
          };
        },
        restaurantDetails_OrderButtonSection_OrderNowButton: function restaurantDetails_OrderButtonSection_OrderNowButton(_ref2) {
          var disabled = _ref2.disabled;
          return {
            alignItems: "center",
            justifyContent: "center",
            borderColor: "#86714d",
            _ios: {
              backgroundColor: "secondary.300",
              borderColor: "secondary.300"
            },
            _android: {
              backgroundColor: "secondary.300",
              borderColor: "secondary.300"
            },
            opacity: disabled ? 0.4 : 1,
            borderWidth: 1,
            width: "100%",
            disabled: disabled,
            _web: {
              minH: "44px",
              padding: 2
            }
          };
        },
        restaurantDetails_RestTimings_WeekDayIconButton: function restaurantDetails_RestTimings_WeekDayIconButton(_ref3) {
          var selectedDay = _ref3.selectedDay;
          return {
            borderRadius: 100,
            backgroundColor: selectedDay ? "restaurantDetailsSelectedWeekDayColor" : "restaurantDetailsNotSelectedWeekDayColor",
            width: 38,
            height: 38,
            borderColor: "weekDayBorderColor",
            borderWidth: 1,
            alignItems: "center",
            justifyContent: "center"
          };
        },
        restaurantDetails_ActionButtons_ApplyNowButton: function restaurantDetails_ActionButtons_ApplyNowButton() {
          return {
            _ios: {
              my: "7px"
            },
            _android: {
              my: "7px"
            },
            alignItems: "center",
            justifyContent: "center",
            paddingY: 4,
            _web: {
              minH: "44px",
              padding: 2
            },
            borderWidth: 1,
            // width: "100%",
            borderColor: "amenitiesActionButtonsColor"
          };
        },
        restaurantDetails_ActionButtons_ViewMenuButton: function restaurantDetails_ActionButtons_ViewMenuButton(_ref4) {
          var disabled = _ref4.disabled;
          return {
            _ios: {
              my: "7px"
            },
            _android: {
              my: "7px"
            },
            alignItems: "center",
            justifyContent: "center",
            opacity: disabled ? 0.4 : 1,
            paddingY: 4,
            _web: {
              minH: "44px",
              padding: 2
            },
            borderWidth: 1,
            // width: "100%",
            borderColor: "amenitiesActionButtonsColor"
          };
        },
        restaurantDetails_RestaurantInfo_FavoriteButton: function restaurantDetails_RestaurantInfo_FavoriteButton() {
          return {
            bg: "white",
            w: "10",
            h: "10",
            shadow: 11,
            m: "auto",
            rounded: "full",
            position: "absolute",
            top: 2,
            right: 2
          };
        },
        restaurantDetails_RestInfo_ShareButton_Icon: {
          alignItems: "center",
          flexDirection: "row"
        },
        //Restaurant Details End
        locationListItemAddress: {
          pointerEvents: "none"
        },
        borderRadiusValue: function borderRadiusValue(_ref5) {
          var radiusValue = _ref5.radiusValue,
              topRadiusValue = _ref5.topRadiusValue,
              bottomRadiusValue = _ref5.bottomRadiusValue;
          return {
            borderRadius: 0,
            borderTopRadius: 0,
            borderBottomRadius: 0
          };
        },
        viewCartBtnBorderRadius: {
          _ios: {
            borderRadius: 8
          },
          _android: {
            borderRadius: 8
          }
        },

        /** Pressable: Private Dining Start */
        privateDiningLocationSelectionBtn: {
          borderRadius: 0,
          px: 10,
          // backgroundColor: "",
          style: {
            background: "linear-gradient(90deg, #B09C79 0%, #86714D 100%)"
          },
          alignItems: "center",
          justifyContent: "center"
        },
        privateDiningModalCancelCTA: {
          px: 4,
          py: 2,
          borderWidth: 1,
          borderColor: "#86714D",
          borderRadius: 0,
          alignItems: "center",
          justifyContent: "center",
          w: "100%"
        },
        privateDiningModalConfirmCTA: {
          bg: "#86714D",
          alignItems: "center",
          justifyContent: "center",
          borderRadius: 0,
          w: "100%",
          px: 4,
          py: 2,
          borderWidth: 1,
          borderColor: "#86714D"
        },
        pd_landing_menuTabs_Item: function pd_landing_menuTabs_Item(_ref6) {
          var isActive = _ref6.isActive;
          return {
            style: {
              background: isActive ? "linear-gradient(102deg, #B09C79 20.73%, #86714D 65.86%)" : "transparent"
            },
            px: isActive ? 6 : 0,
            py: isActive ? 1.5 : 0,
            borderRadius: 0
          };
        },
        pd_landing_noLocation_selectCTA: {
          style: {
            background: "linear-gradient(102deg, #B09C79 20.73%, #86714D 65.86%)"
          },
          mt: {
            base: 8,
            md: 12
          },
          py: 3.5,
          px: {
            base: 5,
            md: 24
          },
          width: {
            base: "100%",
            sm: "auto"
          }
        },
        pd_landing_eventGuideCTA: {
          width: {
            base: "100%",
            lg: "273px"
          },
          borderColor: "#86714D",
          borderWidth: 1,
          borderRadius: 0
        },

        /** Pressable: Private Dining End */
        homeScreen_order_button: function homeScreen_order_button() {
          return {
            borderColor: "secondary.300",
            borderWidth: 1,
            alignItems: "center",
            justifyContent: "center",
            borderRadius: 0,
            width: "90%",
            bg: "bodyBg",
            _pressed: {
              bg: "bodyBg"
            }
          };
        },
        eClubStickySignUpDesktopPressable: {
          style: {
            background: "linear-gradient(102deg, #B09C79 20.73%, #86714D 65.86%)"
          },
          px: 4,
          py: 2,
          borderRadius: 0,
          w: "100%",
          h: "100%",
          justifyContent: "center"
        },
        eClubStickyCancelDesktopPressable: {
          borderWidth: 1,
          borderColor: "#86714D",
          px: 4,
          py: 2,
          borderRadius: 0,
          w: "100%",
          right: 4,
          h: "100%",
          justifyContent: "center"
        },
        eClubConfirmationSignUpMobilePressable: {
          style: {
            background: "linear-gradient(102deg, #B09C79 20.73%, #86714D 65.86%)"
          },
          mt: 10,
          width: "100%",
          alignItems: "center",
          borderRadius: 0,
          py: 3,
          mb: 5
        },
        eClubStickySignUpMobilePressable: {
          style: {
            background: "linear-gradient(102deg, #B09C79 20.73%, #86714D 65.86%)"
          },
          px: 4,
          py: 2,
          borderRadius: 0,
          flex: 1,
          h: "100%",
          justifyContent: "center"
        },
        eClubStickyCancelMobilePressable: {
          borderWidth: 1,
          borderColor: "secondary.300",
          px: 4,
          py: 2,
          borderRadius: 0,
          flex: 1,
          mr: 3,
          h: "100%",
          justifyContent: "center"
        },
        // My Account starts
        myAccount_edit_fields_sheet_title_container: {
          bg: "white",
          width: "100%"
        },
        myAccount_order_history_order_details_modal_header_close_icon: {
          position: "absolute",
          right: 5,
          my: "auto"
        },
        myAccount_infoList_changeOperation_container: {
          px: 4,
          mb: 3,
          alignItems: "center",
          flexDirection: "row",
          shadow: 17,
          py: 5,
          backgroundColor: {
            base: "myAccountCardBackground",
            md: "#F1ECE6"
          },
          borderRadius: 8,
          _web: {
            borderRadius: 0
          }
        },
        myAccount_paymentOptions_addGC_actionSheet_Add: {
          my: 1,
          borderRadius: 0,
          width: "100%",
          backgroundColor: "secondary.300",
          _web: {
            my: 0,
            style: {
              background: "linear-gradient(102deg, #B09C79 20.73%, #86714D 65.86%)"
            }
          },
          flex: 1,
          ml: 2
        },
        editFieldsConfirmationModalCTAPressable: {
          borderRadius: 0,
          py: 3,
          px: 4,
          _web: {
            style: {
              background: "linear-gradient(102deg, #B09C79 20.73%, #86714D 65.86%)"
            }
          }
        },
        myAccount_editFieldsConfirmationModalCancelCTAPressable: {
          _web: {
            backgroundColor: "transparent"
          },
          py: 2.5
        },
        editFieldsSuccessModalCTAPressable: {
          borderRadius: 0,
          py: 3,
          px: 4,
          _web: {
            style: {
              background: "linear-gradient(102deg, #B09C79 20.73%, #86714D 65.86%)"
            }
          }
        },
        myAccount_paymentOptions_addCard_Pressable: {
          mt: 8,
          bg: "secondary.300",
          px: 5,
          _ios: {
            width: {
              base: "90%",
              md: "65%",
              lg: "50%"
            }
          },
          _android: {
            width: {
              base: "90%",
              md: "65%",
              lg: "50%"
            }
          },
          _web: {
            style: {
              background: "linear-gradient(102deg, #B09C79 20.73%, #86714D 65.86%)"
            }
          }
        },
        addEditCreditCard_add_pressable: {
          width: "100%",
          backgroundColor: "secondary.300",
          _web: {
            style: {
              background: "linear-gradient(102deg, #B09C79 20.73%, #86714D 65.86%)"
            }
          }
        },
        myAccount_menuListItem_pressable: function myAccount_menuListItem_pressable(_ref7) {
          var isActive = _ref7.isActive;
          return {
            borderRadius: 0,
            alignItems: "center",
            padding: 4,
            backgroundColor: isActive ? "myAccountCardBackgroundActive" : "myAccountCardBackground",
            flexDirection: "row",
            _web: {
              backgroundColor: {
                base: "white",
                md: isActive ? "myAccountCardBackgroundActive" : "myAccountCardBackground"
              }
            }
          };
        },
        // My Account ends
        myAccount_paymentOptions_checkBalanceCTA: {
          marginY: 1,
          border: 1.5,
          borderColor: "#86714D",
          borderRadius: 0,
          _web: {
            my: 0
          },
          flex: 1,
          mr: 2
        }
      }
    },
    Checkbox: {
      baseStyle: {
        _checkbox: {
          bg: "#F0ECE6",
          borderColor: "primary.100",
          _checked: {
            bg: "#86714D",
            borderColor: "#86714D"
          }
        }
      },
      variants: {
        eclub_restaurantOptions: {
          alignItems: "flex-start"
        }
      }
    },
    Radio: {
      baseStyle: {
        _radio: {
          borderColor: "primary.100",
          bg: "#ECE4CA"
        }
      }
    },
    Button: {
      baseStyle: {
        borderRadius: 0,
        _focusVisible: {
          style: {
            boxShadow: "none"
          }
        }
      },
      variants: {
        solid: {
          bg: "#86714D",
          _pressed: {
            bg: "#86714D"
          },
          _hover: {
            bg: "#86714D"
          }
        },
        ghost: {
          _pressed: {
            bg: "transparent"
          },
          _hover: {
            bg: "transparent"
          }
        },
        link: {
          _text: {
            textTransform: "uppercase",
            color: "#86714d",
            fontWeight: "400",
            fontStyle: "normal",
            fontSize: "lg",
            lineHeight: 7,
            _web: {
              letterSpacing: "-0.3px"
            },
            letterSpacing: "-0.3",
            textAlign: "center",
            fontFamily: "heading"
          },
          _pressed: {
            bg: "transparent"
          }
        },
        outline: {
          _hover: {
            bg: "#E6DAD0"
          },
          _pressed: {
            bg: "#E6DAD0"
          }
        },
        loginPopUpBtn: {
          height: 12,
          _web: {
            height: null
          },
          _text: {
            color: "white",
            fontWeight: 400
          },
          bg: "secondary.300",
          _pressed: {
            bg: "secondary.300"
          },
          _hover: {
            bg: "#7A502D"
          }
        },
        camAccessBtn: {
          bg: "#7A502D",
          paddingY: 18,
          marginTop: 27,
          marginX: 5,
          borderWidth: 1,
          w: "100%",
          _text: {
            fontSize: 18,
            lineHeight: 6,
            fontWeight: 400,
            color: "white",
            textTransform: "uppercase"
          }
        },
        socialLoginBtn: {
          bg: "transparent",
          mb: 4,
          border: 1,
          borderColor: "rgb(53,88,156)",
          _text: {
            fontWeight: 400,
            color: "rgb(53,88,156)"
          },
          _hover: {
            bg: "white"
          }
        },
        refreshIcon: {
          _ios: {
            borderWidth: 1
          },
          _android: {
            borderWidth: 1
          },
          _web: {
            borderWidth: "1px"
          },
          backgroundColor: "white",
          borderColor: "#A2402A",
          _text: {
            fontSize: "xs",
            lineHeight: 4,
            textTransform: "uppercase",
            color: "secondary.300",
            fontWeight: 400
          }
        },
        changeLocationLink: {
          _text: {
            textTransform: "uppercase",
            _web: {
              fontSize: "xs"
            },
            fontWeight: "400",
            color: "#86714d",
            fontStyle: "normal",
            lineHeight: 7,
            letterSpacing: "-0.3px",
            textAlign: "center",
            fontFamily: "heading"
          },
          _pressed: {
            bg: "transparent"
          },
          _hover: {
            _text: {
              underline: true
            }
          }
        },
        HomeScreenCTAjwl: function HomeScreenCTAjwl(_ref8) {
          var borderRadiusValue = _ref8.borderRadiusValue;
          return {
            marginTop: 5,
            borderRadius: borderRadiusValue || 0
          };
        },
        HomescreenOrderOnlineCta: function HomescreenOrderOnlineCta(_ref9) {
          var borderRadiusValue = _ref9.borderRadiusValue;
          return {
            borderRadius: 0,
            backgroundColor: "secondary.300",
            shadow: 9,
            _ios: {
              borderRadius: 0,
              borderWidth: 1,
              bg: "bodyBg",
              _pressed: {
                bg: "bodyBg"
              },
              borderColor: "secondary.300",
              shadow: 0
            },
            _android: {
              borderRadius: 0,
              borderWidth: 1,
              bg: "bodyBg",
              _pressed: {
                bg: "bodyBg"
              },
              borderColor: "secondary.300",
              shadow: 0
            },
            width: "90%"
          };
        },
        HomeScreenCTAreserveNow: function HomeScreenCTAreserveNow(_ref10) {
          var borderRadiusValue = _ref10.borderRadiusValue;
          return {
            borderColor: "secondary.300",
            borderWidth: 1,
            bg: "bodyBg",
            _text: {
              color: "secondary.300"
            },
            _ios: {
              bg: "secondary.300",
              _text: {
                color: "homeScreenOrderNowButtonTextColor"
              }
            },
            _android: {
              bg: "secondary.300",
              _text: {
                color: "homeScreenOrderNowButtonTextColor"
              }
            }
          };
        },
        cartItemActionButton: {
          _text: {
            color: "cartItemActionBtn",
            textTransform: "uppercase",
            lineHeight: 5,
            fontWeight: 600,
            _ios: {
              fontSize: "13",
              fontWeight: "400"
            },
            _android: {
              fontSize: "13",
              fontWeight: "400"
            },
            _web: {
              fontSize: "18px"
            }
          }
        },
        cartItemRemoveBtn: {
          _ios: {
            borderWidth: 1
          },
          _android: {
            borderWidth: 1
          },
          _web: {
            borderWidth: "1px"
          },
          backgroundColor: "secondary.300",
          borderColor: "secondary.300",
          _text: {
            fontSize: "xs",
            lineHeight: 4,
            textTransform: "uppercase",
            color: "white",
            fontWeight: 400
          }
        },
        addMoreItemsButton: {
          _ios: {
            width: "100%",
            py: 4
          },
          _android: {
            width: "100%",
            py: 4
          },
          _web: {
            width: "100%",
            py: 2
          }
        },
        menuButton: function menuButton(_ref11) {
          var isActive = _ref11.isActive,
              isMobile = _ref11.isMobile,
              isLongText = _ref11.isLongText;
          return {
            ml: isLongText && isMobile && 5,
            px: isMobile ? 6 : 9,
            _web: {
              width: !isMobile && (isLongText ? "100%" : "117px"),
              borderRadius: 0
            },
            // bg: isActive ? "menuButtonBackgroundColor" : "transparent",
            width: !isMobile && (isLongText ? "100%" : 32),
            borderRadius: 0,
            height: {
              base: 8,
              md: 9
            },
            _text: {
              color: isActive ? "white" : "#020001",
              fontWeight: "300",
              fontSize: isMobile ? "xs" : "sm",
              _web: {
                lineHeight: {
                  base: "14.63px",
                  md: "24px"
                },
                fontSize: {
                  base: "12px",
                  md: "14px"
                }
              },
              lineHeight: isMobile ? 4 : 6,
              textTransform: "uppercase",
              fontFamily: "heading"
            },
            style: {
              background: isActive ? "linear-gradient(125deg, rgba(176,156,121,1) 0%, rgba(134,113,77,1) 100%)" : "transparent"
            }
          };
        },
        pillButton: function pillButton(_ref12) {
          var isActive = _ref12.isActive;
          return {
            bg: isActive ? "secondary.100" : "transparent",
            _web: {
              borderRadius: "20px",
              height: "24px"
            },
            borderRadius: 5,
            height: 6
          };
        },
        exploreMenuButton: function exploreMenuButton() {
          return {
            bg: Platform.OS === "web" ? "white" : "mobileReorderBg",
            border: 1,
            borderColor: "secondary.300",
            _text: {
              color: "secondary.300"
            }
          };
        },
        orderSettingsDateTimeChoiceSolidButton: function orderSettingsDateTimeChoiceSolidButton() {
          return {
            bg: "secondary.200"
          };
        },
        orderOnlineBtn: function orderOnlineBtn() {
          return {
            padding: 0,
            borderRadius: 0,
            _text: {
              color: "white",
              fontFamily: "Lato-Regular",
              fontWeight: 400,
              _web: {
                fontSize: "xs"
              },
              textTransform: "uppercase",
              margin: 2
            },
            bg: "locationListBtn",
            _hover: {
              bg: "locationListBtn"
            },
            _pressed: {
              bg: "locationListBtn"
            }
          };
        },
        orderOnlineBtnExternalLink: function orderOnlineBtnExternalLink() {
          return {
            padding: 0,
            borderRadius: 0,
            _text: {
              color: "white",
              fontFamily: "Lato-Regular",
              fontWeight: 400,
              _web: {
                fontSize: "xs"
              },
              textTransform: "uppercase",
              margin: 2
            },
            border: 1,
            borderColor: "secondary.300",
            bg: "secondary.300",
            _hover: {
              bg: "secondary.300"
            },
            _pressed: {
              bg: "secondary.300"
            }
          };
        },
        addToCartSolidButton: function addToCartSolidButton(_ref13) {
          var isUnavailable = _ref13.isUnavailable;
          return {
            _web: {
              style: {
                background: isUnavailable ? "#E5E5E5" : "linear-gradient(125deg, rgba(176,156,121,1) 0%, rgba(134,113,77,1) 100%)"
              }
            },
            bg: isUnavailable ? "#E5E5E5" : "#86714d",
            _pressed: {
              bg: isUnavailable ? "#E5E5E5" : "#7A502D"
            },
            _hover: {
              bg: isUnavailable ? "#E5E5E5" : "#7A502D"
            },
            _text: {
              fontWeight: "700"
            }
          };
        },
        addBtnPadding: function addBtnPadding() {
          return {
            _web: {
              paddingBottom: 2
            },
            paddingBottom: 1
          };
        },
        confirmationGradientButton: function confirmationGradientButton() {
          return {
            borderRadius: "none"
          };
        },
        menuSearchModalCloseButtonContainer: function menuSearchModalCloseButtonContainer() {
          return {
            _web: {
              marginRight: {
                base: "20px",
                md: "40px",
                lg: "110px"
              },
              marginTop: "26px",
              height: "48px",
              width: "48px",
              borderRadius: 0
            }
          };
        },
        //Restaurant Details Start
        restaurantDetails_RestInfo_GetDirectionsButton: function restaurantDetails_RestInfo_GetDirectionsButton() {
          return {
            variant: "outline",
            borderRadius: 8,
            alignItems: "center",
            justifyContent: "center",
            borderColor: "amenitiesActionButtonsColor",
            alignSelf: "flex-end",
            borderWidth: 1,
            bg: "white",
            _hover: {
              bg: "white"
            },
            _focus: {
              bg: "white"
            },
            _focusVisible: {
              bg: "white"
            },
            py: 2.5,
            px: 2
          };
        },
        //Restaurant Details End
        preorderDineIn: {
          backgroundColor: "#00A9A1"
        },
        // LS tokens
        viewMenuBtn: {
          padding: 0,
          borderWidth: 1,
          borderColor: "secondary.300",
          _text: {
            color: "secondary.300",
            marginY: "11px",
            marginX: 6,
            fontSize: 13,
            fontWeight: 400,
            letterSpacing: -0.3,
            fontFamily: "body",
            lineHeight: 4
          }
        },
        defaultBannerBtn: function defaultBannerBtn() {
          return {
            _web: {
              minW: 134,
              px: 4,
              py: 2
            },
            _ios: {
              px: 2,
              py: 2,
              mt: 0.5
            },
            _android: {
              px: 2,
              py: 2,
              mt: 0.5
            },
            px: 4,
            py: 2,
            bg: "secondary.300"
          };
        },
        viewMenuBtnExternalLink: function viewMenuBtnExternalLink(_ref14) {
          var isLocationSearch = _ref14.isLocationSearch,
              fromAllLocations = _ref14.fromAllLocations;
          return {
            padding: 0,
            borderWidth: 1,
            borderColor: "secondary.300",
            _text: {
              color: "secondary.300",
              marginY: "11px",
              marginX: 6,
              fontSize: 13,
              fontWeight: 400,
              letterSpacing: -0.3,
              fontFamily: "body",
              lineHeight: 4
            },
            bg: isLocationSearch && fromAllLocations ? "transparent" : "secondary.300",
            _hover: {
              bgColor: "secondary.300",
              _text: {
                color: "white"
              }
            },
            _pressed: {
              bgColor: "secondary.300"
            }
          };
        },
        locationListItemButtonBorderRadius: 0,
        locationsInfographicLoginButton: function locationsInfographicLoginButton() {
          return {
            pl: 38,
            pr: 38,
            py: 3,
            backgroundColor: "secondary.300",
            borderRadius: 0,
            _text: {
              color: "locationInfographicModalActionButtonTextColor",
              fontSize: 20,
              fontWeight: 400,
              textTransform: "uppercase",
              textAlign: "center",
              lineHeight: 6
            }
          };
        },
        borderRadiusValue: function borderRadiusValue(_ref15) {
          var radiusValue = _ref15.radiusValue,
              topRadiusValue = _ref15.topRadiusValue,
              bottomRadiusValue = _ref15.bottomRadiusValue;
          return {
            borderRadius: 0,
            borderTopRadius: 0,
            borderBottomRadius: 0
          };
        },
        viewNutritionalVariant: {
          py: 1,
          mb: 2
        },
        confirmBtnBorderRadius: {
          _web: {
            borderRadius: 8
          },
          borderRadius: 0
        },
        joinWaitlist_Header_LoginButton: function joinWaitlist_Header_LoginButton() {
          return {
            _text: {
              fontSize: 14,
              color: "#86714D",
              fontWeight: 400
            },
            borderColor: "#86714D",
            borderRadius: 0,
            px: "17px",
            py: "10px",
            _web: {
              px: {
                base: "10px",
                lg: "17px"
              },
              py: {
                base: "6px",
                lg: "10px"
              }
            },
            _focus: {
              backgroundColor: "#000000"
            },
            bg: "transparent",
            borderWidth: 1
          };
        },

        /** Button: Private Dining Start */
        pd_Header_LoginButton: function pd_Header_LoginButton() {
          return {
            _text: {
              fontSize: 14,
              color: "#86714D",
              fontWeight: 400,
              textTransform: "uppercase"
            },
            px: "17px",
            py: "10px"
          };
        },
        pd_request_eventDetails_confirmCTA: function pd_request_eventDetails_confirmCTA() {
          return {
            borderRadius: 0,
            backgroundColor: "#86714D",
            padding: 0,
            marginTop: 4,
            marginX: 5,
            marginBottom: 3,
            h: 12,
            _text: {
              color: "white",
              letterSpacing: -0.5,
              fontWeight: "400",
              fontSize: 18,
              marginTop: 3,
              marginBottom: 3,
              lineHeight: 6,
              textAlign: "center",
              textTransform: "uppercase"
            },
            _pressed: {
              opacity: 0.8
            }
          };
        },
        pd_requestForm_Footer_cancalCTA: function pd_requestForm_Footer_cancalCTA() {
          return {
            bg: "none",
            border: 2,
            borderRadius: 0,
            borderColor: "#86714D",
            _text: {
              fontSize: 16,
              color: "#86714D"
            },
            _hover: {
              bg: "none"
            }
          };
        },
        pd_requestForm_Footer_ContinueCTA: function pd_requestForm_Footer_ContinueCTA() {
          return {
            px: 12,
            _text: {
              fontWeight: 400,
              fontSize: 16,
              color: "white"
            },
            bg: "#86714D",
            borderRadius: 0
          };
        },
        pd_confirmation_backToHomeCTA: {
          bg: "none",
          border: 2,
          borderRadius: 0,
          borderColor: "#86714D",
          px: 12,
          mt: {
            md: 5
          },
          _text: {
            fontSize: 16,
            color: "#86714D",
            fontFamily: "Lato-Regular"
          },
          _hover: {
            bg: "none"
          }
        },
        pd_landing_stickyFooter_pdReqCTA: {
          py: 2.5,
          width: {
            base: "100%",
            md: "469px"
          },
          height: 12,
          style: {
            background: "linear-gradient(102deg, #B09C79 20.73%, #86714D 65.86%)"
          }
        },
        confirmAndAddToCartButton: {
          style: {
            background: "linear-gradient(102deg, #B09C79 20.73%, #86714D 65.86%)"
          }
        },

        /** Button: Private Dining End */
        ErrorDialogOKButton: {
          _ios: {
            borderRadius: 0
          },
          _android: {
            borderRadius: 0
          },
          bg: "secondary.300",
          _pressed: {
            bg: "secondary.300"
          },
          _hover: {
            bg: "#7A502D"
          }
        },
        myAccount_paymentOptions_gc_bs_deleteCTA: {
          width: "100%",
          mb: 5,
          borderWidth: 1,
          borderColor: "#86714D",
          _hover: {
            backgroundColor: "background.300"
          },
          _focus: {
            backgroundColor: "background.300"
          },
          py: 5,
          _text: {
            fontSize: "md",
            fontWeight: 400,
            lineHeight: 5,
            textTransform: "uppercase",
            color: "#86714D"
          },
          _web: {
            width: {
              base: "100%",
              md: "30%"
            },
            py: {
              base: 5,
              md: 2.5
            },
            mb: {
              base: 5,
              md: 0
            },
            style: {
              background: "white"
            }
          }
        },
        editProfileFullBottomButton: {
          _web: {
            style: {
              background: "linear-gradient(102deg, #B09C79 20.73%, #86714D 65.86%)"
            }
          }
        },
        orderHistoryReorderFullBottomButton: {
          _web: {
            style: {
              background: "linear-gradient(102deg, #B09C79 20.73%, #86714D 65.86%)"
            }
          }
        },
        EClubUnsubscribeSubmitButton: {
          alignSelf: {
            md: "flex-start"
          },
          _text: {
            color: "white",
            fontWeight: 300
          },
          bg: "secondary.300",
          _pressed: {
            bg: "secondary.300"
          },
          _hover: {
            bg: "#7A502D"
          }
        },
        noPrefLocationScreen_selectCTA_Button: {
          width: "300px",
          py: 3.5,
          mt: 10,
          bg: "secondary.300",
          _web: {
            style: {
              background: "linear-gradient(102deg, #B09C79 20.73%, #86714D 65.86%)"
            }
          },
          mx: "auto"
        },
        orderHistory_emptyScreenCTA_button: {
          width: {
            base: "200px",
            md: "256px"
          },
          py: {
            base: 2.5,
            md: 3.5
          },
          mt: {
            base: 10,
            md: 10
          },
          bg: "secondary.300",
          _web: {
            style: {
              background: "linear-gradient(102deg, #B09C79 20.73%, #86714D 65.86%)"
            }
          }
        },
        addEditCreditCard_delete_button: {
          flex: 1,
          mr: 2,
          _hover: {
            backgroundColor: "background.300"
          },
          _focus: {
            backgroundColor: "background.300"
          },
          py: 5,
          _text: {
            fontSize: "md",
            fontWeight: 400,
            lineHeight: 5,
            textTransform: "uppercase",
            color: "secondary.300"
          },
          bg: "transparent",
          borderColor: "secondary.300",
          borderWidth: 1
        },
        addEditCreditCard_update_button: {
          flex: 1,
          ml: 2,
          py: 5,
          _text: {
            fontSize: 16,
            lineHeight: 6,
            letterSpacing: -0.5,
            fontWeight: 400,
            textAlign: "center",
            color: "addCardFooterButtonText"
          },
          bg: "secondary.300",
          _web: {
            style: {
              background: "linear-gradient(102deg, #B09C79 20.73%, #86714D 65.86%)"
            }
          }
        },
        myAccount_paymentOptions_deleteGiftCard_confirmationCTAStyles: {
          _web: {
            style: {
              background: "linear-gradient(102deg, #B09C79 20.73%, #86714D 65.86%)"
            }
          },
          _text: {
            py: 1
          }
        },
        myAccount_paymentOptions_deleteCreditCard_confirmationCTAStyles: {
          _web: {
            style: {
              background: "linear-gradient(102deg, #B09C79 20.73%, #86714D 65.86%)"
            }
          }
        },
        myAccount_paymentOptions_giftCardDetails_refreshCTA: {
          mb: 5,
          paddingX: 2,
          width: "60%",
          borderColor: "gcBalanceRefreshBorderTextColor",
          mr: 1,
          _web: {
            width: {
              base: "45%",
              md: "30%"
            }
          },
          _text: {
            color: "gcBalanceRefreshBorderTextColor",
            fontWeight: 400
          },
          bg: "#FFFFFF"
        },
        previousOrderItemAddCta: {
          borderRadius: {
            base: "md",
            md: "lg"
          },
          bg: "white",
          borderColor: "reOrderAddBtnBorder",
          borderWidth: 1
        }
      }
    },
    Tooltip: {
      baseStyle: {
        borderRadius: 8,
        padding: 3,
        _text: {
          fontSize: 12,
          fontWeight: 500
        }
      }
    },
    Accordion: {
      baseStyle: {
        borderWidth: 0,
        borderColor: "transparent",
        borderRadius: 0
      },
      variants: {
        skuSelectorAccordion: function skuSelectorAccordion(_ref16) {
          var isMandatory = _ref16.isMandatory;
          return {
            borderRadius: 0
          };
        },
        menuItemAccordion: function menuItemAccordion() {
          return {
            borderRadius: 0
          };
        }
      }
    },
    ModalContent: {
      baseStyle: {
        rounded: 0
      },
      variants: {
        pd_cancelModal: {
          alignItems: "center",
          justifyContent: "center",
          maxWidth: "335px",
          py: 8,
          px: 6,
          borderRadius: 0,
          backgroundColor: "#F0ECE6"
        },
        pd_callRestModal: {
          maxW: "335px",
          py: 8,
          px: {
            base: 5,
            md: 7
          },
          borderRadius: 0,
          backgroundColor: "#F6F4E0"
        },
        borderRadiusValue: function borderRadiusValue(_ref17) {
          var radiusValue = _ref17.radiusValue,
              topRadiusValue = _ref17.topRadiusValue,
              bottomRadiusValue = _ref17.bottomRadiusValue;
          return {
            borderRadius: 0,
            borderTopRadius: 0,
            borderBottomRadius: 0
          };
        },
        editFieldsConfirmationModal: {
          borderRadius: 0,
          p: 12,
          bgColor: "#FFFFFF"
        },
        editFieldsSuccessModal: {
          borderRadius: 0,
          p: 12,
          maxWidth: {
            md: "588"
          },
          bgColor: "#FFFFFF"
        },
        myAccount_paymentOptions_deleteGiftCard_modalContentStyles: {
          p: 0,
          borderRadius: 0,
          bgColor: "#FFFFFF"
        },
        myAccount_paymentOptions_giftCardLimitReached_modalContentStyles: {
          width: {
            md: "370px"
          },
          p: 0,
          borderRadius: 12
        }
      }
    },
    ModalHeader: {
      variants: {
        errorDialogModalHeader: {
          roundedTop: 0
        }
      }
    },
    ModalBody: {
      variants: {
        smartRecommendationModalModalBody: {
          _ios: {
            width: "100%",
            minHeight: "100%",
            justifyContent: "center"
          },
          _android: {
            width: "100%",
            minHeight: "100%",
            justifyContent: "center"
          }
        },
        myAccount_paymentOptions_deleteGiftCard_modalBodyStyles: {
          bg: "#FFFFFF",
          borderRadius: 0,
          p: {
            base: 6,
            md: 10
          },
          pt: 10
        },
        myAccount_paymentOptions_giftCardsLimitReached_modalBodyStyles: {
          alignItems: "center",
          justifyContent: "center",
          p: 6,
          borderRadius: 12,
          bg: "#FFFFFF",
          pt: 10,
          _web: {
            pt: 6
          }
        }
      }
    },
    AccordionSummary: {
      baseStyle: {
        borderTopWidth: 0,
        borderTopColor: "transparent",
        p: 0,
        _hover: {
          bg: "transparent"
        },
        _expanded: {
          bg: "transparent",
          borderBottomColor: "transparent",
          _text: {
            color: "white"
          }
        },
        _disabled: {
          bg: "transparent"
        }
      },
      variants: {
        skuSelectorSummary: function skuSelectorSummary(_ref18) {
          var isMandatory = _ref18.isMandatory;
          return {
            borderTopRadius: 0
          };
        }
      }
    },
    AccordionDetails: {
      variants: {
        skuSelectorDetails: function skuSelectorDetails(_ref19) {
          var isMandatory = _ref19.isMandatory;
          return {
            borderBottomRadius: 0
          };
        },
        menuItemDetails: function menuItemDetails(_ref20) {
          var isDefaultExpanded = _ref20.isDefaultExpanded;
          return {
            borderBottomRadius: isDefaultExpanded ? 0 : undefined
          };
        }
      }
    },
    Stack: {
      variants: {
        skuSelectorItem: {
          borderRadius: 0
        },
        //Restaurant Details Start
        restaurantDetails_CurrentStatusAndWaitlist_AvailabilityStack: {
          alignItems: {
            lg: "flex"
          },
          _ios: {
            marginTop: 3
          },
          _android: {
            marginTop: 3
          },
          direction: {
            base: "row",
            lg: "column"
          },
          justifyContent: "space-between",
          space: "md"
        },
        restaurantDetails_CurrentStatusAndWaitlist_WaitTimeStack: {
          _ios: {
            marginRight: 4
          },
          _android: {
            marginRight: 4
          },
          direction: {
            base: "column",
            lg: "row"
          },
          alignItems: "center",
          space: {
            lg: "sm"
          }
        },
        restaurantDetails_RestInfo_AddressLink_Stack: {
          direction: {
            base: "column",
            lg: "row"
          }
        },
        //Restaurant Details End
        EClubUnsubscribeFormContainer: {
          direction: {
            base: "column",
            md: "row"
          },
          space: {
            base: 4,
            md: 8
          },
          maxW: "500"
        },

        /** Stack: Private Dining Start */
        pd_landing_stickyFooter_container: {
          direction: {
            base: "column-reverse",
            lg: "row"
          },
          bgColor: "#FFFFFF",
          alignItems: "center",
          justifyContent: "space-between",
          py: {
            base: 3,
            md: 7
          },
          px: {
            base: 5,
            md: 32
          },
          shadow: 14
        }
        /** Stack: Private Dining End */

      }
    },
    Input: {
      baseStyle: {
        rounded: 0,
        fontFamily: "Lato-Regular"
      },
      variants: {
        menuSearchInputContainer: {
          borderRadius: 0
        },

        /** Input: Private Dining Start */
        pd_request_eventDetails_noOfGuestinput: {
          borderRadius: 0,
          fontFamily: "Lato-Regular"
        },
        pd_request_eventDetails_SplRequest: {
          borderRadius: 0
        },
        pd_request_contactDetails_input: {
          borderRadius: 0,
          fontFamily: "Lato-Regular"
        },

        /** Input: Private Dining End */
        borderRadiusValue: function borderRadiusValue(_ref21) {
          var radiusValue = _ref21.radiusValue,
              topRadiusValue = _ref21.topRadiusValue,
              bottomRadiusValue = _ref21.bottomRadiusValue;
          return {
            borderRadius: 0,
            borderTopRadius: 0,
            borderBottomRadius: 0,
            _focus: {
              borderColor: "#86714d"
            }
          };
        },
        myAccountInputForm: {
          fontFamily: "Lato-Regular"
        }
      }
    },
    Divider: {
      variants: {
        restaurantDetails_RestInfo_Divider: {
          mx: 5
        },
        jwcFooterBlockDivider: {
          height: 4,
          backgroundColor: "#8A8585",
          orientation: "vertical",
          mx: 3.5,
          w: 0.4
        }
      }
    },
    Text: {
      defaultProps: {
        _ios: {
          paddingBottom: 1
        }
      },
      variants: {
        myAccount_button_editConfirmation_text: {
          fontWeight: 400
        },
        myAccount_button_cta_weight: 400,
        createAccountSelectPrefLocationText: {
          color: "secondary.300",
          lineHeight: 6,
          fontSize: 18,
          fontWeight: 300,
          ml: 1,
          mr: {
            base: 8,
            md: 8
          }
        },

        /* RESERVATION */
        reservationListHeaderUpcoming: {
          fontSize: 18,
          fontWeight: 800,
          pb: 4
        },
        reservationCancelSuccessHeader: {
          fontSize: 20,
          fontWeight: 500,
          color: "#303030",
          textAlign: "center"
        },
        reservationPoliteDressText: {
          fontSize: 14,
          fontWeight: 300,
          pt: 2
        },
        reservationMakeNewReservationCTA: {
          fontWeight: 500,
          fontSize: 20,
          color: "primary.100",
          textAlign: "center"
        },
        reservationCancelSuccessBody: {
          fontSize: 16,
          fontWeight: 200,
          color: "#606060",
          lineHeight: 5,
          textAlign: "center"
        },
        joinWaitlist_Header_Logout: function joinWaitlist_Header_Logout() {
          return {
            textAlign: "end",
            textTransform: "uppercase",
            fontSize: 16,
            mt: 1,
            color: "#B7A077"
          };
        },
        joinWaitlist_Header_MyAcc: function joinWaitlist_Header_MyAcc() {
          return {
            textAlign: "end",
            textTransform: "uppercase",
            fontSize: 16,
            mt: 1,
            color: "#B7A077"
          };
        },
        joinWaitlist_Header_MyAcc_Mobile: function joinWaitlist_Header_MyAcc_Mobile() {
          return {
            fontSize: 8,
            mt: 1,
            color: "#B7A077"
          };
        },
        reservtionPredferedLocationCardAddress: {
          fontWeight: "400",
          fontSize: 12,
          lineHeight: 4,
          color: "#303030"
        },
        reservationConfirmationDateTimeSizeText: {
          fontWeight: 500,
          lineHeight: 5,
          fontSize: 14
        },
        reservationConfirmationRestaurantName: {
          fontSize: {
            base: 14,
            md: 16
          },
          fontWeight: 400,
          lineHeight: 5,
          flexWrap: "wrap"
        },
        reservationConfirmationLocationAddress: {
          fontSize: {
            base: 12,
            md: 14
          },
          fontWeight: 200,
          lineHeight: 5,
          flexWrap: "wrap"
        },
        reservationConfirmationDirectionsText: {
          fontWeight: 500
        },
        reservationListCardDirections: {
          fontWeight: 700,
          lineHeight: 12,
          color: "primary.100",
          fontSize: 12
        },
        reservationListCardLocationText: {
          fontWeight: 400,
          fontSize: 11,
          color: "#303030",
          lineHeight: 5
        },
        reservationListCardRestName: {
          fontWeight: 500,
          fontSize: 12,
          color: "#020001",
          lineHeight: 5
        },
        reservationListCardRestAddress: {
          fontSize: 12,
          fontWeight: 400,
          color: "#303030",
          lineHeight: 5
        },
        reservationsSelectFromAvailableSlotsTitle: {
          fontWeight: 600,
          color: "#303030"
        },
        reservationsReviewReservationsText: {
          fontWeight: 600
        },
        reservationsChangeLocationChangeText: {
          color: "#86714D",
          textTransform: "uppercase",
          fontSize: {
            base: 12,
            md: 14
          },
          fontWeight: 500
        },
        reservationThankyouConfirmationText: {
          fontSize: 18,
          fontWeight: 600,
          pb: 2,
          color: "primary.100",
          textAlign: "center"
        },
        reservationThankyouConfirmationSubText: {
          fontSize: 16,
          fontWeight: 600,
          textAlign: "center"
        },
        reservationSelectGuestText: {
          fontSize: 14,
          fontWeight: 300
        },
        reservationLocationCardHeader: {
          fontSize: {
            base: 14,
            md: 16
          },
          lineHeight: 5,
          fontWeight: {
            base: 500,
            md: 600
          },
          color: "#000000",
          _ios: {
            fontSize: 15
          },
          _android: {
            fontSize: 15
          }
        },
        reservationLocationCardAddress: {
          lineHeight: 5,
          fontSize: {
            base: 10,
            md: 14
          },
          fontWeight: 300,
          color: "#000000",
          _ios: {
            fontSize: 14
          },
          _android: {
            fontSize: 14
          }
        },
        reservationLocationModalHeaderText: {
          color: Platform.OS === "web" ? "#000000" : "#FFFFFF",
          fontSize: 20,
          fontWeight: 300,
          textAlign: "center"
        },
        reservationFilterStateHeading: {
          fontSize: 20,
          color: "#2A2C25",
          fontWeight: 600,
          ml: {
            base: 0,
            md: 4
          },
          mt: {
            base: 4,
            md: 0
          },
          textTransform: "capitalize"
        },
        reservationTabsText: function reservationTabsText(_ref22) {
          var isActive = _ref22.isActive;
          return {
            textAlign: "center",
            color: isActive ? "#000000" : "#000000",
            fontSize: {
              base: 18,
              md: 20
            },
            fontWeight: 400,
            mt: 2
          };
        },
        reservationDetailsHeaderText: {
          px: 5,
          fontSize: {
            base: 16,
            md: 20
          },
          fontWeight: 500,
          lineHeight: 5,
          color: "#303030"
        },
        reservationPickerTopLabelText: {
          pb: 2,
          noOfLines: 1,
          fontSize: 12,
          color: "#000000",
          _web: {
            pb: 0,
            mb: {
              base: 1,
              md: 0
            }
          }
        },
        reservationPickerLabelText: {
          pt: 2,
          noOfLines: 1,
          fontSize: 12,
          _web: {
            pt: 0,
            mt: 1,
            width: "min-content",
            borderBottomWidth: 1
          }
        },
        reservationAddDetailsHeading: {
          px: 5,
          fontSize: {
            base: 16,
            md: 20
          },
          fontWeight: 500,
          lineHeight: 5,
          color: "#303030"
        },

        /* RESERVATION */
        advanceOrderMessageText: {
          fontWeight: 400,
          color: "#FF0000",
          fontSize: [12, 12, 14, 14, 14]
        },
        noCheckHeaderText: {
          fontFamily: "body",
          fontWeight: 500,
          fontSize: 22,
          lineHeight: 26,
          color: "#303030"
        },
        errorDialogBoxTitle: {
          fontSize: "lg",
          fontWeight: 400
        },
        OnboardingScreenTitleTextColor: {
          color: "secondary200Mobile",
          _ios: {
            color: "#4E311D",
            fontWeight: "800"
          },
          _android: {
            color: "#4E311D",
            fontWeight: "800"
          }
        },
        //checkDetails Start
        cdHeaderText: {
          fontSize: 16,
          lineHeight: 5,
          _web: {
            letterSpacing: "-0.23px"
          },
          letterSpacing: "-0.23"
        },
        cdCheckItemsText: {
          fontSize: 16,
          lineHeight: 5,
          _web: {
            letterSpacing: "-0.23px"
          },
          letterSpacing: "-0.23"
        },
        cdCheckDetailsModifierText: {
          fontSize: 14,
          lineHeight: 4,
          _web: {
            letterSpacing: "-0.23px"
          },
          letterSpacing: "-0.23"
        },
        cdBillingTileText: {
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 400,
          _web: {
            letterSpacing: "-0.23px"
          },
          letterSpacing: "-0.23"
        },
        cdTableDetailTileText: {
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 400,
          _web: {
            letterSpacing: "-0.23px"
          },
          letterSpacing: "-0.23"
        },
        successDialogTitleText: {
          lineHeight: 4
        },
        successDialogDescText: {
          _ios: {
            lineHeight: 4
          },
          _android: {
            lineHeight: 4
          }
        },
        orderConfirmationMobileNumberText: {
          lineHeight: 3,
          fontSize: {
            base: 15,
            lg: 14
          }
        },
        //checkDetails End
        // checkSummaryStart
        paymentCompleteText: {
          fontSize: 18,
          fontWeight: 500,
          lineHeight: 6,
          color: "secondary200Mobile"
        },
        checkSummaryTitle: {
          fontSize: 22,
          color: "secondary200Mobile",
          fontWeight: 500,
          fontFamily: "headingSecondary",
          lineHeight: 6
        },
        checkSummaryBodyText: {
          fontSize: 14,
          fontWeight: 400,
          lineHeight: 5,
          color: "#303030"
        },
        checkSummaryEmailText: {
          fontSize: 14,
          fontWeight: 500,
          lineHeight: 5,
          color: "#020001"
        },
        checkSummarySurveyText: {
          color: "secondary200Mobile",
          fontWeight: 500,
          lineHeight: 6,
          fontSize: 14
        },
        checkSummaryPriceText: {
          fontSize: 14,
          fontWeight: 400,
          lineHeight: 5,
          color: "#303030"
        },
        totalPriceText: {
          fontSize: 14,
          fontWeight: 500,
          lineHeight: 6,
          color: "secondary200Mobile"
        },
        preAppliedDeductionPrice: {
          fontSize: 16,
          fontWeight: 400,
          lineHeight: 5
        },
        // checkSummaryEnds
        paymentTileTitle: {
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 500,
          color: "orderTotalTextColor"
        },
        paymentTilePrice: {
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 500,
          color: "#55111E"
        },
        paymentMethodsText: {
          fontSize: 18,
          lineHeight: 5,
          fontWeight: 500,
          color: "#303030"
        },
        OrderInfoBannerCartIconText: {
          pt: 1
        },
        LoginHeaderText: {
          pt: 1
        },
        checkoutTopLabelText: {
          pt: 1
        },
        emailReceiptText: {
          fontSize: 20,
          lineHeight: 5,
          fontWeight: 500,
          fontFamily: "headingSecondary",
          color: "#55111E"
        },
        addGratuityText: {
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 300,
          color: "#303030"
        },
        camAccessText: {
          color: "#737373",
          lineHeight: 6,
          fontSize: 14
        },
        camAccessLinkText: {
          textDecoration: "underline",
          color: "primary.100"
        },
        gratuityTipNumbers: {
          fontSize: 10,
          color: "themeGrey",
          lineHeight: 3
        },
        snackBarText: {
          fontSize: 18,
          lineHeight: 5,
          fontWeight: 400,
          color: "#000000",
          _web: {
            color: "secondary200Mobile"
          }
        },
        snackBarPrice: {
          fontSize: 18,
          lineHeight: 5,
          fontWeight: 400,
          color: "secondary.300"
        },
        stepsToMobilePayHeader: {
          fontFamily: "headingSecondary",
          fontSize: 28,
          color: "#303030",
          textTransform: "uppercase",
          ml: 5
        },
        mobilePayStepsHeading: {
          fontFamily: "body",
          fontWeight: 500,
          fontSize: 16,
          mt: 4,
          ml: 5,
          color: "#782434",
          _web: {
            letterSpacing: "-0.29px"
          },
          letterSpacing: "-0.29"
        },
        mobilePayStepsBody: {
          fontFamily: "body",
          fontWeight: 200,
          fontSize: 11,
          color: "#303030"
        },
        mobilePayVisitLink: {
          display: "block",
          position: "absolute",
          fontSize: 12,
          lineHeight: 12,
          opacity: "0.4",
          color: "#1B1B1B",
          bottom: "42%",
          left: {
            base: "36%",
            sm: "36%",
            md: "42%",
            lg: "45%"
          },
          textAlign: "center"
        },
        remoteCheckinNoteText: {
          _android: {
            lineHeight: 5
          },
          _ios: {
            lineHeight: 5
          },
          mt: 3,
          _web: {
            fontSize: "14px"
          },
          fontSize: "sm",
          fontWeight: 300,
          textAlign: "center"
        },
        //JWC STARTS
        jwcLeaveTheLineCancelBtn: {
          fontSize: 16,
          fontWeight: 400,
          color: "primary.100"
        },
        jwcLeaveTheLineContinueBtn: {
          fontSize: 16,
          fontWeight: 400
        },
        jwcLeaveTheLineModalTitle: {
          fontSize: 16,
          color: "#303030",
          fontFamily: "headingSecondary",
          textTransform: "uppercase"
        },
        jwcLeaveTheLineModalBody: {
          fontWeight: 300,
          fontSize: {
            base: 18,
            lg: 14
          },
          lineHeight: {
            base: 25,
            lg: 18
          },
          color: {
            base: "#606060",
            lg: "#020001"
          }
        },
        jwcEstWaitTimePrefix: {
          textAlign: "center",
          fontSize: 14,
          fontWeight: 300,
          lineHeight: 6,
          color: "#54301A"
        },
        jwcEstWaitTime: {
          lineHeight: 10,
          fontWeight: 400,
          textAlign: "center",
          fontSize: 32,
          color: "#54301A"
        },
        jwcRestDetails: {
          color: "#80603D",
          lineHeight: 4,
          fontSize: 12,
          fontWeight: 300
        },
        jwcRestName: {
          color: "#80603D",
          fontSize: 15,
          fontWeight: 400
        },
        jwcHowItWorksText: {
          fontSize: 14,
          fontWeight: 300,
          color: "white",
          textAlign: "center"
        },
        jwcOrderWhileYouWaitText: {
          textAlign: "center",
          color: {
            base: "white",
            lg: "#A2402A"
          },
          fontSize: 16,
          fontWeight: 400
        },
        qualityStoryCtaText: {
          textAlign: "center",
          color: {
            base: "#80603D",
            lg: "#80603D"
          },
          fontSize: 16,
          fontWeight: 400
        },
        jwcOrderAheadText: {
          fontSize: {
            base: 22,
            lg: 28
          },
          fontWeight: 600,
          color: "white",
          lineHeight: 32,
          textAlign: "center"
        },
        qualityStoryDescText: {
          fontSize: {
            base: 21,
            lg: 28
          },
          fontWeight: 600,
          color: "white",
          lineHeight: 32,
          textAlign: "center"
        },
        jwcHeaderDirectionsText: {
          color: "#A2402A",
          fontSize: 14
        },
        jwcHeaderLocationName: {
          color: "#303030",
          fontSize: 16,
          fontWeight: 300
        },
        jwcViewPdfMenu: {
          color: "#303030",
          fontSize: 14,
          fontWeight: 300
        },
        jwcLeaveTheLine: {
          color: "#303030",
          fontSize: 14,
          fontWeight: 300
        },
        jwcWaitTimeVary: {
          textAlign: "center",
          fontWeight: 300,
          fontSize: 18,
          color: " #2A2C25",
          lineHeight: 24
        },
        jwcPartySizeNumber: {
          fontWeight: 400,
          fontSize: 17,
          color: "#54301A"
        },
        jwcPartySize: {
          fontWeight: 300,
          fontSize: 17,
          color: "#54301A"
        },
        jwcTitle: {
          textAlign: "center",
          fontSize: 24,
          fontWeight: 500,
          color: "#54301A",
          mt: 6
        },
        jwcTitleText: {
          textAlign: "center",
          fontSize: 24,
          fontWeight: 500,
          color: "#54301A",
          mb: 4,
          mx: 1,
          lineHeight: 7,
          _ios: {
            mx: 2
          },
          _android: {
            mx: 2
          }
        },
        waitListFooterText: {
          marginTop: 2,
          fontSize: 14,
          fontWeight: 300,
          maxWidth: 74,
          textAlign: "center"
        },
        refreshIconText: {
          textTransform: "uppercase",
          fontSize: 12,
          color: "#A2402A",
          lineHeight: 14
        },
        waitlistCheckbackSoonTitle: {
          color: "#54301A",
          fontWeight: 300,
          fontSize: 20,
          lineHeight: 20
        },
        waitlistCheckbackSoonBody: {
          color: "#606060",
          pt: 4,
          fontWeight: 300,
          fontSize: 16,
          lineHeight: 20
        },
        checkinSuccessNoteTitleText: {
          color: "#FFFFFF",
          pt: 3,
          fontSize: 22,
          lineHeight: 42,
          _web: {
            letterSpacing: "-0.5px"
          },
          letterSpacing: "-0.5"
        },
        checkinSuccessNoteBodyText: {
          color: "#FFFFFF",
          pt: 1,
          maxWidth: 173,
          textAlign: "center",
          fontWeight: 300,
          fontSize: 14,
          lineHeight: 16,
          _web: {
            letterSpacing: "-0.5px"
          },
          letterSpacing: "-0.5"
        },
        leaveTheLineText: {
          fontWeight: 300,
          fontSize: 14,
          lineHeight: 16
        },
        leaveTheLineLinkText: {
          fontWeight: 300,
          fontSize: 14,
          lineHeight: 16
        },
        leaveWaitlistErrorModal: {
          fontWeight: 300,
          fontSize: 18,
          lineHeight: 25,
          _web: {
            letterSpacing: "-1px"
          },
          letterSpacing: "-1",
          color: "#606060"
        },
        waitlistErrorTitle: {
          fontWeight: 500,
          fontSize: 24,
          lineHeight: 24,
          _web: {
            letterSpacing: "-1px"
          },
          letterSpacing: "-1",
          color: "#2A2C25"
        },
        waitlistErrorBody: {
          fontWeight: 300,
          fontSize: 20,
          lineHeight: 28,
          _web: {
            letterSpacing: "-1px"
          },
          letterSpacing: "-1",
          color: "#606060",
          mt: 2,
          textAlign: "center",
          maxWidth: 253
        },
        waitTimeText: {
          fontWeight: 400,
          fontSize: 14,
          lineHeight: 16,
          mb: 2
        },
        waitTimeMins: {
          fontWeight: 400,
          fontSize: 32,
          lineHeight: 36
        },
        remoteCheckinWaitTimeThankYou: {
          fontSize: 24,
          fontWeight: 600,
          _web: {
            letterSpacing: "-0.3px"
          },
          letterSpacing: "-0.3"
        },
        remoteCheckinWaitTimePartySize: {
          fontSize: 14,
          fontWeight: 300,
          lineHeight: 14
        },
        remoteCheckinWaitTimeNote: {
          fontSize: 14,
          fontWeight: 100,
          lineHeight: 4
        },
        confirmAndAddToCart: {
          textTransform: "uppercase",
          color: "white",
          fontWeight: 400
        },
        unavailableTextWeight: {
          fontWeight: 400
        },
        startingAtPrice: function startingAtPrice(_ref23) {
          var isUnavailable = _ref23.isUnavailable;
          return {
            color: isUnavailable ? "unavailablePriceTextColor" : "#000000",
            fontSize: 16,
            fontWeight: 400
          };
        },
        startingAtText: function startingAtText(_ref24) {
          var isUnavailable = _ref24.isUnavailable;
          return {
            color: isUnavailable ? "unavailablePriceTextColor" : "#000000",
            fontSize: 16,
            fontWeight: 100,
            fontFamily: "heading"
          };
        },
        categoryText: function categoryText(_ref25) {
          var isActive = _ref25.isActive;
          return {
            fontSize: {
              base: "sm",
              md: "sm"
            },
            fontWeight: isActive ? "600" : "400"
          };
        },
        noThanksText: {
          fontFamily: "heading",
          fontSize: "xl",
          textDecoration: "underline",
          textDecorationColor: "white",
          textAlign: "center",
          color: "white",
          _web: {
            fontSize: "24px",
            mt: 5
          },
          _ios: {
            mt: 0,
            fontSize: "16px",
            lineHeight: 8,
            letterSpacing: "-0.37",
            fontWeight: "400"
          },
          _android: {
            mt: 0,
            fontSize: "16px",
            lineHeight: 8,
            letterSpacing: "-0.37",
            fontWeight: "400"
          }
        },
        youMayLikeText: {
          fontFamily: "headingSecondary",
          _web: {
            fontSize: "28px"
          },
          fontSize: "xl"
        },
        orderTypeText: {
          fontSize: "sm",
          fontWeight: "300"
        },
        globalBannerCareer: function globalBannerCareer() {
          return {
            textTransform: "uppercase",
            fontWeight: 100,
            color: "#ffeec2",
            fontSize: {
              base: "10px",
              md: "10px",
              lg: "13px"
            },
            right: 0
          };
        },
        menuItemNameWeight: function menuItemNameWeight(_ref26) {
          var isFromSmartRecsOrFrequentlyOrdered = _ref26.isFromSmartRecsOrFrequentlyOrdered,
              recommendedInMenuDetails = _ref26.recommendedInMenuDetails;
          return {
            fontWeight: 400,
            fontSize: [14, 14, 14, isFromSmartRecsOrFrequentlyOrdered ? 14 : 20],
            _ios: {
              minHeight: recommendedInMenuDetails ? 16 : null
            },
            _android: {
              minHeight: recommendedInMenuDetails ? 16 : null,
              lineHeight: 16
            },
            color: "#000000"
          };
        },
        listDescriptionText: function listDescriptionText() {
          return {
            _web: {
              fontSize: 13,
              fontWeight: 200,
              fontFamily: "heading",
              fontStyle: "italic"
            }
          };
        },
        categoryFontSize: function categoryFontSize() {
          return {
            fontSize: [24, 24, 36],
            fontWeight: 500,
            fontFamily: "heading"
          };
        },
        subCategoryFontSize: function subCategoryFontSize() {
          return {
            fontSize: [18, 18, 28],
            fontFamily: "heading",
            fontWeight: 400
          };
        },
        subSubCategoryFontSize: function subSubCategoryFontSize() {
          return {
            fontSize: ["md", "md", "xl"]
          };
        },
        locationText: {
          color: "#86714d",
          fontSize: "xs",
          fontFamily: "body"
        },
        phoneNumberText: {
          color: "#86714d",
          fontSize: "xs",
          fontFamily: "body"
        },
        btnText: {
          color: "#86714d",
          fontFamily: "heading"
        },
        headerText: {
          color: "#86714d"
        },
        cartItemCancelText: {
          fontSize: 13,
          lineHeight: 4,
          textTransform: "uppercase",
          color: "secondary.300",
          fontWeight: 400
        },
        checkoutText: {
          fontSize: "xl",
          lineHeight: 6,
          fontWeight: 400,
          color: "white",
          textTransform: "uppercase"
        },
        addMoreItemsText: {
          fontSize: "md",
          fontWeight: 400,
          lineHeight: 5,
          textTransform: "uppercase",
          color: "secondary.300"
        },
        checkoutPriceText: {
          fontSize: 22,
          lineHeight: 5,
          fontWeight: 400,
          color: "white"
        },
        menuItemDetailsPropertyAccordionHeading: function menuItemDetailsPropertyAccordionHeading(_ref27) {
          var isMandatory = _ref27.isMandatory;
          return {
            _web: {
              fontSize: {
                base: "lg",
                md: "24"
              },
              letterSpacing: "-0.3px"
            },
            _android: {
              letterSpacing: 1
            },
            _ios: {
              letterSpacing: 1
            },
            lineHeight: {
              base: 5,
              md: 7
            },
            fontWeight: 400,
            color: isMandatory ? "white" : "menuDetailAccordionTextColor",
            fontFamily: "headingSecondary",
            textTransform: "uppercase"
          };
        },
        skuMenuItemDetailsPropertyAccordionHeading: function skuMenuItemDetailsPropertyAccordionHeading(_ref28) {
          var isMandatory = _ref28.isMandatory;
          return {
            _web: {
              fontSize: {
                base: "lg",
                md: "24"
              },
              letterSpacing: "-0.3px"
            },
            letterSpacing: "-0.3",
            lineHeight: {
              base: 5,
              md: 7
            },
            fontWeight: 400,
            color: isMandatory ? "white" : "menuDetailAccordionTextColor",
            fontFamily: "headingSecondary",
            textTransform: "uppercase"
          };
        },
        menuItemDetailsQuestionVarient: function menuItemDetailsQuestionVarient(_ref29) {
          var isMobile = _ref29.isMobile;
          return {
            _web: {
              fontSize: {
                base: "2xl",
                md: "md"
              },
              letterSpacing: "-0.3px"
            },
            letterSpacing: "-0.3",
            lineHeight: {
              base: 7,
              md: 5
            },
            fontWeight: {
              base: 300,
              md: 500
            },
            color: "themeTextColor",
            textTransform: isMobile && "uppercase",
            fontFamily: isMobile ? "headingSecondary" : "body"
          };
        },
        menuItemDetailsIsRequiredMark: function menuItemDetailsIsRequiredMark() {
          return {
            fontSize: {
              base: "xs",
              md: "md"
            },
            _web: {
              letterSpacing: "-0.3px"
            },
            letterSpacing: "-0.3",
            fontWeight: 300,
            color: "white",
            lineHeight: {
              base: 4,
              md: 5
            },
            alignSelf: "center"
          };
        },
        menuItemDetailsPropertyAccordionRightText: function menuItemDetailsPropertyAccordionRightText() {
          return {
            fontSize: {
              base: "xs",
              md: "sm"
            },
            lineHeight: 5,
            color: "white",
            _web: {
              letterSpacing: "-0.3 px"
            },
            letterSpacing: "-0.3"
          };
        },
        menuDetailPropertyAccordionDescription: function menuDetailPropertyAccordionDescription(_ref30) {
          var isMandatory = _ref30.isMandatory,
              isDefaultExpanded = _ref30.isDefaultExpanded;
          return {
            lineHeight: {
              base: 4,
              md: 5
            },
            fontWeight: 300,
            _web: {
              letterSpacing: "-0.3px",
              fontSize: {
                base: "xs",
                md: "16px"
              },
              color: isDefaultExpanded ? "white" : isMandatory ? "white" : "white"
            },
            letterSpacing: "-0.3",
            color: "white"
          };
        },
        menuDetailErrorText: function menuDetailErrorText() {
          return {
            fontSize: "xs",
            color: "#721C24",
            fontWeight: 400,
            lineHeight: 4
          };
        },
        deliveryErrorText: function deliveryErrorText() {
          return {
            fontSize: {
              base: "xs",
              md: "sm"
            },
            color: "#721C24",
            fontWeight: 300,
            lineHeight: 4
          };
        },
        menuItemInfoName: function menuItemInfoName() {
          return {
            fontSize: ["xl", "xl", "4xl"],
            fontWeight: 400
          };
        },
        addToCardButtonPriceText: function addToCardButtonPriceText() {
          return {
            color: "white",
            fontSize: {
              base: "sm",
              md: "xl"
            },
            _web: {
              fontSize: {
                base: "12px",
                md: "24px"
              }
            },
            fontWeight: 400,
            fontFamily: "heading"
          };
        },
        addToCardButtonText: function addToCardButtonText() {
          return {
            color: "white",
            fontSize: {
              base: "sm",
              md: "xl"
            },
            _web: {
              fontSize: {
                base: "12px",
                md: "24px"
              }
            },
            fontWeight: 400,
            fontFamily: "heading"
          };
        },
        nutritinalInfo: function nutritinalInfo() {
          return {
            fontSize: ["md", "md", "lg"],
            fontWeight: 500
          };
        },
        confirmPickupDetailsHeaderText: function confirmPickupDetailsHeaderText() {
          return {
            fontSize: 20,
            fontWeight: 400,
            textTransform: "uppercase",
            fontFamily: "SortsMillGoudy-Regular",
            color: "#86714d"
          };
        },
        confirmPickupDetailsRestaurant: function confirmPickupDetailsRestaurant() {
          return {
            fontSize: 16,
            fontWeight: 400,
            lineHeight: 5,
            color: "#000000"
          };
        },
        confirmPickupDetailsText: function confirmPickupDetailsText() {
          return {
            color: "orderConfirmationTextColor",
            fontWeight: 300,
            lineHeight: 4,
            fontSize: 14,
            _web: {
              letterSpacing: "2px"
            },
            letterSpacing: 1
          };
        },
        mobilePayHeaderBtnText: function mobilePayHeaderBtnText() {
          return {
            fontSize: {
              base: 14,
              md: 18
            },
            fontWeight: 400,
            color: "secondary.300"
          };
        },
        confirmPickupDetailsChangeBtnText: function confirmPickupDetailsChangeBtnText() {
          return {
            fontSize: 14,
            fontWeight: 400,
            color: "#86714d"
          };
        },
        cartItemMenuName: function cartItemMenuName(_ref31) {
          var inOrderDetails = _ref31.inOrderDetails;
          return {
            fontSize: 17,
            lineHeight: 5,
            _web: {
              letterSpacing: "-0.3px",
              width: {
                base: inOrderDetails ? "100%" : "164px"
              }
            },
            letterSpacing: "-0.3",
            width: {
              base: 40
            },
            fontWeight: 700,
            color: "#000000"
          };
        },
        cartItemPrice: function cartItemPrice() {
          return {
            fontSize: "sm"
          };
        },
        cartMessageText: function cartMessageText() {
          return {
            fontSize: "xs",
            fontWeight: 200
          };
        },
        checkoutNoOfItems: function checkoutNoOfItems() {
          return {
            fontSize: "xs",
            _web: {
              pt: 2
            }
          };
        },
        cartItemMenuPropertyName: function cartItemMenuPropertyName() {
          return {
            fontSize: 15,
            lineHeight: 5,
            fontWeight: 400,
            _web: {
              letterSpacing: "-0.3px",
              width: "176px"
            },
            letterSpacing: "-0.3",
            width: 40,
            noOfLines: 3,
            color: "#3B3734"
          };
        },
        orderSettingsText: function orderSettingsText() {
          return {
            fontWeight: "400",
            fontSize: "sm"
          };
        },
        menuItemInfoPrice: function menuItemInfoPrice() {
          return {
            _web: {
              fontSize: {
                base: "14px",
                md: "18px"
              },
              pt: {
                base: 1,
                lg: 2
              }
            },
            // fontSize: { base: 3, md: 4 },
            fontWeight: "400"
          };
        },
        menuItemInfoPriceStartingAt: function menuItemInfoPriceStartingAt() {
          return {
            _web: {
              fontSize: {
                base: "14px",
                md: "18px"
              }
            },
            fontSize: {
              base: 3,
              md: 4
            },
            fontWeight: "300"
          };
        },
        menuItemInfoCalorie: function menuItemInfoCalorie() {
          return {
            _web: {
              fontSize: {
                base: "14px",
                md: "14px"
              }
            },
            fontSize: {
              base: 3,
              md: 3
            },
            fontWeight: "400"
          };
        },
        skuSelectorItemPriceText: function skuSelectorItemPriceText() {
          return {
            fontWeight: 500,
            fontSize: {
              base: 14,
              md: 16
            }
          };
        },
        skuSelectorItemName: function skuSelectorItemName() {
          return {
            fontWeight: 400,
            fontSize: {
              base: 14,
              md: 18
            }
          };
        },
        mobileAuthHeaderText: function mobileAuthHeaderText() {
          return {
            fontWeight: 300,
            fontSize: 24,
            color: "#505050"
          };
        },
        menuItemPrice: function menuItemPrice() {
          return {
            fontSize: [12, 12, 14],
            fontWeight: 500,
            pr: 1
          };
        },
        mobileOrderDetailsHeader: function mobileOrderDetailsHeader() {
          return {
            fontWeight: 400,
            fontSize: 18
          };
        },
        mobileOrderDetailsStatic: function mobileOrderDetailsStatic() {
          return {
            fontWeight: 300,
            fontSize: 12
          };
        },
        mobileOrderDetailsInput: function mobileOrderDetailsInput() {
          return {
            fontWeight: 400,
            fontSize: 16
          };
        },
        temperatureSelectLabel: function temperatureSelectLabel() {
          return {
            color: "#B0B0B0",
            fontSize: "lg",
            fontFamily: "headingSecondary"
          };
        },
        cartHeaderOrderType: function cartHeaderOrderType() {
          return {
            fontSize: "sm",
            lineHeight: 4,
            fontWeight: 400,
            color: "cartHeaderOrderType",
            textDecoration: "none",
            textDecorationColor: "cartHeaderOrderType"
          };
        },
        cartHeaderLocationName: function cartHeaderLocationName() {
          return {
            fontSize: "sm",
            lineHeight: 4,
            fontWeight: 500,
            color: "cartHeaderLocationName",
            textDecoration: "none",
            textDecorationColor: "cartHeaderLocationName"
          };
        },
        emptyCartText: {
          fontSize: "sm",
          fontWeight: 200,
          lineHeight: 4
        },
        allLocationsSelectHeading: {
          fontSize: 28,
          fontWeight: 600,
          fontFamily: "heading"
        },
        allLocationsSelectText: {
          fontSize: 20,
          fontWeight: 600
        },
        allLocationsText: {
          fontSize: 20,
          color: "#2A2C25",
          fontWeight: 600
        },
        allLocationsLengthText: {
          fontSize: 16,
          color: "#606060",
          fontWeight: 300
        },
        menuListTextCTA: {
          fontWeight: 400,
          fontSize: [10, 10, 14, 14, 14]
        },
        menuItemCalorieText: {
          fontSize: [12, 12, 14],
          fontWeight: 200,
          pl: 1
        },
        cartItemRemoveText: {
          fontSize: 13,
          lineHeight: 4,
          textTransform: "uppercase",
          color: "white",
          fontWeight: 400
        },
        pdfMenuButtonText: {
          mt: 1,
          _web: {
            mt: 0
          }
        },
        locationListRestaurantName: function locationListRestaurantName(_ref32) {
          var isFromLocationSearch = _ref32.isFromLocationSearch;
          return {
            fontFamily: "heading",
            fontWeight: 600,
            fontSize: {
              base: "md",
              md: isFromLocationSearch ? "lg" : "md"
            },
            lineHeight: 22,
            textAlign: "left"
          };
        },
        locationListRestaurantDetails: function locationListRestaurantDetails(_ref33) {
          var isFromLocationSearch = _ref33.isFromLocationSearch;
          return {
            fontSize: {
              base: "xs",
              md: "sm"
            },
            _web: {
              width: isFromLocationSearch ? "100%" : "70%",
              lineHeight: "18px"
            },
            fontWeight: 300,
            lineHeight: 14
          };
        },
        locationListResturantAddressSecondLine: {
          marginTop: 1,
          marginBottom: 0.5
        },
        addBtnText: function addBtnText(_ref34) {
          var addButtonText = _ref34.addButtonText;
          return {
            color: "white",
            textTransform: "uppercase",
            fontSize: (addButtonText === null || addButtonText === void 0 ? void 0 : addButtonText.length) > 8 ? 14 : 14,
            overflowWrap: "break-word",
            textAlign: "center",
            marginBottom: (addButtonText === null || addButtonText === void 0 ? void 0 : addButtonText.length) > 8 ? "2px" : 0
          };
        },
        confirmationSurveyHeader: function confirmationSurveyHeader() {
          return {
            color: "confirmationAccent",
            fontSize: {
              base: 16,
              lg: 20
            }
          };
        },
        confirmationPickupRestName: {
          fontSize: {
            base: 12,
            lg: 16
          },
          lineHeight: 3
        },
        confirmationPickupRestNameTitle: {
          fontSize: {
            base: 12,
            lg: 16
          },
          lineHeight: 3
        },
        confirmationPickupResAdd1: {
          lineHeight: 4,
          marginBottom: 1,
          fontSize: {
            base: 15,
            lg: 14
          }
        },
        confirmationPickupResAdd2: {
          lineHeight: 4,
          fontSize: {
            base: 15,
            lg: 14
          }
        },
        confirmationSurveyText: function confirmationSurveyText() {
          return {
            color: "confirmationThemeDark",
            fontSize: {
              base: 14,
              lg: 16
            }
          };
        },
        // @ts-ignore
        confirmationEclubHeader: function confirmationEclubHeader() {
          return {
            color: "confirmationAccent",
            fontSize: {
              base: 16,
              lg: 20
            }
          };
        },
        confirmationEclubEmail: function confirmationEclubEmail() {
          return {
            color: "confirmationThemeDark"
          };
        },
        confirmationEclubChangeEmail: function confirmationEclubChangeEmail() {
          return {
            color: "confirmationPrimary",
            fontSize: {
              base: 14,
              lg: 16
            }
          };
        },
        confirmationEclubCheckboxText: function confirmationEclubCheckboxText() {
          return {
            color: "confirmationThemeDark"
          };
        },
        confirmationAccountHeader: function confirmationAccountHeader() {
          return {
            color: "confirmationAccent",
            fontSize: {
              base: 16,
              lg: 20
            },
            fontWeight: "400"
          };
        },
        confirmationAccountEmail: function confirmationAccountEmail() {
          return {
            color: "confirmationThemeDark",
            fontSize: {
              base: 14,
              lg: 16
            }
          };
        },
        confirmationPickupMyOrderHeader: function confirmationPickupMyOrderHeader() {
          return {
            color: "confirmationAccent",
            fontSize: {
              base: 16,
              lg: 20
            }
          };
        },
        confirmationPickupDetailsHeader: function confirmationPickupDetailsHeader() {
          return {
            color: "confirmationAccent",
            fontSize: {
              base: 16,
              lg: 20
            }
          };
        },
        confirmationPickupDetailsSubTitle: function confirmationPickupDetailsSubTitle() {
          return {
            color: "confirmationAccentLight",
            fontSize: {
              base: 12,
              lg: 13
            }
          };
        },
        confirmationThankYouTitle: function confirmationThankYouTitle() {
          return {
            color: "#86714d",
            fontSize: {
              base: 18,
              lg: 32
            },
            fontWeight: {
              base: "400",
              lg: "1000"
            }
          };
        },
        confirmationOrderNumber: function confirmationOrderNumber() {
          return {
            fontSize: {
              base: 14,
              lg: 16
            },
            color: "#000000",
            fontWeight: "400"
          };
        },
        confirmationThankYouMailText: function confirmationThankYouMailText() {
          return {
            color: "#000000",
            fontSize: {
              base: 14,
              lg: 16
            },
            fontWeight: "300"
          };
        },
        confirmationThankYouMail: function confirmationThankYouMail() {
          return {
            color: "confirmationPrimary",
            fontSize: {
              base: 14,
              lg: 16
            },
            fontWeight: "600"
          };
        },
        confirmationThankYouDetailTitle: function confirmationThankYouDetailTitle() {
          return {
            color: "#000000",
            fontSize: {
              base: 14
            }
          };
        },
        confirmationHowToText: function confirmationHowToText() {
          return {
            fontSize: {
              base: 12,
              lg: 14
            },
            color: "#484238"
          };
        },
        confirmationMarketingTitle: function confirmationMarketingTitle() {
          return {
            color: "#86714d",
            fontWeight: 400,
            fontSize: {
              base: 12,
              lg: 14
            }
          };
        },
        confirmationMarketingSubtitle: function confirmationMarketingSubtitle() {
          return {
            color: "confirmationAccent",
            fontWeight: "300",
            fontSize: 12
          };
        },
        confirmationOrderDetailsTitle: function confirmationOrderDetailsTitle() {
          return {
            color: "#000000"
          };
        },
        confirmationOrderTotalItem: function confirmationOrderTotalItem() {
          return {
            fontSize: {
              base: 14,
              lg: 16
            }
          };
        },
        confirmationOrderTotalLabel: function confirmationOrderTotalLabel() {
          return {
            fontSize: {
              base: 18,
              lg: 23
            },
            color: "black",
            _web: {
              color: "#86714D"
            },
            fontWeight: 600
          };
        },
        confirmationOrderTotal: function confirmationOrderTotal() {
          return {
            fontSize: {
              base: 18,
              lg: 23
            },
            color: "#303030",
            _web: {
              color: "#86714D"
            },
            fontWeight: 600
          };
        },
        confirmationPaymentDetailsTitle: function confirmationPaymentDetailsTitle() {
          return {
            color: "black",
            fontSize: {
              base: 16,
              lg: 18
            }
          };
        },
        confirmationSpecialInstructionTitle: function confirmationSpecialInstructionTitle() {
          return {
            fontSize: {
              base: 12,
              md: 18
            }
          };
        },
        confirmationSpecialInstructionSubTitle: function confirmationSpecialInstructionSubTitle() {
          return {
            fontSize: {
              base: 12,
              md: 16
            }
          };
        },
        confirmationCardChargeInfo: function confirmationCardChargeInfo() {
          return {
            fontSize: {
              base: 12,
              lg: 16
            }
          };
        },
        confirmationChangesHeader: function confirmationChangesHeader() {
          return {
            color: "confirmationAccent",
            fontSize: {
              base: 16,
              lg: 20
            }
          };
        },
        confirmationSvgCenteredText: function confirmationSvgCenteredText() {
          return {
            pb: {
              base: "1px",
              lg: "2px"
            }
          };
        },
        //OC AddressAndTime variants start
        confirmationPickupRestaurantTitle: function confirmationPickupRestaurantTitle() {
          return {
            fontWeight: "300"
          };
        },
        confirmationPickupDateTimeTitle: function confirmationPickupDateTimeTitle() {
          return {
            fontWeight: "300",
            _ios: {
              py: 1
            },
            _android: {
              py: 1
            },
            marginBottom: 1.5,
            fontSize: {
              base: 15,
              lg: 14
            }
          };
        },
        confirmationPickupDateTimeValue: function confirmationPickupDateTimeValue() {
          return {
            fontSize: {
              base: 15,
              lg: 16
            },
            letterSpacing: -0.4,
            fontWeight: "400",
            color: "pickupRestaurantName",
            marginBottom: 1
          };
        },
        confirmationPickupPersonDetails: function confirmationPickupPersonDetails() {
          return {
            fontSize: {
              base: 14,
              lg: 16
            },
            textTransform: "capitalize",
            lineHeight: 4,
            fontWeight: "400",
            letterSpacing: -0.3
          };
        },
        confirmationDeliveryAddressTitle: function confirmationDeliveryAddressTitle() {
          return {
            fontWeight: "300"
          };
        },
        confirmationDeliveryRestaurantTitle: function confirmationDeliveryRestaurantTitle() {
          return {
            fontWeight: "300"
          };
        },
        confirmationDeliveryDateTimeTitle: function confirmationDeliveryDateTimeTitle() {
          return {
            fontWeight: "300"
          };
        },
        confirmationDeliveryGuestsTitle: function confirmationDeliveryGuestsTitle() {
          return {
            fontWeight: "300"
          };
        },
        //OC AddressAndTime variants end

        /* Restaurant Details Start */
        //Restaurant Info
        restaurantDetails_RestInfo_AddToFavoritesText: function restaurantDetails_RestInfo_AddToFavoritesText() {
          return {
            alignItems: "center",
            color: "amenitiesActionButtonsColor",
            fontSize: {
              base: "14px",
              lg: "16px"
            },
            ml: "3",
            h: "20px"
          };
        },
        restaurantDetails_RestInfo_TitleText: function restaurantDetails_RestInfo_TitleText() {
          return {
            fontWeight: "600",
            color: "restDetailsRestInfoTitleColor",
            mb: {
              base: "2",
              lg: "0"
            },
            fontSize: {
              base: "18px",
              lg: "32px"
            },
            textAlign: {
              base: "center",
              lg: "normal"
            }
          };
        },
        restaurantDetails_RestInfo_OpensText: function restaurantDetails_RestInfo_OpensText() {
          return {
            fontWeight: "500",
            fontSize: {
              base: "xs",
              lg: "sm"
            },
            color: "restDetailsRestInfoTitleColor"
          };
        },
        restaurantDetails_RestInfo_DateText: function restaurantDetails_RestInfo_DateText() {
          return {
            fontWeight: "500",
            fontSize: {
              base: "xs",
              lg: "sm"
            },
            color: "restDetailsRestInfoTitleColor",
            textTransform: "uppercase"
          };
        },
        restaurantDetails_RestInfo_AddressText: function restaurantDetails_RestInfo_AddressText() {
          return {
            fontWeight: 300,
            lineHeight: 6,
            px: 4,
            fontSize: {
              base: 14,
              lg: 16
            },
            _web: {
              lineHeight: {
                base: 5,
                lg: 5
              },
              my: 4,
              px: 0,
              style: {
                "text-underline-offset": "3px"
              }
            },
            textAlign: {
              base: "center",
              lg: "flex-start"
            },
            w: "100%",
            _ios: {
              flex: 1
            },
            _android: {
              flex: 1
            },
            textDecoration: "underline",
            textDecorationColor: "restaurantInfoAddressTextColor",
            color: "restaurantInfoAddressTextColor"
          };
        },
        restaurantDetails_RestInfo_PhoneNumberText: function restaurantDetails_RestInfo_PhoneNumberText(_ref35) {
          var customMarginHorizontal = _ref35.customMarginHorizontal;
          return {
            _ios: {
              mx: customMarginHorizontal || 0
            },
            _android: {
              mx: customMarginHorizontal || 0
            },
            marginLeft: 1,
            fontWeight: 300,
            fontSize: {
              base: 14,
              lg: 16
            },
            color: "restaurantInfoNumberAndDistanceTextColor"
          };
        },
        restaurantDetails_RestInfo_DistanceText: function restaurantDetails_RestInfo_DistanceText() {
          return {
            fontWeight: "300",
            fontSize: "14px",
            color: "restaurantInfoNumberAndDistanceTextColor"
          };
        },
        restaurantDetails_RestInfo_GetDirectionsText: function restaurantDetails_RestInfo_GetDirectionsText() {
          return {
            color: "amenitiesActionButtonsColor",
            fontSize: {
              base: "14px",
              lg: "16px"
            }
          };
        },
        //Restaurant Waitlist
        restaurantDetails_RestWaitlist_WaitlistAvailabilityDescText: function restaurantDetails_RestWaitlist_WaitlistAvailabilityDescText() {
          return {
            mb: "6",
            fontSize: {
              base: 14,
              lg: 16
            },
            fontWeight: 300,
            px: 6,
            maxW: {
              lg: "350",
              xl: "400"
            },
            textAlign: "center",
            lineHeight: {
              lg: 5
            },
            mx: "auto",
            color: "#404040"
          };
        },
        restaurantDetails_RestWaitlist_WaitlistAvailabilityRestName: function restaurantDetails_RestWaitlist_WaitlistAvailabilityRestName() {
          return {
            color: "#54301A"
          };
        },
        restaurantDetails_RestWaitlist_WaitlistAvailabilityPartySize: function restaurantDetails_RestWaitlist_WaitlistAvailabilityPartySize() {
          return {
            fontWeight: "300",
            fontSize: 14,
            color: "#54301A"
          };
        },
        //Restaurant CurrentStatus and Waitlist
        restaurantDetails_RestWaitlist_CurrentStatusText: function restaurantDetails_RestWaitlist_CurrentStatusText() {
          return {
            fontWeight: "300",
            //font specific styles
            color: "#606060",
            pt: "4px",
            fontSize: {
              base: "14",
              lg: "16"
            }
          };
        },
        restaurantDetails_RestWaitlist_AvailabilityText: function restaurantDetails_RestWaitlist_AvailabilityText() {
          return {
            _ios: {
              marginLeft: 4
            },
            _android: {
              marginLeft: 4
            },
            fontSize: "14px",
            fontWeight: "300",
            color: "restaurantWaitlistTextColor",
            maxWidth: {
              base: 40,
              lg: "none"
            },
            lineHeight: 6
          };
        },
        restaurantDetails_RestWaitlist_JoinWaitlistText: function restaurantDetails_RestWaitlist_JoinWaitlistText(_ref36) {
          var disabled = _ref36.disabled;
          return {
            color: "white",
            fontSize: "16px",
            fontWeight: 500,
            _android: {
              py: 2.5,
              px: 2,
              textTransform: "uppercase"
            },
            _ios: {
              py: 2.5,
              px: 2,
              textTransform: "uppercase"
            },
            _web: {
              py: 2.5,
              px: 2,
              textTransform: "uppercase"
            }
          };
        },
        restaurantDetails_RestWaitlist_EstWaitTimeText: function restaurantDetails_RestWaitlist_EstWaitTimeText() {
          return {
            _android: {
              marginTop: 2.5
            },
            _ios: {
              marginTop: 2.5
            },
            lineHeight: 3,
            fontWeight: "300",
            color: "restaurantWaitlistTextColor",
            fontSize: "11",
            textAlign: "center",
            maxWidth: 40,
            _web: {
              maxWidth: 32,
              fontSize: "12px",
              marginTop: {
                base: 2,
                lg: 0
              }
            }
          };
        },
        //Restaurant Timings
        restaurantDetails_RestTimings_TitleText: function restaurantDetails_RestTimings_TitleText() {
          return {
            fontSize: {
              base: 16,
              lg: 20
            },
            // mb: 4,
            color: "restaurantHoursTextColor"
          };
        },
        restaurantDetails_RestTimings_SpecialDayTitleText: function restaurantDetails_RestTimings_SpecialDayTitleText() {
          return {
            marginBottom: 3,
            color: "restaurantSpecialDayHeadingTextColor",
            fontSize: "16px",
            textAlign: "center",
            px: "3"
          };
        },
        restaurantDetails_RestTimings_SpecialDayDescText: function restaurantDetails_RestTimings_SpecialDayDescText() {
          return {
            fontSize: "14px",
            fontWeight: "300",
            lineHeight: 20,
            color: "restaurantSpecialDayBodyTextColor",
            textAlign: "center"
          };
        },
        restaurantDetails_RestTimings_WeekDayIconText: function restaurantDetails_RestTimings_WeekDayIconText() {
          return {
            lineHeight: 5,
            fontSize: "12px",
            textTransform: "capitalize",
            _ios: {
              paddingTop: 0.5,
              paddingLeft: 0.5
            }
          };
        },
        restaurantDetails_RestTimings_FullDayTitleText: function restaurantDetails_RestTimings_FullDayTitleText() {
          return {
            fontSize: {
              base: "14",
              lg: "16"
            },
            lineHeight: 4,
            color: "restaurantTimingsHeadingTextColor",
            maxWidth: "50%",
            textTransform: "capitalize",
            pr: 1
          };
        },
        restaurantDetails_RestTimings_HoursTitleText: function restaurantDetails_RestTimings_HoursTitleText() {
          return {
            fontSize: {
              base: "14",
              lg: "16"
            },
            lineHeight: 4,
            color: "restaurantTimingsHeadingTextColor",
            maxWidth: "50%",
            pl: 1
          };
        },
        restaurantDetails_RestTimings_FullDayItemText: function restaurantDetails_RestTimings_FullDayItemText() {
          return {
            color: "restaurantTimingsTextColor",
            fontSize: {
              base: "14",
              lg: "16"
            },
            fontWeight: "300",
            maxWidth: "50%",
            pr: 1
          };
        },
        restaurantDetails_RestTimings_HoursItemText: function restaurantDetails_RestTimings_HoursItemText() {
          return {
            color: "restaurantTimingsTextColor",
            fontSize: {
              base: "14",
              lg: "16"
            },
            fontWeight: "300",
            maxWidth: "50%",
            pl: 1
          };
        },
        restaurantDetails_RestTimings_MessageText: function restaurantDetails_RestTimings_MessageText() {
          return {
            color: "restaurantTimingsTextColor",
            fontSize: {
              base: "13",
              lg: "14"
            },
            fontWeight: "100",
            _ios: {
              lineHeight: 5,
              fontSize: 12
            },
            _android: {
              lineHeight: 5,
              fontSize: 12
            }
          };
        },
        restaurantDetails_RestTimings_SpecialHoursText: function restaurantDetails_RestTimings_SpecialHoursText() {
          return {
            fontWeight: 300,
            fontSize: 12,
            color: {
              base: "#606060",
              lg: "#404040"
            },
            fontStyle: "italic"
          };
        },
        //Restaurant About
        restaurantDetails_RestAbout_TitleText: function restaurantDetails_RestAbout_TitleText() {
          return {
            color: "restaurantAboutSectionHeadingTextColor",
            marginBottom: 4,
            fontSize: {
              base: "16px",
              lg: "20px"
            },
            lineHeight: 6,
            display: {
              base: "flex",
              lg: "none"
            }
          };
        },
        restaurantDetails_RestAbout_DescText: function restaurantDetails_RestAbout_DescText() {
          return {
            color: "restaurantAboutSectionBodyTextColor",
            paddingBottom: 4,
            fontSize: {
              base: "14",
              lg: "16"
            },
            fontWeight: "300",
            lineHeight: 5
          };
        },
        //Restaurant Action Buttons
        restaurantDetails_ActionButtons_CTAButtonLabelText: function restaurantDetails_ActionButtons_CTAButtonLabelText() {
          return {
            fontSize: {
              base: "14px",
              lg: "16px"
            },
            textAlign: "center",
            color: "amenitiesActionButtonsColor",
            textTransform: "uppercase",
            _web: {
              textTransform: "uppercase"
            },
            fontWeight: 500
          };
        },
        //Restaurant Amenities
        restaurantDetails_Amenities_TitleText: function restaurantDetails_Amenities_TitleText() {
          return {
            paddingBottom: 4,
            fontSize: {
              base: "16px",
              lg: "20px"
            },
            color: "amenitiesHeadingColor",
            display: {
              base: "flex"
            }
          };
        },
        restaurantDetails_Amenities_IconName: {
          fontWeight: 300,
          fontSize: {
            base: "14",
            lg: "16"
          },
          color: "#303030"
        },
        restaurantDetails_Amenities_Description: {
          fontSize: {
            base: 12,
            lg: 14
          },
          fontWeight: "300",
          color: "#404040"
        },
        restaurantDetails_Amenities_Title: {
          fontSize: {
            base: 14,
            lg: 16
          },
          mb: 1,
          color: "#303030"
        },
        //Restaurant Holiday Msg
        restaurantDetails_HolidayMsg_Text: {
          textAlign: "center",
          fontSize: {
            base: "14px",
            lg: "14px"
          },
          color: "white",
          fontWeight: "400",
          maxW: {
            base: "250px",
            md: "350",
            lg: "100%"
          },
          mx: "auto",
          lineHeight: 5
        },
        //Restaurant Order Button
        restaurantDetails_OrderButton_LabelText: function restaurantDetails_OrderButton_LabelText() {
          return {
            _android: {
              paddingY: 5,
              textTransform: "uppercase"
            },
            _ios: {
              paddingY: 5,
              textTransform: "uppercase"
            },
            fontSize: {
              base: "14px",
              lg: "16px"
            },
            color: "orderFromHereButtonTextColor",
            textAlign: "center",
            textTransform: {
              base: "uppercase",
              lg: "uppercase"
            },
            fontWeight: 500
          };
        },
        restaurantDetails_RestTimings_WeekDay: function restaurantDetails_RestTimings_WeekDay() {
          return {
            color: "restaurantTimingWeekDayTextColor",
            fontSize: {
              base: "12",
              lg: "12"
            },
            position: "absolute"
          };
        },
        locationTitleHeader: function locationTitleHeader() {
          return {
            fontWeight: 400,
            fontSize: 20,
            color: "preferredLocationHeaderTextColor",
            textTransform: "uppercase"
          };
        },
        waitlist_leave_the_line_text: function waitlist_leave_the_line_text() {
          return {
            fontSize: 16,
            fontWeight: 300,
            color: "#606060"
          };
        },
        waitlist_leave_the_line_link: function waitlist_leave_the_line_link() {
          return {
            fontSize: 16,
            fontWeight: 400,
            color: "#A2402A"
          };
        },
        restaurantDetails_PoliteNotice_Title: function restaurantDetails_PoliteNotice_Title() {
          return {
            fontSize: 20,
            fontWeight: 400,
            mb: 15,
            color: "#000000"
          };
        },
        restaurantDetails_PoliteNotice_Desc: function restaurantDetails_PoliteNotice_Desc() {
          return {
            fontSize: 16,
            fontWeight: 300,
            color: "#000000",
            lineHeight: 20
          };
        },
        restDetails_TextMapper_Title: function restDetails_TextMapper_Title() {
          return {
            fontWeight: 400,
            fontSize: 28,
            mb: 4,
            color: "white",
            textAlign: "left"
          };
        },
        restDetails_TextMapper_Description: function restDetails_TextMapper_Description() {
          return {
            fontWeight: 300,
            fontSize: 18,
            color: "white",
            textAlign: "left"
          };
        },

        /* Restaurant Details End */

        /* Order Tracking start*/
        orderTrackingCallHelpText: {
          fontSize: "sm",
          fontWeight: 400,
          lineHeight: 5,
          color: "#812F36"
        },
        orderStatusTrackingTitle: function orderStatusTrackingTitle() {
          return {
            color: "#3B3734",
            fontWeight: 400,
            fontSize: 20,
            lineHeight: 6
          };
        },
        orderStatusTitle: function orderStatusTitle() {
          return {
            fontSize: 14,
            fontWeight: 400,
            lineHeight: 6,
            color: "orderStatusText"
          };
        },
        orderStatusSubText: function orderStatusSubText() {
          return {
            fontSize: 12,
            fontWeight: 300,
            lineHeight: 3,
            color: "orderStatusText"
          };
        },
        orderStatusTime: function orderStatusTime() {
          return {
            fontSize: "xs",
            fontWeight: 400,
            lineHeight: 3,
            color: "orderStatusText"
          };
        },
        orderStatusPayNowButtonText: function orderStatusPayNowButtonText() {
          return {
            fontSize: 14,
            lineHeight: 6,
            fontWeight: 400,
            color: "white",
            textTransform: "uppercase"
          };
        },
        orderStatusCurbsideCheckInButtonText: function orderStatusCurbsideCheckInButtonText() {
          return {
            fontSize: "lg",
            lineHeight: 6,
            fontWeight: 400,
            color: "curbsideCheckInButton"
          };
        },
        myLocationsLoginText: {
          fontWeight: 700,
          fontSize: 18,
          color: "secondary.300"
        },
        orderStatusTimeMessage: function orderStatusTimeMessage() {
          return {
            marginTop: 2,
            fontSize: "xs",
            fontWeight: 400,
            lineHeight: 3,
            color: "orderStatusText"
          };
        },
        checkText: function checkText() {
          return {
            fontSize: 14,
            fontWeight: 300,
            lineHeight: 4,
            color: "checkText"
          };
        },
        checkAmount: function checkAmount() {
          return {
            fontSize: 14,
            fontWeight: 400,
            lineHeight: 4,
            color: "checkText"
          };
        },
        curbsideCheckInAvailableText: function curbsideCheckInAvailableText() {
          return {
            fontSize: 12,
            lineHeight: 4,
            fontWeight: 300,
            textAlign: "center",
            color: "curbsideCheckInAvailable"
          };
        },
        orderStatusCurbsideCheckInButtonPrimary: function orderStatusCurbsideCheckInButtonPrimary() {
          return {
            fontSize: 14,
            lineHeight: 6,
            fontWeight: 400,
            color: "curbsideCheckInPrimary",
            textTransform: "uppercase"
          };
        },
        orderStatusCurbsideCheckInButtonSecondary: function orderStatusCurbsideCheckInButtonSecondary() {
          return {
            fontSize: 14,
            lineHeight: 6,
            fontWeight: 400,
            color: "curbsideCheckInSecondary",
            textTransform: "uppercase"
          };
        },
        orderStatusDeatilsTitle: function orderStatusDeatilsTitle() {
          return {
            fontSize: 18,
            lineHeight: 6,
            fontWeight: 400,
            color: "#3B3734",
            marginBottom: 3.5
          };
        },
        otCurbsideVehicleDetailsTitle: function otCurbsideVehicleDetailsTitle() {
          return {
            fontSize: "xs",
            lineHeight: 3,
            fontWeight: 300,
            color: "#3B3734",
            marginBottom: 1
          };
        },
        otCurbsideVehicleDetails: function otCurbsideVehicleDetails() {
          return {
            fontSize: "sm",
            lineHeight: 4,
            fontWeight: 400,
            color: "#3B3734",
            textTransform: "capitalize"
          };
        },
        refreshButtonText: function refreshButtonText() {
          return {
            fontSize: "xs",
            fontWeight: 400,
            color: "refreshButtonColor"
          };
        },
        autoRefreshText: function autoRefreshText() {
          return {
            fontSize: "xs",
            fontWeight: 400,
            color: "refreshButtonColor"
          };
        },
        orderTrackingLocationTimeSectionText: {
          ml: 2,
          fontSize: 14,
          lineHeight: 4,
          color: "#3B3734",
          fontWeight: 300
        },

        /* Order Tracking end*/
        //LocationSearch Start
        locationSearchHeading: function locationSearchHeading() {
          return {
            fontWeight: 600,
            fontSize: 20,
            fontFamily: "heading",
            color: "locationSearchTitle"
          };
        },
        recentLocationsText: function recentLocationsText() {
          return {
            fontSize: {
              base: 17,
              md: 20
            },
            fontWeight: 500,
            lineHeight: 5
          };
        },
        orderSettingsQuantityText: function orderSettingsQuantityText() {
          return {
            fontSize: "md",
            py: 2
          };
        },
        sliderTitleText: function sliderTitleText() {
          return {
            fontSize: {
              base: 14
            },
            fontWeight: {
              base: 500
            }
          };
        },
        reorderButtonText: function reorderButtonText() {
          return {
            fontWeight: 500
          };
        },
        desktopBreadcrumbVariant: function desktopBreadcrumbVariant() {
          return {
            fontSize: "sm",
            fontWeight: "500",
            lineHeight: 4,
            letterSpacing: "xs",
            textTransform: "uppercase",
            p: "0",
            m: "0",
            color: "themeTextColor"
          };
        },
        desktopLastBreadcrumbVariant: function desktopLastBreadcrumbVariant() {
          return {
            fontSize: "sm",
            fontWeight: "500",
            lineHeight: 4,
            letterSpacing: "xs",
            textTransform: "uppercase",
            p: "0",
            m: "0",
            color: "themeTextColor"
          };
        },
        numberOfCartItems: function numberOfCartItems() {
          return {
            fontWeight: 500
          };
        },
        restTimingsSplMsg: function restTimingsSplMsg() {
          return {
            fontWeight: 300
          };
        },
        currentlyUnavailableText: function currentlyUnavailableText() {
          return {
            color: "primary.100",
            fontWeight: {
              base: 500
            }
          };
        },
        menuCartHeaderTexLineHeightForApp: {
          lineHeight: 5
        },
        legalDisclaimerText: {
          lineHeight: 5
        },
        scrollingNavigationCarouselItemText: function scrollingNavigationCarouselItemText(_ref37) {
          var isActive = _ref37.isActive;
          return {
            fontWeight: 400,
            _web: {
              fontWeight: isActive ? 400 : 300
            }
          };
        },
        menuDetailDesciptionMobile: function menuDetailDesciptionMobile() {
          return {
            fontFamily: "Lato-Light",
            color: "#2A2C25"
          };
        },
        increaseTextSize: function increaseTextSize(_ref38) {
          var styleSize = _ref38.styleSize;
          return {
            fontSize: styleSize + 3
          };
        },
        nutritionalInfoBottomSheetAllergenInfo: function nutritionalInfoBottomSheetAllergenInfo() {
          return {
            color: "themeGrey",
            fontWeight: "200",
            fontSize: "xs"
          };
        },
        nutritionalInfoBottomSheetQuestion: function nutritionalInfoBottomSheetQuestion() {
          return {
            fontWeight: "300",
            color: "themeGrey",
            fontSize: "sm"
          };
        },
        reservationListCardCtaText: function reservationListCardCtaText() {
          return {
            pl: 2,
            fontWeight: 500,
            fontSize: 14,
            color: "#020001",
            lineHeight: 5
          };
        },
        reservationInfoValue: function reservationInfoValue() {
          return {
            fontWeight: 500,
            fontSize: 12,
            color: "#020001",
            lineHeight: 5
          };
        },
        reservationInfoKey: function reservationInfoKey() {
          return {
            fontWeight: 400,
            fontSize: 11,
            color: "#303030",
            lineHeight: 5
          };
        },

        /** Text: Private Dining Start */
        privateDiningLocationModalHeaderText: {
          color: "#86714D",
          fontSize: 20,
          fontWeight: 300,
          textAlign: "center"
        },
        privateDiningFilterStateHeading: {
          fontSize: 20,
          color: "#2A2C25",
          fontWeight: 600,
          ml: {
            base: 0,
            md: 4
          },
          mt: {
            base: 4,
            md: 0
          },
          textTransform: "capitalize"
        },
        pd_requestFlow_form_title: function pd_requestFlow_form_title() {
          return {
            pt: {
              base: 5,
              md: 6
            },
            pb: {
              base: 4,
              md: 6
            },
            fontSize: {
              base: 16,
              md: 22
            },
            lineHeight: 6,
            textAlign: "center",
            fontFamily: "Lato-Regular",
            color: "#FFFFFF"
          };
        },
        pd_requestFlow_form_tabIndex: {
          m: "auto",
          color: "#86714D",
          fontSize: {
            base: "xs",
            md: "md"
          }
        },
        pd_requestFlow_form_tabTitle: function pd_requestFlow_form_tabTitle(_ref39) {
          var isActive = _ref39.isActive,
              isCompleted = _ref39.isCompleted;
          return {
            fontWeight: isActive ? 500 : 400,
            fontSize: {
              base: "sm",
              md: "md"
            },
            color: isActive || isCompleted ? "#EFEDE9" : "#B09C79"
          };
        },
        pd_request_eventDetails_locationTitle: {
          fontSize: {
            base: "sm",
            md: "md"
          },
          fontWeight: 400,
          mb: 1.5,
          color: "#020001"
        },
        pd_request_eventDetails_locationAddress: {
          fontSize: {
            base: "xs",
            md: "sm"
          },
          fontWeight: 200,
          lineHeight: 4,
          color: "#020001"
        },
        pd_request_eventDetails_locationPhoneNum: {
          fontSize: {
            base: "xs",
            md: "sm"
          },
          fontWeight: 200,
          color: "#020001"
        },
        pd_request_eventDetails_locationChange: {
          fontSize: 12,
          fontWeight: 300,
          color: "#86714D"
        },
        pd_request_eventDetails_InputTitle: {
          fontSize: "sm",
          fontWeight: 400,
          lineHeight: 4,
          mb: 2,
          color: "#303030"
        },
        pd_request_eventDetails_noOfGuest_subMessage: {
          fontSize: "sm",
          fontWeight: 200,
          lineHeight: 4,
          color: "#606060",
          mt: 2
        },
        pd_request_eventDetails_splRequestTitle: {
          fontSize: 16,
          fontWeight: 300,
          lineHeight: 4,
          mr: 3,
          color: "#303030"
        },
        pd_request_contactDetails_InputTitle: {
          color: "#86714D",
          fontSize: 14,
          mb: 2,
          fontFamily: "Lato-Regular"
        },
        pd_request_contactDetails_InputTitl_Optional_text: {
          color: "#86714D",
          fontSize: 14,
          mb: 2,
          fontFamily: "Lato-Regular"
        },
        pd_review_details_diresctions_text: {
          fontWeight: 500,
          fontSize: 14
        },
        pd_request_contactDetails_dobTitle: {
          color: "#86714D",
          fontSize: 16,
          mr: 2,
          fontFamily: "Lato-Regular"
        },
        pd_request_contactDetails_dobTooltip: {
          maxWidth: 176,
          color: "#FFFFFF",
          fontSize: 12,
          fontFamily: "Lato-Regular"
        },
        pd_request_eventDetails_dineInDate_tooltip: {
          maxWidth: 176,
          color: "#FFFFFF",
          fontSize: 12,
          fontFamily: "Lato-Regular"
        },
        pd_contactDetails_userInfoName: {
          color: "#303030",
          fontFamily: "Lato-Regular",
          fontWeight: 500,
          fontSize: {
            base: 14,
            md: 16
          },
          mb: 2
        },
        pd_contactDetails_userInfoExtras: {
          color: "#303030",
          fontFamily: "Lato-Regular",
          fontSize: {
            base: 12,
            md: 14
          },
          _ios: {
            lineHeight: 14
          },
          _android: {
            lineHeight: 14
          },
          _web: {
            lineHeight: 12
          }
        },
        pd_reviewDetails_title: {
          color: "#606060",
          fontFamily: "Lato-Regular",
          fontSize: 12
        },
        pd_reveiwDetails_restName: {
          color: "#020001",
          fontFamily: "Lato-Bold",
          fontSize: {
            base: 14,
            md: 16
          },
          mb: 1
        },
        pd_reviewDetails_restAddress: {
          color: "#020001",
          fontFamily: "Lato-Regular",
          fontSize: {
            base: 12,
            md: 14
          }
        },
        pd_reviewDetails_restPhoneNum: {
          color: "#020001",
          fontFamily: "Lato-Regular",
          fontSize: {
            base: 12,
            md: 14
          },
          mt: 1
        },
        pd_reviewDetails_eventInfoTitle: {
          color: "#606060",
          fontFamily: "Lato-Regular",
          fontSize: 12,
          _web: {
            lineHeight: 12
          },
          mb: 2
        },
        pd_reviewDetails_eventInfoData: {
          color: "#2C303B",
          fontFamily: "Lato-Regular",
          fontSize: {
            base: 14,
            md: 16
          },
          _web: {
            lineHeight: 12
          }
        },
        pd_reviewDetailsSplReqTitle: {
          color: "#303030",
          fontSize: 14,
          fontWeight: 500,
          lineHeight: 15,
          fontFamily: "Lato-Regular",
          mb: 2
        },
        pd_reviewDetailsSplReqData: function pd_reviewDetailsSplReqData(_ref40) {
          var isFromConfirmation = _ref40.isFromConfirmation;
          return {
            color: isFromConfirmation ? "#020001" : "#808080",
            fontSize: 14,
            fontFamily: "Lato-Regular",
            fontWeight: 400
          };
        },
        pd_confirmation_title: {
          color: "#86714D",
          fontSize: 16,
          maxW: {
            md: "354px"
          },
          textAlign: "center",
          fontWeight: 600,
          mt: 2
        },
        pd_confirmation_emailText: {
          color: "#505050",
          fontFamily: "Lato-Regular",
          fontSize: 14
        },
        pd_confirmation_email: {
          color: "#020001",
          textAlign: "center",
          fontSize: 16,
          mt: 1
        },
        pd_confirmation_salesMessage: {
          color: "#808080",
          fontFamily: "Lato-Regular",
          fontSize: 14,
          maxW: {
            md: "387px"
          },
          textAlign: "center"
        },
        pd_confirmation_restPhoneNum: {
          color: "#86714D",
          fontSize: 14,
          fontFamily: "Lato-Regular",
          fontWeight: 400
        },
        pd_cancelModalMessage: {
          fontSize: 16,
          lineHeight: 5,
          textAlign: "center",
          color: "#606060",
          fontFamily: "Lato-Regular"
        },
        pd_cancelModalCancelCTAText: {
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 400,
          textAlign: "center",
          color: "#86714D",
          fontFamily: "Lato-Regular"
        },
        pd_cancelModalCancelConfirmText: {
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 400,
          textAlign: "center",
          color: "#FFFFFF",
          fontFamily: "Lato-Regular"
        },
        pd_request_eventDetails_dineInDate_subMessage: {
          fontSize: "xs",
          fontWeight: 200,
          lineHeight: 4,
          color: "#606060",
          fontFamily: "Lato-Regular",
          mr: 2
        },
        pd_landing_home_subText: {
          color: "#303030",
          fontWeight: 300
        },
        pd_landing_home_activeText: {
          color: "#2A2C25",
          textTransform: "uppercase",
          fontSize: {
            base: 28,
            md: 45
          },
          fontWeight: 500,
          fontFamily: "Lato-Regular"
        },
        pd_landing_stickyContainer_label: {
          fontSize: {
            base: "xs",
            md: "md"
          },
          fontWeight: 300,
          color: "#282728",
          lineHeight: 5,
          textAlign: {
            base: "center",
            md: "start"
          },
          mt: {
            base: 1,
            lg: 0
          },
          maxWidth: {
            base: 80,
            md: "360px"
          },
          wordBreak: "break-word"
        },
        pd_landing_makeAReq_ctaText: {
          color: "#FFFFFF",
          textTransform: "uppercase",
          fontSize: {
            base: "sm",
            md: "xl"
          },
          lineHeight: 6
        },
        pd_landing_menuTabs_itemLabel: function pd_landing_menuTabs_itemLabel(_ref41) {
          var isActive = _ref41.isActive;
          return {
            textTransform: "uppercase",
            color: isActive ? "#FFFFFF" : "#86714D",
            fontSize: 16,
            fontWeight: 500,
            lineHeight: 6,
            fontFamily: "Lato-Regular"
          };
        },
        pd_landing_dropdown_activeLable: function pd_landing_dropdown_activeLable(_ref42) {
          var isActive = _ref42.isActive;
          return {
            fontSize: "md",
            fontWeight: 500,
            lineHeight: 6,
            color: isActive ? "#3B3734" : "#FFFFFF",
            textTransform: "uppercase",
            fontFamily: "Lato-Regular"
          };
        },
        pd_landing_locationHeaderName: {
          pb: 1,
          fontSize: 16,
          fontWeight: 300,
          color: "#86714D",
          textTransform: "capitalize"
        },
        pd_landing_locationHeaderChangeLoc: {
          fontSize: 16,
          color: "#86714D",
          fontWeight: 600,
          textTransform: "capitalize",
          fontFamily: "Lato-Regular"
        },
        pd_landing_eventGuideCTA_text: {
          fontWeight: 400,
          color: "#86714D",
          fontSize: 16
        },
        pd_landing_floorPlanLink_text: {
          textAlign: "center",
          mt: 3,
          fontSize: 14,
          fontWeight: 300,
          color: "#86714D"
        },
        pd_landing_floorPlan_viewGalleryLink: {
          color: "#86714D",
          fontSize: {
            base: 14,
            lg: 20
          },
          fontWeight: 500,
          fontFamily: "Lato-Regular"
        },

        /** Text: Private Dining End */
        myReservationCardBottomControlsText: function myReservationCardBottomControlsText() {
          return {
            _ios: {
              mt: 0.5
            },
            _android: {
              mb: 1
            }
          };
        },
        quantityText: function quantityText() {
          return {
            fontSize: 14,
            fontWeight: 400,
            lineHeight: {
              base: 4,
              md: 5
            },
            letterSpacing: -0.3
          };
        },
        OrderSummaryCardSpecialInstructionText: function OrderSummaryCardSpecialInstructionText() {
          return {
            _ios: {
              mt: -2.5
            },
            _android: {
              mt: -2.5
            }
          };
        },
        reservationSeatingOptionText: {},
        reservationLocationSelectCTAText: {
          fontSize: 12,
          fontWeight: 400
        },
        reorderNonLoggedInText: {
          fontSize: 16,
          fontWeight: 500
        },
        reservationCheckboxText: {
          fontWeight: 300
        },
        reservationStaticLinkText: {
          fontWeight: 500,
          color: "primary.100"
        },
        sectionHeaderLongDescription: {
          fontSize: ["sm", "sm", "md"],
          color: "categoriesHeadingColor"
        },
        eClub_newsTextHeading: {
          textAlign: "center",
          fontWeight: 500,
          color: "#4E311D",
          fontSize: 24,
          width: "70%",
          lineHeight: 8
        },
        eClub_newsTextSubHeading: {
          textAlign: "center",
          fontWeight: 600,
          color: "#4E311D",
          fontSize: 14,
          width: "70%",
          lineHeight: 8,
          letterSpacing: "-0.3"
        },
        eClub_smsText: {
          fontWeight: 400,
          color: "#4E311D",
          fontSize: 14
        },
        eClub_smsTextFooterText: {
          textAlign: "center",
          fontWeight: 400,
          color: "#303030",
          fontSize: {
            base: "xs",
            md: "sm"
          },
          lineHeight: 4,
          w: {
            base: "100%",
            md: "70%"
          }
        },
        eClub_smsTextFooterLegalNoticeText: {
          textAlign: "center",
          fontWeight: 400,
          color: "#303030",
          fontSize: {
            base: "xs",
            md: "sm"
          },
          lineHeight: 4,
          w: {
            base: "100%",
            md: "70%"
          }
        },
        // My Account
        myAccountLocationCardHeader: {
          fontSize: {
            base: 14,
            md: 16
          },
          lineHeight: 5,
          fontWeight: 400
        },
        myAccountLocationCardAddress: {
          lineHeight: 5,
          fontSize: 14,
          fontWeight: 200
        },
        myAccountLocationCardPhoneNumber: {
          lineHeight: 5,
          fontSize: 14,
          fontWeight: 200
        },
        myAccountChangeLocationChangeText: {
          color: "#86714D",
          fontSize: {
            base: "2xs",
            md: "sm"
          },
          fontWeight: 400,
          _ios: {
            fontSize: 12
          },
          _android: {
            fontSize: 12
          }
        },
        myAccountDOBPrevText: function myAccountDOBPrevText(_ref43) {
          var prevMonthButtonDisabled = _ref43.prevMonthButtonDisabled;
          return {
            mr: "auto",
            fontSize: 12,
            color: prevMonthButtonDisabled ? "transparent" : "#303030",
            textTransform: "capitalize"
          };
        },
        myAccountDOBNextText: function myAccountDOBNextText(_ref44) {
          var nextMonthButtonDisabled = _ref44.nextMonthButtonDisabled;
          return {
            ml: "auto",
            fontSize: 12,
            color: nextMonthButtonDisabled ? "transparent" : "#303030",
            textTransform: "capitalize"
          };
        },
        myAccountContainerTitle: {
          fontSize: 20,
          fontWeight: 500,
          textTransform: "uppercase",
          color: "#2A2C25"
        },
        myAccount_MenuListItem_cardText_title: {
          fontSize: 12,
          lineHeight: 4,
          fontWeight: 300
        },
        myAccount_MenuListItem_cardText_subTitle: {
          marginTop: 1,
          fontSize: 14,
          lineHeight: 4,
          noOfLines: 1
        },
        myAccount_MenuListItem_cardText_subText: {
          marginTop: 1,
          fontSize: 14,
          lineHeight: 4,
          color: "myAccountSubTextColor",
          noOfLines: 1
        },
        myAccount_MenuListItem_cardText_subTitle2: {
          fontSize: 12,
          lineHeight: 4,
          fontWeight: 300,
          color: "myAccountSubTextColor"
        },
        myAccount_ChangeField_title: {
          paddingLeft: 5,
          paddingTop: 4,
          paddingBottom: 3,
          fontSize: 20,
          lineHeight: 6
        },
        myAccount_ChangeEmail_headerTitle: {
          mt: 6,
          mb: 5,
          textAlign: "center",
          fontSize: 20,
          lineHeight: 6,
          color: "#2A2C25"
        },
        myAccount_profileInfo_infoCard_title: {
          color: "#000",
          fontSize: 20,
          fontWeight: 400
        },
        myAccount_profileInfo_infoCard_subtext: {
          color: "#606060",
          fontSize: 14,
          fontWeight: 200,
          mt: 1
        },
        myAccount_profileInfo_infoCard_info: {
          fontSize: 10,
          lineHeight: 3,
          color: "editProfileInfoLabelColor"
        },
        myAccount_profileInfo_infoCard_terms: {
          fontSize: 11,
          lineHeight: 5,
          letterSpacing: -0.2,
          color: "themeGrey"
        },
        myAccount_profileInfo_infoCard_terms2: {
          fontSize: 11,
          lineHeight: 5,
          letterSpacing: -0.2,
          color: "backLinkColor",
          _web: {
            color: "#86714D"
          }
        },
        myAccount_profileInfo_infoList_emailLabel: {
          color: "#808080",
          fontSize: 10,
          mb: 1
        },
        myAccount_profileInfo_infoList_maskedEmail: {
          color: "themeGrey",
          fontSize: 16,
          fontWeight: 400
        },
        myAccount_profileInfo_infoList_emailChange: {
          fontSize: 12,
          color: "secondary.300",
          _web: {
            color: "#86714D"
          }
        },
        myAccount_profileInfo_infoList_changeOperation: {
          color: {
            base: "themeGrey",
            md: "#86714D"
          },
          letterSpacing: -0.3,
          fontSize: 16,
          fontWeight: 400
        },
        myAccount_orderHistoryItem_orderNumber: {
          fontSize: 14,
          letterSpacing: -0.3,
          fontWeight: "400",
          lineHeight: 4,
          color: "#303030"
        },
        myAccount_orderHistoryItem_orderPrice: {
          fontSize: 14,
          letterSpacing: -0.3,
          fontWeight: "400",
          lineHeight: 4,
          color: "#000"
        },
        myAccount_orderHistoryItem_pickpDate: {
          _web: {
            fontSize: {
              base: "13px",
              md: "14px"
            },
            color: {
              base: "#494949",
              md: "#303030"
            }
          },
          fontSize: 14,
          letterSpacing: -0.3,
          fontWeight: "400",
          lineHeight: 4
        },
        myAccount_orderHistoryItem_orderTitle: {
          fontSize: 14,
          fontWeight: "200",
          lineHeight: 4,
          noOfLines: 2,
          _web: {
            fontWeight: 400,
            color: {
              base: "#404040",
              md: "#303030"
            }
          }
        },
        myAccount_edit_fileds_sheet_title: {
          textAlign: "center",
          fontSize: 20,
          lineHeight: 6
        },
        myAccount_preferred_loc_title: {
          fontSize: 20,
          color: "#000",
          fontWeight: 400,
          mb: 6
        },
        myAccount_preferred_loc_card_title: {
          fontSize: 12,
          color: "#737373",
          fontWeight: 200,
          mb: 2
        },
        myAccount_paymentOptions_title: {
          fontSize: 20,
          fontWeight: 500,
          letterSpacing: "-0.3",
          marginLeft: 5,
          marginTop: 6,
          marginBottom: 3
        },
        myAccount_paymentOptions_tapOnCard: {
          textAlign: "center",
          fontSize: 14,
          lineHeight: 5,
          color: "#303030"
        },
        myAccount_paymentOptions_noSavedCards_message: {
          mt: 32,
          color: "grey300",
          fontSize: 16,
          fontWeight: 400,
          textAlign: "center",
          lineHeight: 5,
          _web: {
            mt: {
              base: 32,
              md: 8
            },
            textAlign: {
              base: "center",
              md: "left"
            },
            paddingLeft: {
              base: 0,
              md: 5
            }
          }
        },
        myAccount_paymentOptions_noSavedGiftCards_message: {
          color: "#A8A28F",
          mt: 5,
          fontSize: 16,
          fontWeight: 300,
          textAlign: "center",
          lineHeight: 5,
          mb: 5
        },
        myAccount_paymentOptions_noSavedCreditCards_message: {
          color: "#A8A28F",
          fontSize: 16,
          fontWeight: 400,
          textAlign: "center",
          lineHeight: 5,
          _web: {
            textAlign: {
              base: "center",
              md: "left"
            },
            paddingLeft: {
              base: 0,
              md: 5
            }
          },
          my: 5
        },
        myAccount_paymentOptions_giftCards_addNew: {
          fontSize: 12,
          color: "#86714D"
        },
        myAccount_paymentOptions_giftCards_addLimitMessage: {
          fontSize: 16,
          fontWeight: 300,
          color: "#606060",
          lineHeight: 5,
          textAlign: "center"
        },
        myAccount_paymentOptions_giftCards_AddCTAText: {
          color: "profileAddCardButtonText",
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 300
        },
        myAccount_paymentOptions_gc_maskedNumber: {
          fontSize: 11,
          color: "mobilePaymentsCardTextColor"
        },
        myAccount_paymentOptions_gc_number: {
          fontSize: 12,
          color: "mobilePaymentsCardTextColor"
        },
        myAccount_paymentOptions_gc_availableBalText: {
          fontSize: 8,
          pb: 0,
          color: "mobilePaymentsCardTextColor",
          _ios: {
            pb: 1
          }
        },
        myAccount_paymentOptions_gc_availableBal: {
          fontSize: 12,
          color: "mobilePaymentsCardTextColor"
        },
        myAccount_paymentOptions_gc_label: {
          fontSize: 8,
          color: "mobilePaymentsCardTextColor"
        },
        myAccount_paymentOptions_gc_bottomSheet_titleLabel: {
          pl: 7,
          textAlign: "center",
          fontSize: 20,
          lineHeight: 6,
          flex: 1
        },
        myAccount_order_history_order_details_modal_header_title: {
          fontSize: 20,
          color: "#2A2C25",
          fontWeight: 300
        },
        myAccount_order_history_title: {
          fontSize: 20,
          color: "#000",
          fontWeight: 400
        },
        myAccount_card_details_error_text: {
          color: "red.400",
          fontWeight: 400,
          fontSize: ["xs"],
          mt: 2
        },
        myAccount_consent_area_text: {
          marginLeft: 4,
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 300,
          color: "addCardCheckboxTextColor",
          marginRight: 4,
          maxWidth: 72,
          accessible: false,
          _web: {
            maxWidth: "100%"
          }
        },
        myAccount_consent_area_default_card_text: {
          marginLeft: 4,
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 300,
          color: "addCardCheckboxTextColor"
        },
        myAccount_add_gift_card_action_sheet_check_balance_text: {
          mt: 3,
          mb: 3.5,
          fontSize: 16,
          lineHeight: 5,
          color: "#86714D",
          textAlign: "center",
          _web: {
            mt: {
              base: 5,
              md: 3.5
            },
            mb: {
              base: 5,
              md: 3.5
            }
          },
          fontWeight: 300
        },
        myAccount_add_gift_card_action_sheet_available_balance_text: {
          fontWeight: 300,
          color: "themeGrey",
          py: 2,
          textAlign: "center",
          mt: 5
        },
        myAccount_add_gift_card_action_sheet_error_message: {
          marginY: 3,
          fontWeight: 300,
          fontSize: 12,
          color: "addCardModalValidWarningTextColor",
          lineHeight: 4
        },
        myAccount_ad_gift_card_action_sheet_save_for_future_use_text: {
          pt: 1,
          marginLeft: 4,
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 300,
          color: "saveCardCheckbox"
        },
        myAccount_paymentOptions_gcl_number: {
          fontSize: 24,
          color: "mobilePaymentsCardTextColor",
          lineHeight: 8
        },
        myAccount_paymentOptions_gcl_AvailableBal_label: {
          fontSize: 17,
          lineHeight: 7,
          pb: 0,
          _ios: {
            pb: 1
          },
          color: "mobilePaymentsCardTextColor"
        },
        myAccount_paymentOptions_gcl_bal: {
          fontSize: 24,
          color: "mobilePaymentsCardTextColor",
          lineHeight: 8
        },
        myAccount_paymentOptions_gcl_label: {
          fontSize: 15,
          color: "mobilePaymentsCardTextColor"
        },
        myAccount_paymentOptions_AddGC_AS_AddText: {
          mt: 3.5,
          mb: 3.5,
          fontSize: 16,
          lineHeight: 5,
          textAlign: "center",
          color: "saveCardAddButtonTextColor",
          _web: {
            mt: {
              base: 5,
              md: 4
            },
            mb: {
              base: 5,
              md: 4
            }
          }
        },
        myAccount_paymentOptions_showCC_BS_title: {
          textAlign: "center",
          _ios: {
            flex: 1
          },
          _android: {
            flex: 1
          },
          fontSize: 20,
          lineHeight: 6,
          _web: {
            flex: 1
          }
        },
        myAccount_updateQuestions_selectedText: {
          fontSize: 18,
          lineHeight: 5,
          fontWeight: "400",
          color: "securityQuestionTextColor"
        },
        myAccount_updateQuestions_asterisk: {
          fontSize: 18,
          lineHeight: 5,
          fontWeight: "400",
          color: "secondary.300"
        },
        myAccount_updateQuestions_options: {
          fontSize: 14,
          color: "grey300",
          lineHeight: 4,
          fontWeight: 400
        },
        myAccount_userInfoCard_name: {
          lineHeight: 6,
          fontSize: 20,
          noOfLines: 3
        },
        myAccount_userInfoCard_email: {
          color: "myAccountScreenUserInfoTextColor",
          fontSize: 13,
          fontWeight: 300,
          lineHeight: 4
        },
        myAccount_userInfoCard_mobileNumber: {
          color: "myAccountScreenUserInfoTextColor",
          fontSize: 13,
          fontWeight: 300,
          lineHeight: 4,
          paddingTop: 0.5
        },
        myAccount_userInfoCard_editLabel: {
          color: "secondary.300",
          fontSize: 12,
          lineHeight: 4
        },
        myAccount_fallBackPictureText: {
          fontSize: 26,
          color: "#86714D"
        },
        myAccount_editFieldsConfirmationModalBodyText: {
          fontWeight: 300,
          fontSize: 18
        },
        eClub_TnCs_Text: {
          marginBottom: 3,
          fontWeight: 200,
          fontSize: 14,
          lineHeight: 4
        },
        eClub_TnCs_privacy_policy_text: {
          fontWeight: 400,
          color: "#8E774D",
          fontSize: 14,
          lineHeight: 4,
          underline: true
        },
        eClubStickyCancelPressableText: {
          textTransform: "uppercase",
          color: "#86714D",
          textAlign: "center",
          fontSize: 16
        },
        eclub_selected_restaurant_name: {
          fontWeight: 400
        },
        eclub_changeLocationCTAText: {
          fontWeight: 400
        },
        empty_screen_description: {
          _ios: {
            color: "themeGrey"
          },
          _android: {
            color: "themeGrey"
          },
          fontSize: {
            base: "14px",
            md: "16px"
          },
          fontWeight: {
            base: 300
          },
          textAlign: "center",
          color: "#606060"
        },
        empty_screen_order_togo_btn_text: {
          _ios: {
            paddingY: 1
          },
          _android: {
            paddingY: 1
          },
          _web: {
            fontWeight: "500"
          },
          color: "white"
        },
        order_history_details_text: {
          ml: 1,
          mr: 2,
          lineHeight: 6,
          fontSize: 16,
          fontWeight: 300,
          color: "orderHistoryDetailsText",
          _android: {
            flex: 1
          },
          _ios: {
            flex: 1
          }
        },
        order_history_details_order_from_text: {
          fontWeight: 200,
          fontSize: 11,
          lineHeight: 3,
          letterSpacing: 0.31,
          color: "orderHistoryOrderFrom"
        },
        order_history_details_restaurant_name_text: {
          fontWeight: 400,
          fontSize: 12,
          lineHeight: 4,
          letterSpacing: -0.6,
          mt: 1
        },
        order_history_details_restaurant_address_text: {
          fontSize: 12,
          lineHeight: 4,
          fontWeight: 300,
          color: "orderHistoryDetailsAddress"
        },
        order_history_details_pickup_time_text: {
          fontWeight: 200,
          fontSize: 11,
          lineHeight: 3,
          letterSpacing: 0.31,
          color: "orderHistoryOrderFrom",
          mb: 1
        },
        order_history_details_pickup_time_desc: {
          mt: 0,
          fontSize: 13,
          lineHeight: 4,
          fontWeight: 400,
          color: "orderHistoryDetailsAddress"
        },
        order_history_details_your_order_text: {
          mt: 2,
          ml: 5,
          fontSize: 16,
          lineHeight: 5,
          fontWeight: 400,
          mb: 2
        },
        myAccount_mobileHeader_text: {
          color: "#000000",
          fontSize: 18,
          fontStyle: "normal",
          fontWeight: 400,
          lineHeight: "normal"
        },
        order_history_details_order_number_text: {
          color: "secondary200Mobile",
          _web: {
            color: "#86714D"
          }
        },
        passwordFooter_passiveText: {
          fontSize: 12,
          color: "mobileResetPasswordText",
          fontWeight: 400,
          lineHeight: 5
        },
        passwordFooter_activeText: {
          fontSize: 12,
          lineHeight: 5,
          color: "mobileAuthFooterActiveText",
          fontWeight: 400,
          _web: {
            color: "#86714D"
          }
        },
        orderHistory_reorderText: {
          color: "secondary.300",
          fontSize: 16,
          fontWeight: 400,
          _web: {
            color: "#86714D"
          }
        },
        noPrefLocationScreen_description: {
          fontSize: "16px",
          textAlign: "center",
          color: "#606060",
          fontWeight: "300"
        },
        noPrefLocationScreen_btn_text: {
          fontWeight: "400",
          color: "white",
          letterSpacing: "0.31"
        },
        joinEClubHeading: {
          fontWeight: 400,
          textAlign: "center",
          color: "#86714D",
          fontSize: {
            base: 22,
            md: 32,
            lg: 40
          },
          width: "auto",
          lineHeight: 8,
          fontFamily: "SortsMillGoudy-Regular"
        },
        joinEClubSubHeading: {
          fontWeight: 200,
          color: "#282728",
          fontSize: 16,
          textAlign: "center",
          mt: 4
        },
        myAccount_paymentOptions_noSavedCards_title: {
          fontSize: 18,
          fontWeight: 400
        },
        myAccount_paymentOptions_savedGiftCards_title: {
          fontSize: 14
        },
        myAccount_paymentOptions_savedCreditCards_title: {
          fontSize: 14
        },
        myAccount_paymentOptions_deleteGiftCard_modalBodyText: {
          fontWeight: 300,
          fontSize: 18,
          lineHeight: 6,
          letterSpacing: -1,
          textAlign: "center",
          mb: 3
        },
        myAccountConfirmationHeadTitle: {
          fontSize: 20,
          fontWeight: 400,
          my: 3,
          textAlign: "center",
          letterSpacing: "-0.1",
          color: "#303030"
        },
        myAccountConfirmationHeadSubText: {
          color: "#606060",
          fontSize: 16,
          fontWeight: 300,
          my: 2,
          textAlign: "center",
          lineHeight: 5,
          maxWidth: 337
        },
        addEditCCTitle: {
          textAlign: "center",
          fontSize: 20,
          lineHeight: 6
        },
        eclubSecondarySubsCheckbox: {
          mt: {
            base: -2,
            md: "-2"
          }
        },
        editProfileFullBottomButtonText: {
          fontSize: 16
        },
        myAccount_paymentOptions_modalWrapperHeader_text: {},
        addEditCreditCard_add_pressable_text: {
          marginTop: 5,
          marginBottom: 4,
          fontSize: 16,
          lineHeight: 6,
          textAlign: "center",
          color: "addCardFooterButtonText",
          textTransform: "uppercase"
        },
        gc_refreshBalance_cta_text: {
          color: "gcBalanceRefreshBorderTextColor",
          fontWeight: 400
        },
        myAccount_orderHistoryDetailsHeader_text: {
          color: "orderHistoryModalHeaderTextColor"
        },
        dateTimePickerModalTitle: {
          display: "none"
        }
      }
    },
    HStack: {
      variants: {
        /* RESERVATION */
        joinWaitlist_Header_Container: function joinWaitlist_Header_Container() {
          return {
            _ios: {
              height: 20
            },
            _android: {
              height: 20
            },
            justifyContent: "center",
            alignItems: "center",
            w: "100%",
            borderBottomWidth: 1,
            borderBottomColor: "#FFFFFF",
            bg: "#FFFFFF"
          };
        },
        reservationConfirmationDateTimeSizeHStack: {
          justifyContent: "flex-start",
          alignItems: "flex-start",
          mr: 1,
          flex: 1
        },
        reservationConfirmationDateTimeSizeContainer: {
          pt: 4,
          px: 3,
          justifyContent: "space-between"
        },
        reservationLookUpSuccessHStack: function reservationLookUpSuccessHStack(_ref45) {
          var isError = _ref45.isError;
          return {
            justifyContent: "center",
            space: 2,
            alignItems: "center",
            py: 2,
            my: 2,
            bg: isError ? "#DF450530" : "#FAF9F2",
            maxW: {
              md: "340px"
            },
            w: "100%",
            borderRadius: 0
          };
        },
        reservationLocationCardHStack: {
          my: 4,
          mx: 5,
          alignItems: "center",
          px: 4,
          py: 3,
          borderRadius: 0,
          shadow: 10,
          bg: "#F6F3EF"
        },
        reservationLocationItemHStack: {
          justifyContent: "space-between",
          alignItems: "flex-start",
          borderBottomWidth: 1,
          borderTopWidth: {
            base: 0,
            md: 1
          },
          borderLeftWidth: {
            base: 0,
            md: 1
          },
          borderRightWidth: {
            base: 0,
            md: 1
          },
          borderRadius: 0,
          borderColor: {
            base: "#dedede",
            md: "#dedede"
          },
          py: {
            base: 6,
            md: 4
          },
          px: {
            base: 0,
            md: 4
          },
          m: {
            base: 0,
            md: 4
          },
          backgroundColor: {
            base: "#ffffff",
            md: "#f6f3ef"
          }
        },
        reservationProfileCardHStack: {
          my: 4,
          _ios: {
            paddingX: 4
          },
          _android: {
            paddingX: 4
          },
          borderRadius: 0,
          shadow: 10,
          bg: {
            base: "#F6F3EF",
            md: "transparent"
          }
        },
        reservationProfileCardLoggedInHStack: {
          alignItems: "center",
          _ios: {
            flex: 1
          },
          _android: {
            flex: 1
          },
          _web: {
            justifyContent: "space-between",
            w: "100%",
            px: 4
          },
          my: 3,
          bg: "#f6f3ef"
        },

        /* RESERVATION */
        //JWC START
        jwcFooterBlock: {
          py: 2,
          bg: "white",
          borderRadius: 12,
          borderColor: "#C6C6C6",
          borderWidth: 1
        },
        jwcLocationHeaderBlock: {
          py: 5,
          px: 6,
          borderRadius: 12,
          bg: "white",
          borderColor: "transparent",
          borderWidth: 1
        },
        //JWC END
        header: {
          bg: "themeTextColor"
        },
        menuDetailIsUnavailable: function menuDetailIsUnavailable(_ref46) {
          var isSelected = _ref46.isSelected;
          return {
            bg: "#E5E5E5",
            borderRadius: 0,
            _ios: {
              borderWidth: 0,
              borderColor: "themeSectionSeparator",
              shadow: 5,
              overflow: "hidden"
            },
            _android: {
              borderWidth: 0,
              borderColor: "themeSectionSeparator",
              shadow: 5,
              overflow: "hidden"
            }
          };
        },
        cartItemButtonsContainer: function cartItemButtonsContainer() {
          return {
            justifyContent: "space-between"
          };
        },
        checkoutBtn: {
          alignItems: "center",
          justifyContent: "space-around",
          _web: {
            height: "60px"
          },
          py: 3,
          px: 5
        },
        scheduledOrderForm: {
          alignItems: "center",
          width: "100%",
          _ios: {
            borderWidth: 1
          },
          _android: {
            borderWidth: 1
          },
          _web: {
            borderWidth: "1px"
          },
          borderColor: "themeTextFieldBoundary",
          pl: 3
        },
        listItemBox: {
          borderRadius: 0
        },
        //Restaurant Details
        restaurantDetails_Index_RestAbout_HStack: {
          mt: "10",
          space: {
            lg: "md",
            xl: "2xl"
          }
        },
        restaurantDetails_Amenities_AmenitiesIcons_HStack: {
          alignItems: "center"
        },
        restaurantDetails_CurrentStatus_Icon_HStack: {
          alignItems: "center",
          justifyContent: "center",
          _web: {
            justifyContent: {
              base: "center",
              lg: "normal"
            }
          }
        },
        restaurantDetails_RestInfo_AddToFavourites_HStack: {
          alignItems: "center",
          mb: "6"
        },
        restaurantDetails_RestInfo_StarIcon_HStack: {
          alignItems: "center"
        },
        restaurantDetails_RestTime_HStack: {
          alignItems: "center",
          mb: "4"
        },
        restaurantDetails_RestTime_HoursLegend_HStack: {
          mr: "0",
          ml: "auto",
          justifyContent: "center"
        },
        restaurantDetails_RestTimings_WeekDaysIcon_HStack: {
          mb: 9,
          space: 1,
          justifyContent: "space-between"
        },
        restaurantDetails_RestTimings_SelectedDay_HStack: {
          mb: 4,
          space: 1,
          justifyContent: "space-between"
        },
        restaurantDetails_RestTimings_List_HStack: {
          marginBottom: 3,
          justifyContent: "space-between"
        },
        restaurantDetails_Waitlist_Party_HStack: {
          justifyContent: "center",
          alignItems: "center",
          mb: {
            base: 5
          }
        },
        restaurantDetails_Waitlist_Button_HStack: {
          justifyContent: "center"
        },
        //Order Tracking
        orderTrackingPayNowButtonHStack: {
          bgColor: "payNowButtonBg",
          px: 5,
          py: 3,
          alignItems: "center",
          justifyContent: "space-between"
        },
        orderTrackingCallHelpHStack: {
          py: 4,
          px: 5,
          _web: {
            minHeight: "68px",
            bottom: 0
          },
          bgColor: "#FAF3DF",
          borderTopColor: "borderColorCallSection",
          borderTopWidth: 1,
          alignItems: "center",
          justifyContent: "space-between",
          mt: "auto"
        },
        borderRadiusValue: function borderRadiusValue(_ref47) {
          var radiusValue = _ref47.radiusValue,
              topRadiusValue = _ref47.topRadiusValue,
              bottomRadiusValue = _ref47.bottomRadiusValue;
          return {
            borderRadius: 0,
            borderTopRadius: 0,
            borderBottomRadius: 0
          };
        },
        menuDetailArrowPosition: {
          mt: 1.5
        },
        menuDetailPropertyAccordionDescriptionTile: {
          mt: {
            base: 1.5,
            md: 1
          }
        },

        /* HStack: Private Dining Start */
        pd_Header_Container: function pd_Header_Container() {
          return {
            _ios: {
              height: 20
            },
            _android: {
              height: 20
            },
            justifyContent: "center",
            alignItems: "center",
            w: "100%",
            bgColor: "#FFFFFF",
            borderBottomWidth: 1,
            borderBottomColor: "#909192"
          };
        },
        privateDiningLocationItemHStack: {
          justifyContent: "space-between",
          alignItems: "flex-start",
          borderBottomWidth: 1,
          borderTopWidth: {
            base: 0,
            md: 1
          },
          borderLeftWidth: {
            base: 0,
            md: 1
          },
          borderRightWidth: {
            base: 0,
            md: 1
          },
          borderRadius: 0,
          borderColor: {
            base: "#C7C0AA",
            md: "#F0ECE6"
          },
          py: {
            base: 6,
            md: 4
          },
          px: {
            base: 0,
            md: 4
          },
          m: {
            base: 0,
            md: 4
          },
          bg: "#F0ECE6"
        },
        pd_request_eventDetails_selectTime_container: {
          marginTop: 2,
          marginBottom: 1,
          marginX: 5,
          borderColor: "#979797",
          borderWidth: 1,
          paddingY: 4,
          alignItems: "center",
          justifyContent: "space-between",
          borderRadius: 0
        },
        pd_request_contactDetails_userInfo: {
          p: 4,
          bg: "#FFFFFF"
        },
        pd_request_eventDetails_inputContainer: function pd_request_eventDetails_inputContainer(_ref48) {
          var errorMessage = _ref48.errorMessage,
              isActive = _ref48.isActive;
          return {
            py: 4,
            px: 3,
            alignItems: "center",
            borderRadius: 0,
            borderColor: errorMessage ? "#D30000" : isActive ? "#A96F3E" : "transparent",
            borderWidth: 1,
            bgColor: "#FFFFFF"
          };
        },
        pd_landing_menuTabs_container: {
          alignItems: "center",
          justifyContent: "space-between",
          flex: {
            base: 1,
            xl: 0.7
          }
        },
        pd_landing_menuDropdown_summary: function pd_landing_menuDropdown_summary(_ref49) {
          var isExpanded = _ref49.isExpanded;
          return {
            p: 5,
            flexGrow: 1,
            alignItems: "center",
            justifyContent: "space-between",
            borderBottomColor: isExpanded ? "#D2D2D2" : "transparent",
            borderBottomWidth: 1,
            fontFamily: "Lato-Regular"
          };
        },
        pd_landing_eventGuideCTA_body: {
          alignItems: "center",
          justifyContent: "center",
          space: {
            base: 3,
            lg: 4
          },
          py: 2.5
        },
        pd_landing_floorPlanLinksSection: {
          bgColor: {
            lg: "#F0ECE6"
          },
          py: {
            lg: 5
          },
          alignItems: "center",
          justifyContent: "center"
        },

        /* HStack: Private Dining End */
        eClub_smsTextHStack: {
          w: {
            base: "100%",
            md: "70%"
          },
          alignItems: "center",
          mt: 4,
          mb: 8,
          borderRadius: 0,
          borderWidth: 1,
          borderColor: "#E9E9E9",
          shadow: 10,
          bg: "white",
          zIndex: 1
        },
        // My Account
        myAccountLocationCardHStack: {
          alignItems: "center",
          px: 4,
          py: 5,
          borderRadius: 8,
          borderColor: "#DCDCDC",
          borderWidth: 1,
          shadow: 17
        },
        myAccount_infoList_changeEmail_container: {
          px: 4,
          mb: 3,
          alignItems: "center",
          flexDirection: "row",
          justifyContent: "space-between",
          py: {
            base: 4,
            md: 3
          },
          backgroundColor: {
            base: "myAccountCardBackground",
            md: "#F1ECE6"
          },
          borderRadius: 0,
          _web: {
            w: {
              base: "100%",
              md: "48%"
            }
          }
        },
        // My Account
        orderHistoryDetails_basicDetails_HStack: {
          p: 3,
          bg: "background.100",
          alignItems: "center",
          mb: 2,
          _web: {
            bg: "#DFD4C6"
          }
        }
      }
    },
    VStack: {
      variants: {
        jwcWaitTimeBlock: {
          p: 3,
          px: 6,
          bg: "white",
          borderRadius: 12,
          borderColor: "#C6C6C6",
          borderWidth: 1
        },
        addToCartContainer: {
          flex: 1
        },
        //Restaurant Details
        restaurantDetails_Index_RestInfo_VStack: {
          space: "xs"
        },
        restaurantDetails_Index_RestAbout_VStack: {
          mx: {
            lg: "60px"
          }
        },
        restaurantDetails_Index_RestAbout_InnerVStack: {
          flex: {
            lg: 4,
            xl: 1
          },
          space: "2xs"
        },
        restaurantDetails_Index_BrandFooter_VStack: {
          overflowX: "hidden"
        },
        restaurantDetails_ActionButtons_VStack: {
          _ios: {
            bg: "#FFFFFF"
          },
          _android: {
            bg: "#FFFFFF"
          },
          space: "md"
        },
        restaurantDetails_RestInfo_StarIcon_VStack: {
          space: 4,
          justifyContent: "center",
          flex: 1,
          direction: "column-reverse"
        },
        //order tracking
        orderTrackingRefreshButtonVStack: {
          borderColor: "refreshButtonColor",
          borderWidth: 1,
          py: 2,
          px: 1,
          space: 1.5,
          alignItems: "center",
          bg: "refreshButtonBg"
        },
        orderTrackingAutoRefreshVStack: {
          borderColor: "orderStatusSectionBorderColor",
          borderWidth: 1,
          borderRadius: 6,
          py: 2.5,
          px: 4,
          space: 1.5,
          alignItems: "center",
          bg: "refreshButtonBg"
        },
        nutritionalInfoVStack: {
          mt: {
            base: 2,
            md: 3
          },
          mb: "2",
          alignItems: "flex-start",
          width: "100%",
          _web: {
            width: {
              base: "100%",
              md: "100%",
              lg: "966px"
            }
          }
        },
        vstackBorderBottomRadius: {
          borderBottomRadius: 8
        },

        /** VStack: Private Dining Start */
        pd_requestForm_Tabs_Container: {
          bgColor: "#86714D"
        }
        /** VStack: Private Dining End */

      }
    },
    Flex: {
      variants: {
        orderConfirmationflex: {
          _web: {
            flexDirection: {
              base: "column-reverse",
              lg: "row"
            }
          }
        }
      }
    },
    Image: {
      variants: {
        pdRequestPageBg: {
          display: "none"
        },
        cartItemImage: {
          _web: {
            height: {
              base: "71px"
            },
            width: {
              base: "100px"
            }
          },
          rounded: "md",
          height: 70,
          width: 100
        },
        menu_item_card_vertical_image_border_radius: 8,
        //Restaurant Details
        restaurantDetails_RestInfo_Mob_Image: {
          h: "98px",
          w: "98px",
          resizeMode: "cover",
          _web: {
            h: {
              base: "97px",
              lg: "210px"
            },
            w: {
              base: "97px",
              lg: "220px"
            }
          }
        },
        restaurantDetails_RestInfo_ImageLg: {
          h: "98px",
          w: "98px",
          resizeMode: "cover",
          _web: {
            h: {
              base: "97px",
              lg: "89px"
            },
            w: {
              base: "97px",
              lg: "94px"
            }
          }
        },
        restaurantDetails_RestInfo_FavoriteIconLg: {
          height: "16px",
          width: "16px"
        },
        restaurantDetails_RestInfo_BrandIcon: {
          borderRadius: "none"
        },
        restaurantDetails_RestInfo_BrandIconLg: {
          borderRadius: "none"
        },
        //Edit Waitlist
        editWaitlist_LocationHeader_Icon: {
          _web: {
            width: 4,
            height: 5
          }
        },
        rd_spl_hours_legend: {
          width: "11px",
          height: "11px",
          mr: "1"
        },
        rd_spl_hours_icon: {
          width: "11px",
          height: "11px",
          top: 0,
          right: 0,
          position: "absolute"
        },
        //location search page
        location_search_exclamation_icon: {
          display: "none"
        },
        borderRadiusValue: function borderRadiusValue(_ref50) {
          var radiusValue = _ref50.radiusValue,
              topRadiusValue = _ref50.topRadiusValue,
              bottomRadiusValue = _ref50.bottomRadiusValue;
          return {
            borderRadius: 0,
            borderTopRadius: 0,
            borderBottomRadius: 0
          };
        },
        favorite_pin_fill_brand_icon: function favorite_pin_fill_brand_icon(_ref51) {
          var active = _ref51.active;
          return {
            height: active ? 4 : 3,
            width: active ? 4 : 3
          };
        },
        //cart overlay
        cart_overlay_pickup_date_brand_icon: {
          _web: {
            height: 5,
            width: 5
          },
          height: 20,
          width: 20,
          mr: 0
        },
        cart_overlay_pickup_time_brand_icon: {
          height: 20,
          width: 20,
          _web: {
            height: 5,
            width: 5
          },
          mr: 0
        },
        pd_select_restaurant_brand_logo: {
          height: "57px",
          width: "190px"
        }
      }
    },
    Box: {
      variants: {
        menuCardShadow: {
          shadow: 0
        },

        /*RESERVATION*/
        reservationConfirmationDateTimeSizeBox: {
          flex: 1,
          alignItems: "flex-start"
        },
        reservationConfirmationBoxBorderRadius: {
          borderRadius: 0
        },
        reservationConfirmationDetailsBox: {
          borderRadius: 0,
          my: {
            base: 6,
            md: 0
          },
          py: {
            base: 5,
            md: 6
          },
          borderTopWidth: 1,
          borderColor: "#0000001a"
        },
        reservationProfileInputBox: {
          pl: {
            base: 4,
            md: 5
          },
          pr: 4,
          bg: "#F6F3EF",
          _web: {
            pb: 9
          },
          borderRadius: 0
        },
        reservationProfileContactDetailsBox: {
          py: 3,
          flex: 1,
          my: 3
        },
        reviewReservationsContainerBox: {
          mt: 8,
          alignItems: "center",
          px: 4,
          _web: {
            bg: {
              base: "myReservationsBoxBg",
              md: "myReservationsBoxBg"
            },
            maxW: {
              md: "680px"
            },
            py: 8,
            mt: {
              base: 8,
              md: 16
            },
            px: {
              base: 5,
              md: 24
            },
            mb: {
              base: 8,
              md: 16
            }
          }
        },
        reservationDropdownRadius: 0,
        reservationLocationDropdownSelectBox: {
          borderWidth: 1,
          borderRadius: 0,
          width: {
            base: "100%",
            md: "400px"
          },
          borderColor: "#DEDEDE"
        },
        reservationLocationDropdownBox: {
          bg: "#f6f3ef",
          py: 4,
          justifyContent: "center",
          px: {
            base: 6,
            md: 16
          }
        },
        reservationAvailableTimeSlotBtnBox: {
          _web: {
            width: 24,
            py: 2
          },
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "row",
          borderRadius: 0,
          _ios: {
            width: 24,
            height: 10
          },
          _android: {
            width: 24,
            height: 10
          }
        },
        reservationAvailableTimeSlotsBox: {
          borderWidth: 1,
          _ios: {
            py: 3
          },
          _android: {
            py: 3
          },
          _web: {
            py: 4,
            px: 3
          },
          w: "100%",
          mt: 4,
          borderRadius: 0,
          bg: "#F6F3EF"
        },
        reservationTabsBtn: function reservationTabsBtn(_ref52) {
          var isActive = _ref52.isActive;
          return {
            minW: {
              base: "167px",
              md: "191px"
            },
            px: 1,
            h: {
              base: "38px",
              md: "42px"
            },
            bg: isActive ? "#FFFFFF" : "#DED4C6"
          };
        },

        /*RESERVATION*/
        rd_spl_hours_icon: {
          width: 11,
          height: 11,
          top: 0,
          right: 0,
          position: "absolute"
        },
        rd_spl_hours_legend: {
          width: 11,
          height: 11,
          mr: 1
        },
        indicatorBanner: {
          fontFamily: "Lato-Bold"
        },
        jwcHowItWorksBox: {
          borderBottomWidth: 1,
          borderBottomColor: {
            base: "#A2402A",
            lg: "white"
          }
        },
        onboardingScreenTextContainer: {
          top: "71%"
        },
        checkinSuccessNote: {
          bg: "#A9AD00",
          px: 9,
          py: 6,
          borderRadius: 12,
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        },
        locationDropdownRadius: 0,
        emptyCartModalRadius: 0,
        appMessagesSuccessDialogBorderRadius: 0,
        sectionHeaderBottomSpace: function sectionHeaderBottomSpace(_ref53) {
          var hasSub = _ref53.hasSub;
          return {
            mb: {
              base: hasSub && -1,
              md: hasSub && -4
            }
          };
        },
        configOptionBox: {
          borderRadius: 0
        },
        configOptionBoxWithMAPPWidth: {
          borderRadius: 12,
          _ios: {
            minWidth: 72
          },
          _android: {
            minWidth: 72
          }
        },
        OrderInfoBannerCartIconBox: {
          pb: 1
        },
        sliderItemBox: {
          borderRadius: 0
        },
        brandLogoMobileDimensions: function brandLogoMobileDimensions() {
          return {
            _ios: {
              height: 12,
              width: 40
            },
            _android: {
              height: 12,
              width: 40
            },
            _web: {
              height: "50px",
              width: "166px"
            }
          };
        },
        searchItemCardContainer: function searchItemCardContainer() {
          return {
            width: "100%",
            pr: 4,
            borderBottomWidth: 1,
            _web: {
              borderColor: "#f6f3ef",
              bg: "#f6f3ef"
            },
            borderColor: "#f6f3ef",
            bg: "#f6f3ef",
            py: 4
          };
        },
        searchModalMenuCategoryListBox: function searchModalMenuCategoryListBox(_ref54) {
          var isMobile = _ref54.isMobile;
          return {
            borderRadius: 0
          };
        },
        menuDetailDesciption: function menuDetailDesciption() {
          return {
            fontFamily: "Lato-Light",
            color: "#2A2C25",
            _web: {
              fontSize: {
                base: "14px",
                md: "16px"
              },
              width: {
                xl: 1266,
                lg: 945,
                md: 622,
                sm: "100%"
              }
            },
            fontSize: {
              base: 3,
              md: 4
            }
          };
        },
        menuCardBodyPrice: {
          bottom: 0
        },
        menuItemDesciption: function menuItemDesciption() {
          return {
            color: "#303030",
            fontWeight: 400,
            fontSize: 14,
            fontFamily: "Lato-Regular",
            textDecoration: "none"
          };
        },
        temperatureSlider: function temperatureSlider() {
          return {
            bg: "#F6F4E0",
            _web: {
              height: {
                base: "393px",
                md: "413px"
              },
              pb: 10
            },
            height: 400,
            pb: 10
          };
        },
        categoryActiveBorder: {
          borderBottomWidth: 3
        },
        tempDescriptionBox: function tempDescriptionBox(_ref55) {
          var isChild = _ref55.isChild;
          return {
            px: {
              base: 3,
              md: isChild ? 3 : 5
            },
            py: 5,
            borderLeftRadius: 0,
            borderRightRadius: 0,
            bg: "white",
            shadow: 11,
            _web: {
              width: {
                base: "177px",
                md: isChild ? "177px" : "325px"
              }
            }
          };
        },
        selectLocationDropDownBox: {
          ml: {
            base: 0,
            md: 8
          },
          mt: {
            base: 3,
            md: 0
          },
          alignItems: "center",
          justifyContent: "center",
          borderWidth: 1,
          borderRadius: 0,
          _web: {
            width: {
              base: "100%",
              md: "335px"
            }
          },
          borderColor: {
            base: "allLocationsSelectBorderColorMobile",
            md: "allLocationsSelectBorderColorDesktop"
          }
        },
        locationCard: function locationCard(_ref56) {
          var isFromLocationSearchPage = _ref56.isFromLocationSearchPage;
          return {
            borderBottomWidth: 1,
            borderWidth: {
              base: 0,
              md: 1
            },
            borderColor: isFromLocationSearchPage ? "allLocationsPageItemBoxBorderColor" : "allLocationsItemBoxBorderColor",
            borderRadius: 0,
            p: {
              base: 0,
              md: 1
            },
            mt: {
              base: 0,
              md: 4
            },
            mr: {
              base: 0,
              md: isFromLocationSearchPage ? "2%" : 8
            },
            _web: {
              minWidth: {
                base: "100%",
                md: "300px"
              }
            },
            width: isFromLocationSearchPage ? "48%" : "40%",
            bg: isFromLocationSearchPage ? "locationsSearchPageLocationListItemBgColor" : "locationCardBg"
          };
        },
        listCard: {
          borderRadius: 0,
          position: "relative",
          pt: {
            base: 3
          },
          pb: {
            base: "14px"
          },
          px: {
            base: 3
          },
          p: {
            lg: 6
          }
        },
        pdfMenuButtonContainer: {
          _web: {
            my: 3
          }
        },
        headerCaretIconMobile: function headerCaretIconMobile() {
          return {
            mb: 0
          };
        },
        //Restaurant Details start
        restaurantDetails_Index_Map_Box: {
          flex: 1
        },
        restaurantDetails_Index_RestInfo_Box: {
          backgroundColor: "#FFFFFF",
          flex: 1,
          borderBottomColor: "#FFFFFF",
          borderBottomWidth: "1px"
        },
        restaurantDetails_Index_RestInfo_InnerBox: {
          px: 8
        },
        restaurantDetails_Index_CurrentStatus_Box: function restaurantDetails_Index_CurrentStatus_Box(_ref57) {
          var hideWaitlistSection = _ref57.hideWaitlistSection;
          return {
            px: 8,
            mb: hideWaitlistSection ? 0 : 10
          };
        },
        restaurantDetails_Index_WaitList_Box: {
          position: "relative",
          h: "auto"
        },
        restaurantDetails_Index_Divider_Box: {
          px: 6
        },
        restaurantDetails_Index_Amenities_Box: {
          pt: 4
        },
        restaurantDetails_Index_RestTime_Box: {
          flex: {
            lg: 5,
            xl: 1
          }
        },
        restaurantDetails_Index_RestTime_Mob_Box: {
          position: "relative",
          h: "auto"
        },
        restaurantDetails_Index_ActionButtons_Box: {
          flex: {
            lg: 3,
            xl: 1
          },
          pr: 2
        },
        restaurantDetails_Index_Mob_OrderButton_Box: function restaurantDetails_Index_Mob_OrderButton_Box(_ref58) {
          var isSticky = _ref58.isSticky;
          return {
            py: 4,
            px: isSticky ? 4 : 0,
            bg: "#FFFFFF"
          };
        },
        restaurantDetails_Index_Mob_RestAbout_Box: {
          h: "auto"
        },
        restaurantDetails_ActionButtons_ViewMenu_Box: function restaurantDetails_ActionButtons_ViewMenu_Box(_ref59) {
          var isMobile = _ref59.isMobile,
              singleActionButton = _ref59.singleActionButton;
          return {
            px: 4,
            _web: {
              display: "grid"
            },
            flexDirection: "row",
            flexWrap: "wrap",
            justifyContent: "space-between",
            style: {
              "grid-template-columns": "1fr",
              "column-gap": "10px"
            }
          };
        },
        restaurantDetails_ActionButtons_ViewMenu_InnerBox: {
          _web: {
            mb: {
              base: 3,
              lg: 4
            }
          }
        },
        restaurantDetails_Amenities_IconBox: {
          alignItems: "center",
          flexWrap: "wrap",
          flexDirection: "row"
        },
        restaurantDetails_Amenities_Box: {
          px: {
            base: 4,
            lg: 6
          },
          _ios: {
            bg: "#FFFFFF"
          },
          _android: {
            bg: "#FFFFFF"
          }
        },
        restaurantDetails_CurrentStatus_Icon_Box: {
          mr: 4
        },
        restaurantDetails_CurrentStatus_Mob_Divider_Box: {
          mt: 4,
          alignItems: "center"
        },
        restaurantDetails_HolidayMsg_Box: {
          px: {
            base: 2,
            lg: 3
          },
          py: 3,
          bg: {
            base: "#86714d",
            lg: "#86714d"
          }
        },
        restaurantDetails_Map_Box: {
          height: "140px",
          position: "relative"
        },
        restaurantDetails_OrderButtonSection_Box: function restaurantDetails_OrderButtonSection_Box(_ref60) {
          var isInStack = _ref60.isInStack;
          return {
            px: isInStack ? 0 : 4,
            _web: {
              mb: isInStack ? {
                base: 3,
                lg: 4
              } : 0
            },
            alignItems: "center"
          };
        },
        restaurantDetails_RestAboutSection_Box: {
          px: "6",
          py: {
            base: "6",
            lg: "0"
          }
        },
        restaurantDetails_RestInfo_Outer_ImageBox: {
          position: "relative",
          bg: {
            base: "restaurantDetailsRestInfoBoxBackgroundColor",
            lg: "white"
          }
        },
        restaurantDetails_RestInfo_Mob_StarIcon_Box: {
          m: "auto"
        },
        restaurantDetails_RestInfo_Box: {
          width: "100%",
          alignItems: {
            base: "center",
            lg: "flex-start"
          },
          position: "relative"
        },
        restaurantDetails_RestInfo__Box: {
          width: "100%",
          alignItems: {
            base: "center",
            lg: "flex-start"
          },
          position: "relative"
        },
        restaurantDetails_RestInfo_PhoneNum_Box: {
          mb: {
            base: 4,
            lg: 0
          },
          flexDirection: "row",
          justifyContent: {
            base: "space-evenly",
            lg: "flex-start"
          },
          alignItems: {
            base: "center"
          }
        },
        restaurantDetails_RestInfo_PhoneNum_InnerBox: {
          alignItems: "center",
          flexDirection: "row"
        },
        restaurantDetails_RestTime_Box: {
          px: "4",
          py: {
            base: "4",
            lg: "0"
          }
        },
        restaurantDetails_RestTime_RestClosed_Box: {
          my: 5
        },
        restaurantDetails_RestInfo_ImageBox: {
          backgroundColor: "restaurantImageBorderColor",
          borderColor: "restaurantImageBorderColor",
          borderWidth: 6,
          position: "absolute",
          zIndex: 1,
          alignSelf: "center",
          shadow: 11,
          _web: {
            alignSelf: {
              base: "center",
              lg: "left"
            }
          },
          top: {
            base: "-50px",
            lg: "-150px"
          },
          overflow: "hidden"
        },
        restaurantDetails_RestInfo_ImageLgBox: {
          backgroundColor: "restaurantImageBorderColor",
          borderColor: "restaurantImageBorderColor",
          borderWidth: 6,
          shadow: 11,
          mr: "8"
        },
        restaurantDetails_CurrentStatusAndWaitlist_Box: {
          py: "5",
          px: {
            base: "4",
            lg: "8"
          },
          backgroundColor: {
            base: "white",
            lg: "#F4F4F4"
          },
          borderRadius: "12"
        },
        restaurantDetails_CurrentStatus_Box: {
          pt: {
            base: "5",
            lg: "0"
          },
          px: {
            base: "4",
            lg: "0"
          },
          backgroundColor: "#FFFFFF"
        },
        restaurantDetails_Waitlist_Box: {
          pt: {
            base: 7,
            lg: 9
          },
          pb: {
            base: 8,
            lg: 10
          },
          bg: {
            base: "#FFFFFF",
            lg: "#FFFFFF"
          }
        },
        restaurantDetails_WaitlistAlready_Box: {
          pt: {
            base: 7,
            lg: 9
          },
          mb: {
            base: 8,
            lg: 10
          },
          bg: {
            base: "#FFFFFF",
            lg: "#FFFFFF"
          }
        },
        restaurantDetails_RestTimings_Divider: {
          marginBottom: 4
        },
        restDetails_TextMapper_Container: {
          py: 16,
          px: {
            base: "60",
            lg: "116"
          },
          bg: "#ffffff"
        },
        //Restaurant Details end
        //Location search
        tabLocationsTopWidth: 0,
        // location search page
        locationSearchActiveTab: function locationSearchActiveTab(_ref61) {
          var isActive = _ref61.isActive;
          return {
            height: "4px",
            bg: isActive ? "locationSearchActiveTab" : "transparent",
            w: "100%"
          };
        },
        borderRadiusValue: function borderRadiusValue(_ref62) {
          var radiusValue = _ref62.radiusValue,
              topRadiusValue = _ref62.topRadiusValue,
              bottomRadiusValue = _ref62.bottomRadiusValue;
          return {
            borderRadius: 0,
            borderTopRadius: 0,
            borderBottomRadius: 0
          };
        },
        homeScreenAlertHeadingWrapper: function homeScreenAlertHeadingWrapper(_ref63) {
          var isSmallScreen = _ref63.isSmallScreen;
          return {
            height: isSmallScreen ? 6 : 7,
            mr: 1
          };
        },
        menu_detail_divider: {
          mb: 5
        },
        boxBorderRadius: {
          _web: {
            borderRadius: 8
          },
          borderRadius: 12
        },
        desktopBreadcrumbCaret: function desktopBreadcrumbCaret() {
          return {
            height: 2.5,
            width: 1,
            ml: 2.5,
            mr: 3,
            mb: 1,
            alignItems: "center"
          };
        },
        countLabelContainer: function countLabelContainer(_ref64) {
          var isIOS = _ref64.isIOS;
          return {
            _text: {
              color: "white",
              pt: isIOS ? 1 : 0,
              fontSize: 12
            }
          };
        },
        categoryBox: {
          mb: {
            md: 8,
            base: 3
          }
        },
        mobileGiftCardBrandLogo: {
          height: 47,
          width: 59,
          _web: {
            height: 65,
            width: 58
          }
        },

        /** Box: Private Dining Start */
        privateDiningDropdownRadius: 0,
        privateDiningLocationDropdownSelectBox: {
          borderWidth: 1,
          borderRadius: 0,
          width: {
            base: "100%",
            md: "400px"
          },
          borderColor: "#DEDEDE"
        },
        privateDiningLocationDropdownBox: {
          bg: "#86714D",
          h: {
            base: "72px",
            md: "82px"
          },
          justifyContent: "center",
          px: {
            base: 6,
            md: 16
          }
        },
        pd_makeRequest_container: {
          width: {
            base: "100%",
            md: "794"
          },
          m: {
            md: "auto"
          },
          my: {
            md: 6
          },
          minH: {
            md: "543"
          },
          bg: "#F0ECE6",
          borderBottomWidth: {
            base: 1,
            md: 0
          },
          borderBottomColor: "#0000001a"
        },
        pd_requestFlow_form_tabActiveBorder: function pd_requestFlow_form_tabActiveBorder(_ref65) {
          var isActive = _ref65.isActive;
          return {
            mt: {
              base: 3,
              md: 4
            },
            height: 1,
            bgColor: isActive ? "requestFormTabActiveItem" : "transparent",
            w: "100%",
            borderTopRadius: 0
          };
        },
        pd_request_eventDetails_locationDetails: {
          py: {
            base: 3,
            md: 4
          },
          px: {
            base: 3,
            md: 4
          },
          bgColor: "#ffffff"
        },
        pd_actionSheetBorderRadius: 0,
        pd_phoneNumberTypeBorderRadius: 0,
        pd_reviewDetails_container: function pd_reviewDetails_container(_ref66) {
          var fromConfirmation = _ref66.fromConfirmation;
          return {
            borderRadius: 0,
            p: 4,
            bg: fromConfirmation ? "#F0ECE6" : "#FFFFFF"
          };
        },
        pd_confirmationText_Container: {
          rounded: 0,
          // border: 1,
          // borderColor: "#DCDCDC",
          py: 5,
          px: {
            base: 4,
            md: "56px"
          },
          bg: {
            base: "#FFFFFF",
            md: "#F0ECE6"
          },
          alignItems: "center"
        },
        pd_reviewDetails_messageRegardingRequest: {
          display: "none"
        },
        pd_request_contactDetails_specialReq: {
          px: 4,
          pb: 4,
          bg: "#FFFFFF"
        },
        pd_requestFlow_form_tabBG: function pd_requestFlow_form_tabBG(_ref67) {
          var isActive = _ref67.isActive;
          return {
            bgColor: isActive ? "requestFormTabActiveItem" : "requestFormTabDisableItem"
          };
        },
        pd_landing_eventGuideContainer: {
          width: "100%",
          px: {
            base: 5,
            lg: "115px"
          },
          mb: {
            base: 10,
            lg: "80px"
          },
          mt: {
            base: 4,
            lg: "0px"
          }
        },
        pd_landing_menuDropdown: function pd_landing_menuDropdown(_ref68) {
          var isExpanded = _ref68.isExpanded;
          return {
            p: 0,
            bgColor: isExpanded ? "#FFFFFF" : "#86714D",
            _hover: {
              bg: isExpanded ? "#FFFFFF" : "#86714D"
            },
            _expanded: {
              bg: isExpanded ? "#FFFFFF" : "#86714D"
            }
          };
        },

        /** Box: Private Dining End */
        smartRecommendationModalHeadingContainer: {
          _ios: {
            flex: null
          },
          _android: {
            flex: null
          }
        },
        eClub_Building_Box: {
          w: "100%",
          h: 600,
          bg: "#F0ECE6"
        },
        eClubSignUpBox: {
          borderRadius: 0,
          bg: "white",
          mt: 10,
          px: {
            base: 4,
            md: 8
          },
          py: 8,
          w: {
            base: "100%",
            md: "60%"
          },
          alignSelf: "center"
        },
        eClubNewsBox: {
          borderRadius: 0,
          bg: "white",
          w: {
            base: "100%",
            md: "60%"
          },
          mt: 10,
          py: {
            base: 4,
            md: 10
          },
          px: 4,
          alignItems: "center",
          shadow: 10
        },
        eClubConfirmationBox: {
          borderRadius: 0,
          bg: "white",
          px: 10,
          py: 10,
          w: "50%",
          alignItems: "center"
        },
        eClubUnsubscribeContainer: {
          bg: "white",
          rounded: "md",
          p: 5,
          my: 10,
          shadow: 2,
          mx: {
            base: 10,
            md: "auto"
          }
        },
        // My Account
        myAccountDesktop_container: {
          width: {
            md: "100%",
            lg: 980,
            xl: 1200
          },
          h: 700,
          overflow: "clip",
          rounded: 0,
          bg: "white",
          shadow: 2,
          mx: "auto",
          my: 5
        },
        myAccountDesktop_headerBox: {
          py: 6,
          px: 10,
          borderBottomWidth: 1,
          borderBottomColor: "#EDEDED"
        },
        myAccountDesktop_container_leftSection: {
          borderRightWidth: 1,
          minW: 272,
          borderRightColor: "#EDEDED",
          overflow: "auto",
          mb: 20
        },
        myAccount_editProfile_infoCard: {
          px: {
            base: 5,
            md: 8
          },
          pt: 5,
          pb: {
            base: 0,
            md: 5
          },
          mb: {
            base: 8,
            md: 2
          },
          bg: "myAccountScreenBackroundColor",
          mt: 1
        },
        myAccount_orderHistoryItem_header: {
          backgroundColor: "mobileOrderHistoryItemCardHeaderBackgroundColor",
          _ios: {
            flex: 1
          },
          _android: {
            flex: 1
          },
          padding: 3,
          paddingRight: 4,
          borderTopRadius: 0,
          overflow: "hidden",
          _web: {
            shadow: 2
          }
        },
        myAccount_paymentOptions_container: {
          paddingBottom: 5,
          backgroundColor: "white",
          _android: {
            flex: 1
          },
          _ios: {
            flex: 1
          },
          _web: {
            height: "100%"
          }
        },
        myAccount_check_icon_container: {
          justifyContent: "center",
          alignItems: "center",
          rounded: "full",
          bg: "white",
          border: 2,
          borderColor: "#86714D",
          w: "90px",
          h: "90px",
          mb: 12,
          mx: "auto"
        },
        myAccount_edit_field_sheet_title_wrapper: {
          bg: "white",
          rounded: 12,
          flexDirection: "row",
          justifyContent: "center",
          width: "100%"
        },
        myAccount_profile_icon_container: {
          size: 75,
          overflow: "hidden",
          borderRadius: 100,
          borderWidth: 6,
          borderColor: "ProfilePictureCircleBorderColor",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "displayImageFallbackBackground"
        },
        myAccount_paymentOptions_cardDetails_container: {
          py: 3,
          backgroundColor: "#F1ECE6",
          borderBottomWidth: 1,
          borderColor: "paymentOptionsBorderColor",
          _web: {
            marginX: {
              base: 0,
              md: 5
            }
          }
        },
        myAccount_paymentOptions_giftCards_AddCardButton: {
          py: 0.5,
          px: 3,
          _web: {
            py: 1
          }
        },
        myAccount_paymentOptions_gc_isRefershing: {
          position: "absolute",
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          justifyContent: "center",
          alignItems: "center",
          bg: "gcBalanceRefreshBackdropColor"
        },
        myAccount_paymentOptions_gc_bottomSheet_title: {
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          pb: 5,
          pt: 0,
          px: 5,
          _web: {
            width: "100%"
          }
        },
        myAccount_paymentOptions_gc_bottomSheet_content: {
          width: "100%",
          px: 4,
          pt: 7,
          _web: {
            px: {
              base: 4,
              md: 0
            }
          },
          bg: {
            base: "#FFFFFF",
            md: "#F1ECE6"
          }
        },
        myAccount_paymentOptions_gc_bottomSheet_gcContainer: {
          mb: 5,
          _web: {
            width: {
              base: "100%",
              md: "70%"
            },
            alignSelf: "center",
            px: {
              base: 0,
              md: 4
            }
          }
        },
        myAccount_order_history_order_details_modal_header: {
          position: "relative",
          alignItems: "center",
          justifyContent: "center",
          pb: 4,
          w: "100%",
          bg: "#F1ECE6"
        },
        myAccount_order_history_title_wrapper: {
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          px: 5,
          pt: 5,
          mb: 2
        },
        myAccount_add_edit_credit_card_wrapper: {
          paddingX: 4,
          _ios: {
            flex: 1
          },
          _android: {
            flex: 1
          },
          _web: {
            paddingX: {
              base: 4,
              md: 9
            }
          },
          justifyContent: "space-between"
        },
        myAccount_add_gift_card_actionsheet_wrapper: {
          alignItems: "center",
          paddingLeft: 0,
          paddingTop: 0,
          bg: "#F1ECE6"
        },
        myAccount_add_gift_card_action_sheet_save_for_future_use_wrappper: {
          width: "100%",
          paddingX: 5,
          alignItems: "flex-start",
          justifyContent: "center"
        },
        myAccount_paymentOptions_gcl_isRefershing: {
          position: "absolute",
          width: "100%",
          height: "100%",
          justifyContent: "center",
          alignItems: "center",
          bg: "gcBalanceRefreshBackdropColor"
        },
        myAccount_paymentOptions_gc_bs_delete_container: {
          bg: "white",
          py: 3.5,
          alignItems: "flex-end",
          px: 6
        },
        myAccount_paymentOptions_addGC_addSheet_addContainer: {
          width: "100%",
          _android: {
            paddingY: 1
          },
          _ios: {
            marginTop: 6
          },
          paddingX: 5,
          alignItems: "center",
          bg: {
            base: "#F1ECE6",
            md: "white"
          },
          _web: {
            py: {
              base: 5,
              md: 3.5
            },
            paddingX: {
              base: 5,
              md: 12
            }
          },
          flexDirection: "row"
        },
        myAccount_paymentOptions_showCC_BS_titleBox: {
          flexDirection: "row",
          justifyContent: "space-between",
          alignItems: "center",
          pb: 5,
          pt: 0,
          px: 5,
          bg: "#FFFFFF"
        },
        myAccount_security_question_wrapper: {
          px: 5
        },
        myAccount_updatedQuestion_defaultItemContainer: {
          flexDirection: "row",
          justifyContent: "space-between",
          borderBottomColor: "securityQuestionMenuColor",
          py: 2,
          mb: 12,
          borderBottomWidth: 1
        },
        myAccount_userInfoCard_container: {
          px: 5,
          py: 5,
          flexDirection: "row",
          alignItems: "flex-start"
        },
        myAccount_editField_saveErrorMessage: {
          borderRadius: 4,
          mt: 3,
          py: 3,
          px: 5,
          mx: 5,
          border: 1,
          bg: "red.200",
          borderColor: "red.300"
        },
        myAccount_fallBackPictureBackground_Box: {
          height: "100%",
          width: "100%",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "displayImageFallbackBackground",
          _web: {
            backgroundColor: "#DFD4C6"
          }
        },
        myAccount_editFields_actionSheet_webBox: {
          pt: 2,
          pb: 7,
          bg: "#F1ECE6"
        },
        myAccount_orderHistoryDetails_actionSheet_webBox: {
          pb: 7
        },
        addCreditCard_securityBanner_ContainerBox: {
          paddingTop: 4,
          paddingX: 5,
          paddingBottom: 4,
          justifyContent: "space-between",
          alignItems: "center",
          flexDirection: "row",
          backgroundColor: "#F1ECE6",
          borderTopWidth: 1,
          borderBottomWidth: 1,
          borderColor: "#EAEAEA",
          accessible: false,
          _web: {
            marginBottom: {
              base: 3,
              md: 6
            },
            paddingX: {
              base: 5,
              md: 9
            },
            paddingY: 3
          }
        },
        giftCardContainer_Box: function giftCardContainer_Box(_ref69) {
          var radiusValue = _ref69.radiusValue;
          return {
            _ios: {
              bg: {
                linearGradient: {
                  colors: ["mobileGiftCardGradientFirst", "mobileGiftCardGradientSecond"],
                  start: [0, 0],
                  end: [1, 0]
                }
              }
            },
            _android: {
              bg: {
                linearGradient: {
                  colors: ["mobileGiftCardGradientFirst", "mobileGiftCardGradientSecond"],
                  start: [0, 0],
                  end: [1, 0]
                }
              }
            },
            _web: {
              style: {
                background: "linear-gradient(90deg, rgba(166,148,116,1) 0%, rgba(134,113,77,1) 100%)"
              }
            },
            borderRadius: 0,
            borderTopRadius: 0,
            borderBottomRadius: 0,
            pt: 1
          };
        },
        editProfileScreens_Box: {
          _android: {
            flex: 1
          },
          _ios: {
            flex: 1
          },
          backgroundColor: "editProfileScreensBackgroundColor",
          _web: {
            height: "100%",
            overflowY: "auto",
            backgroundColor: "#F1ECE6"
          }
        },
        myAccount_orderHistoryItem_orderDetails_Box: {
          _ios: {
            flex: 1
          },
          _android: {
            flex: 1
          },
          paddingLeft: 3,
          paddingRight: 4,
          paddingTop: 5,
          paddingBottom: 7,
          justifyContent: "center",
          backgroundColor: "mobileOrderHistoryItemCardHeaderBackgroundColor"
        },
        orderHistoryEmptyScreen_Box: {
          flex: 1,
          justifyContent: "center"
        },
        orderHistory_screenContainer_box: {
          _android: {
            flex: 1
          },
          _ios: {
            flex: 1
          },
          _web: {
            height: "100%"
          },
          bg: {
            base: "mobileOrderHistoryBackgroundColor",
            md: "white"
          },
          px: {
            base: 0,
            md: 6
          }
        },
        giftCardLarge_brandIcon_Box: {
          mb: 4,
          height: 59,
          width: 123,
          _web: {
            height: {
              base: "90px",
              md: "99px"
            },
            width: {
              base: "140px",
              md: "162px"
            }
          }
        },
        addGiftCard_actionSheetTitle: {
          flexDirection: "row",
          justifyContent: "center",
          width: "100%"
        },
        myAccount_editDetails_editMail: {
          mx: 4,
          px: {
            base: 0,
            md: 5
          },
          pt: 4,
          _android: {
            bgColor: "editProfileScreensBackgroundColor"
          },
          _ios: {
            bgColor: "editProfileScreensBackgroundColor"
          }
        },
        // My Account ends,
        paymentOptions_giftCardLarge_deleteCTA: {},
        myAccount_editDetails_changeDOB: {
          _ios: {
            flex: 1
          },
          _android: {
            flex: 1
          },
          backgroundColor: "editProfileScreensBackgroundColor",
          _web: {
            pt: {
              base: 5,
              md: 0
            },
            backgroundColor: "transparent",
            height: "100%"
          }
        },
        eClubBGGradient_box: {// empty
        }
      }
    },
    View: {
      variants: {
        confirmationCardLayout: function confirmationCardLayout() {
          return {
            borderRadius: "none"
          };
        },
        borderRadiusValue: function borderRadiusValue(_ref70) {
          var radiusValue = _ref70.radiusValue,
              topRadiusValue = _ref70.topRadiusValue,
              bottomRadiusValue = _ref70.bottomRadiusValue;
          return {
            borderRadius: 0,
            borderTopRadius: 0,
            borderBottomRadius: 0
          };
        },
        myAccount_orderHistoryCard_container: {
          marginX: 2,
          marginTop: 2,
          marginBottom: 3,
          _ios: {
            flex: 1
          },
          _android: {
            flex: 1
          },
          borderRadius: 0,
          backgroundColor: "#F1ECE6",
          shadow: 4
        },
        myAccount_paymentOptions_giftCards_iconWarpper: {
          paddingY: 2,
          marginRight: 5
        },
        myAccountConfirmationViewContainer: function myAccountConfirmationViewContainer(_ref71) {
          var isMobile = _ref71.isMobile;
          return {
            bg: "#FFFFFF",
            rounded: 0,
            shadow: isMobile ? null : 2,
            my: 8,
            paddingY: 5
          };
        },
        myAccountConfirmationHeadContainer: {
          bg: "#F8F7F6",
          rounded: 0,
          padding: 7,
          mt: {
            md: 5
          },
          mx: {
            base: "auto",
            md: 67
          },
          mb: {
            base: 4,
            md: 2
          }
        }
      }
    },
    Switch: {
      baseStyle: {
        thumbColor: "#FFFFFF",
        onTrackColor: "primary.100"
      }
    },
    Select: {
      variants: {
        borderRadiusValue: function borderRadiusValue(_ref72) {
          var radiusValue = _ref72.radiusValue,
              topRadiusValue = _ref72.topRadiusValue,
              bottomRadiusValue = _ref72.bottomRadiusValue;
          return {
            borderRadius: radiusValue,
            borderTopRadius: topRadiusValue,
            borderBottomRadius: bottomRadiusValue
          };
        },
        paymentOptions_addEditCC_addressDetails: {
          w: "100%",
          borderRadius: 0
        }
      }
    },
    Spinner: {
      variants: {
        paymentOptions_addGiftCard_checkBalanceSpinner: {
          mt: 3.5,
          mb: 4,
          _web: {
            mt: {
              base: 5,
              md: 4
            },
            mb: {
              base: 5,
              md: 4
            }
          },
          color: "#BBBBBB",
          size: "sm"
        },
        paymentOptions_addGiftCard_addCardSpinner: {
          my: 4,
          _web: {
            mt: {
              base: 5,
              md: 4
            },
            mb: {
              base: 5,
              md: 4
            }
          },
          color: "#FFFFFF",
          size: "sm"
        }
      }
    },
    Alert: {
      variants: {
        borderRadiusValue: function borderRadiusValue(_ref73) {
          var radiusValue = _ref73.radiusValue,
              topRadiusValue = _ref73.topRadiusValue,
              bottomRadiusValue = _ref73.bottomRadiusValue;
          return {
            borderRadius: 0,
            borderTopRadius: 0,
            borderBottomRadius: 0
          };
        }
      }
    },
    Menu: {
      variants: {
        borderRadiusValue: function borderRadiusValue(_ref74) {
          var radiusValue = _ref74.radiusValue,
              topRadiusValue = _ref74.topRadiusValue,
              bottomRadiusValue = _ref74.bottomRadiusValue;
          return {
            borderRadius: 0,
            borderTopRadius: 0,
            borderBottomRadius: 0
          };
        }
      }
    },
    ActionsheetContent: {
      variants: {
        topRounded: {
          roundedTop: 0
        },
        myAccount_editFields_actionSheetContent: {
          padding: 0,
          bg: "white",
          borderRadius: 0
        },
        myAccount_orderHistoryDetails_actionSheetContent: {
          padding: 0,
          bg: "#F1ECE6"
        },
        payments_addGiftCard_actionSheetContent: {
          height: "max-content",
          padding: 0
        },
        myAccount_paymentOptions_giftCardDetails_actionSheetContent: {
          bg: "#FFFFFF",
          p: 0
        }
      }
    },
    PopoverContent: {
      variants: {
        /** PopoverContent: Private Dining Start */
        pd_request_eventDetails_purposDropdown: {
          top: {
            md: 20
          },
          bg: "#FFFFFF",
          maxH: "235px",
          overflowY: "auto",
          borderRadius: 0,
          borderColor: "transparent",
          shadow: 15
        },
        pd_request_eventDetails_timeDropdown: {
          bg: "#FFFFFF",
          maxH: "235px",
          overflowY: "auto",
          borderRadius: 0,
          shadow: 10,
          borderColor: "transparent"
        },
        pd_request_eventDetails_partySizeDropdown: {
          bg: "#F6F4E0",
          maxH: "235px",
          overflowY: "auto",
          borderRadius: 0,
          borderColor: "transparent",
          shadow: 15
        },
        pd_request_eventDetails_menuPrefDropdown: {
          top: {
            md: 20
          },
          bg: "#F6F4E0",
          maxH: "235px",
          overflowY: "auto",
          borderRadius: 0,
          borderColor: "transparent",
          shadow: 15
        },
        pd_request_contactDetails_dopTooltip: {
          backgroundColor: "#812F36",
          borderRadius: 0
        },
        pd_request_contactDetails_phoneType: {
          borderRadius: 0,
          py: 6,
          px: 4,
          bg: "#FFFFFF",
          top: 2,
          shadow: 13,
          border: "none"
        },

        /** PopoverContent: Private Dining Start */
        popoverRadius: function popoverRadius(_ref75) {
          var radiusValue = _ref75.radiusValue;
          return {
            borderRadius: 0
          };
        }
      }
    }
  },
  fontConfig: {
    Lato: {
      100: {
        normal: "Lato-Light",
        italic: Platform.OS === "web" ? "Lato-Light" : "Lato-Italic"
      },
      200: {
        normal: "Lato-Light",
        italic: Platform.OS === "web" ? "Lato-Light" : "Lato-Italic"
      },
      300: {
        normal: Platform.OS === "web" ? "Lato-Regular" : "Lato-Light",
        italic: Platform.OS === "web" ? "Lato-Regular" : "Lato-Italic"
      },
      400: {
        normal: "Lato-Regular",
        italic: Platform.OS === "web" ? "Lato-Regular" : "Lato-Italic"
      },
      500: {
        normal: Platform.OS === "web" ? "Lato-Bold" : "Lato-Regular",
        italic: Platform.OS === "web" ? "Lato-Bold" : "Lato-Italic"
      },
      600: {
        normal: "Lato-Bold",
        italic: Platform.OS === "web" ? "Lato-Bold" : "Lato-Italic"
      },
      700: {
        normal: "Lato-Bold",
        italic: Platform.OS === "web" ? "Lato-Bold" : "Lato-Italic"
      },
      800: {
        normal: "Lato-Bold",
        italic: Platform.OS === "web" ? "Lato-Bold" : "Lato-Italic"
      },
      900: {
        normal: "Lato-Bold",
        italic: Platform.OS === "web" ? "Lato-Bold" : "Lato-Italic"
      },
      1000: {
        normal: "Lato-ExtraBold"
      }
    },
    SortsMillGoudy: {
      100: {
        normal: "SortsMillGoudy-Regular",
        italic: "SortsMillGoudy-Regular"
      },
      200: {
        normal: "SortsMillGoudy-Regular",
        italic: "SortsMillGoudy-Regular"
      },
      300: {
        normal: "SortsMillGoudy-Regular",
        italic: "SortsMillGoudy-Regular"
      },
      400: {
        normal: "SortsMillGoudy-Regular",
        italic: "SortsMillGoudy-Regular"
      },
      500: {
        normal: "SortsMillGoudy-Regular",
        italic: "SortsMillGoudy-Regular"
      },
      600: {
        normal: "SortsMillGoudy-Regular",
        italic: "SortsMillGoudy-Regular"
      },
      700: {
        normal: "SortsMillGoudy-Regular",
        italic: "SortsMillGoudy-Regular"
      },
      800: {
        normal: "SortsMillGoudy-Regular",
        italic: "SortsMillGoudy-Regular"
      },
      900: {
        normal: "SortsMillGoudy-Regular",
        italic: "SortsMillGoudy-Regular"
      }
    }
  },
  fonts: {
    heading: "Lato",
    body: "Lato",
    headingSecondary: "Lato",
    youMightLikeText: "Lato-Bold"
  },
  config: {
    // Changing initialColorMode to 'dark'
    initialColorMode: "light"
  }
}; // extend the theme

export var theme = extendTheme(_objectSpread(_objectSpread({}, baseTheme), config));